var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import * as require$$0 from "react";
import require$$0__default, { useCallback, memo, forwardRef, Suspense, createContext, useState, useRef, useEffect, useContext, useImperativeHandle, useMemo } from "react";
import { Flex, Select, Form, Button, Image, Modal, Upload, Input, message, DatePicker, Spin, Checkbox, Alert, Progress, Empty, Tag as Tag$1, Collapse, Switch, Badge, Tooltip, Table, ConfigProvider, Tabs, InputNumber, Popconfirm, notification, Divider } from "antd";
import { useNavigate } from "react-router";
import { useLocation, Link, useNavigate as useNavigate$1, useParams } from "react-router-dom";
import styled from "styled-components";
import require$$11 from "relay-runtime";
import { FullscreenOutlined, FilePdfOutlined, CloseOutlined, SaveOutlined, DeleteOutlined, PlusOutlined, DatabaseOutlined, EditOutlined, LoginOutlined, CloudUploadOutlined, SearchOutlined, LeftOutlined, CloseCircleOutlined } from "@ant-design/icons";
import WebViewer from "@pdftron/webviewer";
import dayjs from "dayjs";
import { createSlice, configureStore } from "@reduxjs/toolkit";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = require$$0__default, k = Symbol.for("react.element"), l2 = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n2 = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n2.current };
  }
  reactJsxRuntime_production_min.Fragment = l2;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React = require$$0__default;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match2 = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match2 && match2[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s2 = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s2 >= 1 && c >= 0 && sampleLines[s2] !== controlLines[c]) {
              c--;
            }
            for (; s2 >= 1 && c >= 0; s2--, c--) {
              if (sampleLines[s2] !== controlLines[c]) {
                if (s2 !== 1 || c !== 1) {
                  do {
                    s2--;
                    c--;
                    if (c < 0 || sampleLines[s2] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s2].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s2 >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty2 = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty2);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      function hasValidRef(config) {
        {
          if (hasOwnProperty2.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty2.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self) ;
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          }
          for (propName in config) {
            if (hasOwnProperty2.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node2, parentType) {
        {
          if (typeof node2 !== "object") {
            return;
          }
          if (isArray(node2)) {
            for (var i = 0; i < node2.length; i++) {
              var child = node2[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node2)) {
            if (node2._store) {
              node2._store.validated = true;
            }
          } else if (node2) {
            var iteratorFn = getIteratorFn(node2);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node2.entries) {
                var iterator = iteratorFn.call(node2);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      var didWarnAboutKeySpread = {};
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          {
            if (hasOwnProperty2.call(props, "key")) {
              var componentName = getComponentNameFromType(type);
              var keys = Object.keys(props).filter(function(k) {
                return k !== "key";
              });
              var beforeExample = keys.length > 0 ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
              if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? "{" + keys.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
const paths = {
  MAIN: "/"
};
const HEIGHT_PICT_VIEW = 84;
class API {
}
__publicField(API, "STATUS_200", 200);
__publicField(API, "STATUS_302", 302);
__publicField(API, "STATUS_400", 400);
__publicField(API, "URL_GRAPHQL", "https://2d6wn7ar4zc35dmt335sktscx4.appsync-api.us-west-2.amazonaws.com/graphql");
__publicField(API, "GRAPHQL_TOKEN");
__publicField(API, "PROJECT_FILTER", "0,9d9788d6-1129-4482-9b7a-87ce4d5f1b11");
__publicField(API, "DRAWINGS_S3_URL", "https://drawings-s3.sitemax.io/prod");
const LogoStyle = styled.a`
    display: block;
    background: transparent url(${(props) => props.type === "full" ? "/logo-full.png" : "/logo-short.svg"}) no-repeat
        0 0;
    text-indent: -9999px;
    margin: 0 auto;
    width: ${(props) => props.type === "full" ? "200px" : "33px"};
    height: ${(props) => props.type === "full" ? "28px" : "33px"};
    //background-size: cover;
    background-position-y: bottom;
`;
const Logo = ({ type, margin }) => {
  const history = useNavigate();
  const location = useLocation();
  const onClick = useCallback(() => {
    history(paths.MAIN);
  }, [location, history]);
  const logo = /* @__PURE__ */ jsxRuntimeExports.jsx(LogoStyle, { href: "#", type, onClick, children: "SiteMax" });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { style: { margin }, className: "logo", align: "center", children: type === "full" ? logo : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { borderRadius: 28, padding: 5, backgroundColor: "#08172B" }, children: logo }) });
};
const node$C = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "pageInfoFragment",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startCursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPreviousPage",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "PageInfo",
  "abstractKey": null
};
node$C.hash = "ea27bf402586ed11b304569ab7c3f970";
var ReactRelayContext;
var hasRequiredReactRelayContext;
function requireReactRelayContext() {
  if (hasRequiredReactRelayContext) return ReactRelayContext;
  hasRequiredReactRelayContext = 1;
  var React = require$$0__default;
  var _require = require$$11, createRelayContext = _require.__internal.createRelayContext;
  ReactRelayContext = createRelayContext(React);
  return ReactRelayContext;
}
var interopRequireDefault = { exports: {} };
var hasRequiredInteropRequireDefault;
function requireInteropRequireDefault() {
  if (hasRequiredInteropRequireDefault) return interopRequireDefault.exports;
  hasRequiredInteropRequireDefault = 1;
  (function(module) {
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(interopRequireDefault);
  return interopRequireDefault.exports;
}
var _extends = { exports: {} };
var hasRequired_extends;
function require_extends() {
  if (hasRequired_extends) return _extends.exports;
  hasRequired_extends = 1;
  (function(module) {
    function _extends2() {
      return module.exports = _extends2 = Object.assign ? Object.assign.bind() : function(n2) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) ({}).hasOwnProperty.call(t, r) && (n2[r] = t[r]);
        }
        return n2;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends2.apply(null, arguments);
    }
    module.exports = _extends2, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(_extends);
  return _extends.exports;
}
var objectWithoutPropertiesLoose = { exports: {} };
var hasRequiredObjectWithoutPropertiesLoose;
function requireObjectWithoutPropertiesLoose() {
  if (hasRequiredObjectWithoutPropertiesLoose) return objectWithoutPropertiesLoose.exports;
  hasRequiredObjectWithoutPropertiesLoose = 1;
  (function(module) {
    function _objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n2 in r) if ({}.hasOwnProperty.call(r, n2)) {
        if (-1 !== e.indexOf(n2)) continue;
        t[n2] = r[n2];
      }
      return t;
    }
    module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(objectWithoutPropertiesLoose);
  return objectWithoutPropertiesLoose.exports;
}
var assertThisInitialized = { exports: {} };
var hasRequiredAssertThisInitialized;
function requireAssertThisInitialized() {
  if (hasRequiredAssertThisInitialized) return assertThisInitialized.exports;
  hasRequiredAssertThisInitialized = 1;
  (function(module) {
    function _assertThisInitialized(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(assertThisInitialized);
  return assertThisInitialized.exports;
}
var inheritsLoose = { exports: {} };
var setPrototypeOf = { exports: {} };
var hasRequiredSetPrototypeOf;
function requireSetPrototypeOf() {
  if (hasRequiredSetPrototypeOf) return setPrototypeOf.exports;
  hasRequiredSetPrototypeOf = 1;
  (function(module) {
    function _setPrototypeOf(t, e) {
      return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
        return t2.__proto__ = e2, t2;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
    }
    module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(setPrototypeOf);
  return setPrototypeOf.exports;
}
var hasRequiredInheritsLoose;
function requireInheritsLoose() {
  if (hasRequiredInheritsLoose) return inheritsLoose.exports;
  hasRequiredInheritsLoose = 1;
  (function(module) {
    var setPrototypeOf2 = requireSetPrototypeOf();
    function _inheritsLoose(t, o) {
      t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf2(t, o);
    }
    module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(inheritsLoose);
  return inheritsLoose.exports;
}
var defineProperty = { exports: {} };
var toPropertyKey = { exports: {} };
var _typeof = { exports: {} };
var hasRequired_typeof;
function require_typeof() {
  if (hasRequired_typeof) return _typeof.exports;
  hasRequired_typeof = 1;
  (function(module) {
    function _typeof2(o) {
      "@babel/helpers - typeof";
      return module.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof2(o);
    }
    module.exports = _typeof2, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(_typeof);
  return _typeof.exports;
}
var toPrimitive = { exports: {} };
var hasRequiredToPrimitive;
function requireToPrimitive() {
  if (hasRequiredToPrimitive) return toPrimitive.exports;
  hasRequiredToPrimitive = 1;
  (function(module) {
    var _typeof2 = require_typeof()["default"];
    function toPrimitive2(t, r) {
      if ("object" != _typeof2(t) || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof2(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    module.exports = toPrimitive2, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(toPrimitive);
  return toPrimitive.exports;
}
var hasRequiredToPropertyKey;
function requireToPropertyKey() {
  if (hasRequiredToPropertyKey) return toPropertyKey.exports;
  hasRequiredToPropertyKey = 1;
  (function(module) {
    var _typeof2 = require_typeof()["default"];
    var toPrimitive2 = requireToPrimitive();
    function toPropertyKey2(t) {
      var i = toPrimitive2(t, "string");
      return "symbol" == _typeof2(i) ? i : i + "";
    }
    module.exports = toPropertyKey2, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(toPropertyKey);
  return toPropertyKey.exports;
}
var hasRequiredDefineProperty;
function requireDefineProperty() {
  if (hasRequiredDefineProperty) return defineProperty.exports;
  hasRequiredDefineProperty = 1;
  (function(module) {
    var toPropertyKey2 = requireToPropertyKey();
    function _defineProperty(e, r, t) {
      return (r = toPropertyKey2(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
      }) : e[r] = t, e;
    }
    module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(defineProperty);
  return defineProperty.exports;
}
var browser;
var hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  var invariant = function(condition, format, a, b, c, d, e, f) {
    if (process.env.NODE_ENV !== "production") {
      if (format === void 0) {
        throw new Error("invariant requires an error message argument");
      }
    }
    if (!condition) {
      var error;
      if (format === void 0) {
        error = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        error = new Error(
          format.replace(/%s/g, function() {
            return args[argIndex++];
          })
        );
        error.name = "Invariant Violation";
      }
      error.framesToPop = 1;
      throw error;
    }
  };
  browser = invariant;
  return browser;
}
var assertFragmentMap_1;
var hasRequiredAssertFragmentMap;
function requireAssertFragmentMap() {
  if (hasRequiredAssertFragmentMap) return assertFragmentMap_1;
  hasRequiredAssertFragmentMap = 1;
  var invariant = requireBrowser();
  function assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === "object") ? process.env.NODE_ENV !== "production" ? invariant(false, "Could not create Relay Container for `%s`. Expected a set of GraphQL fragments, got `%s` instead.", componentName, fragmentSpec) : invariant(false) : void 0;
    for (var key in fragmentSpec) {
      if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === "object" || typeof fragment === "function")) ? process.env.NODE_ENV !== "production" ? invariant(false, "Could not create Relay Container for `%s`. The value of fragment `%s` was expected to be a fragment, got `%s` instead.", componentName, key, fragment) : invariant(false) : void 0;
      }
    }
  }
  assertFragmentMap_1 = assertFragmentMap;
  return assertFragmentMap_1;
}
var ReactRelayContainerUtils;
var hasRequiredReactRelayContainerUtils;
function requireReactRelayContainerUtils() {
  if (hasRequiredReactRelayContainerUtils) return ReactRelayContainerUtils;
  hasRequiredReactRelayContainerUtils = 1;
  function getComponentName(component) {
    return component.displayName || component.name || "Component";
  }
  function getContainerName(Component) {
    return "Relay(" + getComponentName(Component) + ")";
  }
  ReactRelayContainerUtils = {
    getComponentName,
    getContainerName
  };
  return ReactRelayContainerUtils;
}
var ReactRelayQueryRendererContext;
var hasRequiredReactRelayQueryRendererContext;
function requireReactRelayQueryRendererContext() {
  if (hasRequiredReactRelayQueryRendererContext) return ReactRelayQueryRendererContext;
  hasRequiredReactRelayQueryRendererContext = 1;
  var React = require$$0__default;
  ReactRelayQueryRendererContext = React.createContext({
    rootIsQueryRenderer: false
  });
  return ReactRelayQueryRendererContext;
}
var buildReactRelayContainer_1;
var hasRequiredBuildReactRelayContainer;
function requireBuildReactRelayContainer() {
  if (hasRequiredBuildReactRelayContainer) return buildReactRelayContainer_1;
  hasRequiredBuildReactRelayContainer = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _extends2 = _interopRequireDefault(require_extends());
  var assertFragmentMap = requireAssertFragmentMap();
  var _require = requireReactRelayContainerUtils(), getComponentName = _require.getComponentName, getContainerName = _require.getContainerName;
  var ReactRelayContext2 = requireReactRelayContext();
  var ReactRelayQueryRendererContext2 = requireReactRelayQueryRendererContext();
  var invariant = requireBrowser();
  var React = require$$0__default;
  var _require2 = require$$11, getFragment2 = _require2.getFragment;
  var useContext2 = React.useContext;
  function buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = getContainerName(ComponentClass);
    assertFragmentMap(getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for (var key in fragmentSpec) {
      fragments[key] = getFragment2(fragmentSpec[key]);
    }
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
      var _queryRendererContext;
      var context = useContext2(ReactRelayContext2);
      !(context != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "`%s` tried to render a context that was not valid this means that `%s` was rendered outside of a query renderer.", containerName, containerName) : invariant(false) : void 0;
      var queryRendererContext = useContext2(ReactRelayQueryRendererContext2);
      return /* @__PURE__ */ React.createElement(Container, (0, _extends2["default"])({}, props, {
        __relayContext: context,
        __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
        componentRef: props.componentRef || ref
      }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = React.forwardRef(ForwardRef);
    if (process.env.NODE_ENV !== "production") {
      ForwardContainer.__ComponentClass = ComponentClass;
      ForwardContainer.displayName = containerName;
    }
    return ForwardContainer;
  }
  buildReactRelayContainer_1 = buildReactRelayContainer;
  return buildReactRelayContainer_1;
}
var isRelayEnvironment_1;
var hasRequiredIsRelayEnvironment;
function requireIsRelayEnvironment() {
  if (hasRequiredIsRelayEnvironment) return isRelayEnvironment_1;
  hasRequiredIsRelayEnvironment = 1;
  function isRelayEnvironment(environment) {
    return typeof environment === "object" && environment !== null && typeof environment.check === "function" && typeof environment.lookup === "function" && typeof environment.retain === "function" && typeof environment.execute === "function" && typeof environment.subscribe === "function";
  }
  isRelayEnvironment_1 = isRelayEnvironment;
  return isRelayEnvironment_1;
}
var RelayContext;
var hasRequiredRelayContext;
function requireRelayContext() {
  if (hasRequiredRelayContext) return RelayContext;
  hasRequiredRelayContext = 1;
  var isRelayEnvironment = requireIsRelayEnvironment();
  var invariant = requireBrowser();
  function assertRelayContext(relay) {
    !isRelayContext(relay) ? process.env.NODE_ENV !== "production" ? invariant(false, "RelayContext: Expected `context.relay` to be an object conforming to the `RelayContext` interface, got `%s`.", relay) : invariant(false) : void 0;
    return relay;
  }
  function isRelayContext(context) {
    return typeof context === "object" && context !== null && !Array.isArray(context) && isRelayEnvironment(context.environment);
  }
  RelayContext = {
    assertRelayContext,
    isRelayContext
  };
  return RelayContext;
}
var areEqual_1;
var hasRequiredAreEqual;
function requireAreEqual() {
  if (hasRequiredAreEqual) return areEqual_1;
  hasRequiredAreEqual = 1;
  var aStackPool = [];
  var bStackPool = [];
  /**
   * Checks if two values are equal. Values may be primitives, arrays, or objects.
   * Returns true if both arguments have the same keys and values.
   *
   * @see http://underscorejs.org
   * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
   * @license MIT
   */
  function areEqual(a, b) {
    var aStack = aStackPool.length ? aStackPool.pop() : [];
    var bStack = bStackPool.length ? bStackPool.pop() : [];
    var result = eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    aStackPool.push(aStack);
    bStackPool.push(bStack);
    return result;
  }
  function eq(a, b, aStack, bStack) {
    if (a === b) {
      return a !== 0 || 1 / a == 1 / b;
    }
    if (a == null || b == null) {
      return false;
    }
    if (typeof a != "object" || typeof b != "object") {
      return false;
    }
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) {
      return false;
    }
    switch (className) {
      case "[object String]":
        return a == String(b);
      case "[object Number]":
        return isNaN(a) || isNaN(b) ? false : a == Number(b);
      case "[object Date]":
      case "[object Boolean]":
        return +a == +b;
      case "[object RegExp]":
        return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    }
    var length = aStack.length;
    while (length--) {
      if (aStack[length] == a) {
        return bStack[length] == b;
      }
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0;
    if (className === "[object Array]") {
      size = a.length;
      if (size !== b.length) {
        return false;
      }
      while (size--) {
        if (!eq(a[size], b[size], aStack, bStack)) {
          return false;
        }
      }
    } else {
      if (a.constructor !== b.constructor) {
        return false;
      }
      if (a.hasOwnProperty("valueOf") && b.hasOwnProperty("valueOf")) {
        return a.valueOf() == b.valueOf();
      }
      var keys = Object.keys(a);
      if (keys.length != Object.keys(b).length) {
        return false;
      }
      for (var i = 0; i < keys.length; i++) {
        if (!eq(a[keys[i]], b[keys[i]], aStack, bStack)) {
          return false;
        }
      }
    }
    aStack.pop();
    bStack.pop();
    return true;
  }
  areEqual_1 = areEqual;
  return areEqual_1;
}
var ReactRelayFragmentContainer;
var hasRequiredReactRelayFragmentContainer;
function requireReactRelayFragmentContainer() {
  if (hasRequiredReactRelayFragmentContainer) return ReactRelayFragmentContainer;
  hasRequiredReactRelayFragmentContainer = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _extends2 = _interopRequireDefault(require_extends());
  var _objectWithoutPropertiesLoose2 = _interopRequireDefault(requireObjectWithoutPropertiesLoose());
  var _assertThisInitialized2 = _interopRequireDefault(requireAssertThisInitialized());
  var _inheritsLoose2 = _interopRequireDefault(requireInheritsLoose());
  var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
  var _excluded = ["componentRef", "__relayContext", "__rootIsQueryRenderer"];
  var buildReactRelayContainer = requireBuildReactRelayContainer();
  var _require = requireReactRelayContainerUtils(), getContainerName = _require.getContainerName;
  var _require2 = requireRelayContext(), assertRelayContext = _require2.assertRelayContext;
  var areEqual = requireAreEqual();
  var React = require$$0__default;
  var _require3 = require$$11, createFragmentSpecResolver = _require3.createFragmentSpecResolver, getDataIDsFromObject = _require3.getDataIDsFromObject, isScalarAndEqual = _require3.isScalarAndEqual;
  function createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = getContainerName(Component);
    return _class = /* @__PURE__ */ function(_React$Component) {
      (0, _inheritsLoose2["default"])(_class2, _React$Component);
      function _class2(props) {
        var _props$__rootIsQueryR, _this;
        _this = _React$Component.call(this, props) || this;
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
          var resolverFromThisUpdate = _this.state.resolver;
          _this.setState(function(updatedState) {
            return resolverFromThisUpdate === updatedState.resolver ? {
              data: updatedState.resolver.resolve(),
              relayProp: getRelayProp(updatedState.relayProp.environment)
            } : null;
          });
        });
        var relayContext = assertRelayContext(props.__relayContext);
        var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
        var resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
        _this.state = {
          data: resolver.resolve(),
          prevProps: props,
          prevPropsContext: relayContext,
          relayProp: getRelayProp(relayContext.environment),
          resolver
        };
        return _this;
      }
      _class2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var _nextProps$__rootIsQu;
        var prevProps = prevState.prevProps;
        var relayContext = assertRelayContext(nextProps.__relayContext);
        var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
        var prevIDs = getDataIDsFromObject(fragments, prevProps);
        var nextIDs = getDataIDsFromObject(fragments, nextProps);
        var resolver = prevState.resolver;
        if (prevState.prevPropsContext.environment !== relayContext.environment || !areEqual(prevIDs, nextIDs)) {
          resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
          return {
            data: resolver.resolve(),
            prevPropsContext: relayContext,
            prevProps: nextProps,
            relayProp: getRelayProp(relayContext.environment),
            resolver
          };
        } else {
          resolver.setProps(nextProps);
          var data = resolver.resolve();
          if (data !== prevState.data) {
            return {
              data,
              prevProps: nextProps,
              prevPropsContext: relayContext,
              relayProp: getRelayProp(relayContext.environment)
            };
          }
        }
        return null;
      };
      var _proto = _class2.prototype;
      _proto.componentDidMount = function componentDidMount() {
        this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
      };
      _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (this.state.resolver !== prevState.resolver) {
          prevState.resolver.dispose();
          this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        } else {
          this._rerenderIfStoreHasChanged();
        }
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.resolver.dispose();
      };
      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        if (nextState.data !== this.state.data) {
          return true;
        }
        var keys = Object.keys(nextProps);
        for (var ii = 0; ii < keys.length; ii++) {
          var key = keys[ii];
          if (key === "__relayContext") {
            if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) {
              return true;
            }
          } else {
            if (!fragments.hasOwnProperty(key) && !isScalarAndEqual(nextProps[key], this.props[key])) {
              return true;
            }
          }
        }
        return false;
      };
      _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
        var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
        var maybeNewData = resolver.resolve();
        if (data !== maybeNewData) {
          this.setState({
            data: maybeNewData
          });
        }
      };
      _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
        var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
        var maybeNewData = resolver.resolve();
        resolver.setCallback(this.props, this._handleFragmentDataUpdate);
        if (data !== maybeNewData) {
          this.setState({
            data: maybeNewData
          });
        }
      };
      _proto.render = function render() {
        var _this$props = this.props, componentRef = _this$props.componentRef;
        _this$props.__relayContext;
        _this$props.__rootIsQueryRenderer;
        var props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
        return /* @__PURE__ */ React.createElement(Component, (0, _extends2["default"])({}, props, this.state.data, {
          ref: componentRef,
          relay: this.state.relayProp
        }));
      };
      return _class2;
    }(React.Component), (0, _defineProperty2["default"])(_class, "displayName", containerName), _class;
  }
  function getRelayProp(environment) {
    return {
      environment
    };
  }
  function createContainer(Component, fragmentSpec) {
    return buildReactRelayContainer(Component, fragmentSpec, createContainerWithFragments);
  }
  ReactRelayFragmentContainer = {
    createContainer
  };
  return ReactRelayFragmentContainer;
}
var ReactRelayLocalQueryRenderer_1;
var hasRequiredReactRelayLocalQueryRenderer;
function requireReactRelayLocalQueryRenderer() {
  if (hasRequiredReactRelayLocalQueryRenderer) return ReactRelayLocalQueryRenderer_1;
  hasRequiredReactRelayLocalQueryRenderer = 1;
  var ReactRelayContext2 = requireReactRelayContext();
  var ReactRelayQueryRendererContext2 = requireReactRelayQueryRendererContext();
  var areEqual = requireAreEqual();
  var React = require$$0__default;
  var _require = require$$11, createOperationDescriptor = _require.createOperationDescriptor, deepFreeze = _require.deepFreeze, getRequest = _require.getRequest;
  var useLayoutEffect = React.useLayoutEffect, useState2 = React.useState, useRef2 = React.useRef, useMemo2 = React.useMemo;
  var queryRendererContext = {
    rootIsQueryRenderer: true
  };
  function useDeepCompare(value) {
    var latestValue = React.useRef(value);
    if (!areEqual(latestValue.current, value)) {
      if (process.env.NODE_ENV !== "production") {
        deepFreeze(value);
      }
      latestValue.current = value;
    }
    return latestValue.current;
  }
  function ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = useDeepCompare(variables);
    var operation = useMemo2(function() {
      var request = getRequest(query);
      return createOperationDescriptor(request, latestVariables);
    }, [query, latestVariables]);
    var relayContext = useMemo2(function() {
      return {
        environment
      };
    }, [environment]);
    var dataRef = useRef2(null);
    var _useState = useState2(null), forceUpdate = _useState[1];
    var cleanupFnRef = useRef2(null);
    var snapshot = useMemo2(function() {
      environment.check(operation);
      var res = environment.lookup(operation.fragment);
      dataRef.current = res.data;
      var retainDisposable = environment.retain(operation);
      var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
        dataRef.current = newSnapshot.data;
        forceUpdate(dataRef.current);
      });
      var disposed = false;
      function nextCleanupFn() {
        if (!disposed) {
          disposed = true;
          cleanupFnRef.current = null;
          retainDisposable.dispose();
          subscribeDisposable.dispose();
        }
      }
      if (cleanupFnRef.current) {
        cleanupFnRef.current();
      }
      cleanupFnRef.current = nextCleanupFn;
      return res;
    }, [environment, operation]);
    useLayoutEffect(function() {
      var cleanupFn = cleanupFnRef.current;
      return function() {
        cleanupFn && cleanupFn();
      };
    }, [snapshot]);
    return /* @__PURE__ */ React.createElement(ReactRelayContext2.Provider, {
      value: relayContext
    }, /* @__PURE__ */ React.createElement(ReactRelayQueryRendererContext2.Provider, {
      value: queryRendererContext
    }, render({
      props: dataRef.current
    })));
  }
  ReactRelayLocalQueryRenderer_1 = ReactRelayLocalQueryRenderer;
  return ReactRelayLocalQueryRenderer_1;
}
var objectSpread2 = { exports: {} };
var hasRequiredObjectSpread2;
function requireObjectSpread2() {
  if (hasRequiredObjectSpread2) return objectSpread2.exports;
  hasRequiredObjectSpread2 = 1;
  (function(module) {
    var defineProperty2 = requireDefineProperty();
    function ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r2) {
          return Object.getOwnPropertyDescriptor(e, r2).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread2(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
          defineProperty2(e, r2, t[r2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
          Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
        });
      }
      return e;
    }
    module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(objectSpread2);
  return objectSpread2.exports;
}
var getRootVariablesForFragments_1;
var hasRequiredGetRootVariablesForFragments;
function requireGetRootVariablesForFragments() {
  if (hasRequiredGetRootVariablesForFragments) return getRootVariablesForFragments_1;
  hasRequiredGetRootVariablesForFragments = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var _require = require$$11, getSelector = _require.getSelector;
  function getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
      var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
      var fragmentNode = fragments[key];
      var fragmentRef = props[key];
      var selector = getSelector(fragmentNode, fragmentRef);
      var fragmentOwnerVariables = selector != null && selector.kind === "PluralReaderSelector" ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
      rootVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
  }
  getRootVariablesForFragments_1 = getRootVariablesForFragments;
  return getRootVariablesForFragments_1;
}
var ReactRelayQueryFetcher_1;
var hasRequiredReactRelayQueryFetcher;
function requireReactRelayQueryFetcher() {
  if (hasRequiredReactRelayQueryFetcher) return ReactRelayQueryFetcher_1;
  hasRequiredReactRelayQueryFetcher = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
  var invariant = requireBrowser();
  var _require = require$$11, fetchQuery = _require.__internal.fetchQuery, createOperationDescriptor = _require.createOperationDescriptor, isRelayModernEnvironment = _require.isRelayModernEnvironment;
  var ReactRelayQueryFetcher = /* @__PURE__ */ function() {
    function ReactRelayQueryFetcher2(args) {
      (0, _defineProperty2["default"])(this, "_selectionReferences", []);
      (0, _defineProperty2["default"])(this, "_didFetchFinish", false);
      if (args != null) {
        this._cacheSelectionReference = args.cacheSelectionReference;
        this._selectionReferences = args.selectionReferences;
      }
    }
    var _proto = ReactRelayQueryFetcher2.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
      return {
        cacheSelectionReference: this._cacheSelectionReference,
        selectionReferences: this._selectionReferences
      };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
      if (fetchPolicy === "store-and-network" || fetchPolicy === "store-or-network") {
        if (environment.check(operation).status === "available") {
          this._retainCachedOperation(environment, operation);
          return environment.lookup(operation.fragment);
        }
      }
      return null;
    };
    _proto.getFetchResult = function getFetchResult() {
      if (this._didFetchFinish) {
        if (this._error != null) {
          return {
            error: this._error
          };
        } else if (this._snapshot != null) {
          return {
            snapshot: this._snapshot
          };
        }
      } else {
        return null;
      }
    };
    _proto.execute = function execute(_ref) {
      var _this = this;
      var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
      var reference = environment.retain(operation);
      var error = function error2() {
        _this._selectionReferences = _this._selectionReferences.concat(reference);
      };
      var complete = function complete2() {
        if (!preservePreviousReferences) {
          _this.disposeSelectionReferences();
        }
        _this._selectionReferences = _this._selectionReferences.concat(reference);
      };
      var unsubscribe = function unsubscribe2() {
        _this._selectionReferences = _this._selectionReferences.concat(reference);
      };
      if (!isRelayModernEnvironment(environment)) {
        return environment.execute({
          operation
        })["do"]({
          error,
          complete,
          unsubscribe
        });
      }
      return fetchQuery(environment, operation)["do"]({
        error,
        complete,
        unsubscribe
      });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
      !this._fetchOptions ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayQueryFetcher: `setOnDataChange` should have been called after having called `fetch`") : invariant(false) : void 0;
      if (typeof onDataChange === "function") {
        this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
        this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        if (this._didFetchFinish) {
          if (this._error != null) {
            onDataChange({
              error: this._error
            });
          } else if (this._snapshot != null) {
            onDataChange({
              snapshot: this._snapshot
            });
          }
        }
      }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
      var _this2 = this;
      var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
      var fetchHasReturned = false;
      var _error;
      this.disposeRequest();
      var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
      this._fetchOptions = {
        environment,
        onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
        operation
      };
      if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) {
        this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
      }
      var operationOverride = cacheConfigOverride ? createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
      var request = this.execute({
        environment,
        operation: operationOverride
      })["finally"](function() {
        _this2._pendingRequest = null;
      }).subscribe({
        next: function next() {
          _this2._didFetchFinish = true;
          _this2._error = null;
          _this2._onQueryDataAvailable({
            notifyFirstResult: fetchHasReturned
          });
        },
        error: function error(err) {
          _this2._didFetchFinish = true;
          _this2._error = err;
          _this2._snapshot = null;
          var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
          if (fetchHasReturned) {
            if (onDataChangeCallbacks) {
              onDataChangeCallbacks.forEach(function(onDataChange2) {
                onDataChange2({
                  error: err
                });
              });
            }
          } else {
            _error = err;
          }
        }
      });
      this._pendingRequest = {
        dispose: function dispose() {
          request.unsubscribe();
        }
      };
      fetchHasReturned = true;
      if (_error) {
        throw _error;
      }
      return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
      !this._fetchOptions ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayQueryFetcher: `retry` should be called after having called `fetch`") : invariant(false) : void 0;
      return this.fetch({
        environment: this._fetchOptions.environment,
        operation: this._fetchOptions.operation,
        onDataChange: null
      }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
      this.disposeRequest();
      this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
      this._error = null;
      this._snapshot = null;
      if (this._pendingRequest) {
        this._pendingRequest.dispose();
      }
      if (this._rootSubscription) {
        this._rootSubscription.dispose();
        this._rootSubscription = null;
      }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
      this._disposeCacheSelectionReference();
      this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
      this._cacheSelectionReference && this._cacheSelectionReference.dispose();
      this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
      this._disposeCacheSelectionReference();
      this._selectionReferences.forEach(function(r) {
        return r.dispose();
      });
      this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
      var _this3 = this;
      var notifyFirstResult = _ref2.notifyFirstResult;
      !this._fetchOptions ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayQueryFetcher: `_onQueryDataAvailable` should have been called after having called `fetch`") : invariant(false) : void 0;
      var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
      if (this._snapshot) {
        return;
      }
      this._snapshot = environment.lookup(operation.fragment);
      this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot2) {
        if (_this3._fetchOptions != null) {
          var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
          if (Array.isArray(maybeNewOnDataChangeCallbacks)) {
            maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
              return onDataChange({
                snapshot: snapshot2
              });
            });
          }
        }
      });
      if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
        var snapshot = this._snapshot;
        onDataChangeCallbacks.forEach(function(onDataChange) {
          return onDataChange({
            snapshot
          });
        });
      }
    };
    return ReactRelayQueryFetcher2;
  }();
  ReactRelayQueryFetcher_1 = ReactRelayQueryFetcher;
  return ReactRelayQueryFetcher_1;
}
var emptyFunction_1;
var hasRequiredEmptyFunction;
function requireEmptyFunction() {
  if (hasRequiredEmptyFunction) return emptyFunction_1;
  hasRequiredEmptyFunction = 1;
  function makeEmptyFunction(arg) {
    return function() {
      return arg;
    };
  }
  var emptyFunction = function emptyFunction2() {
  };
  emptyFunction.thatReturns = makeEmptyFunction;
  emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
  emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
  emptyFunction.thatReturnsNull = makeEmptyFunction(null);
  emptyFunction.thatReturnsThis = function() {
    return this;
  };
  emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
  };
  emptyFunction_1 = emptyFunction;
  return emptyFunction_1;
}
var warning_1;
var hasRequiredWarning;
function requireWarning() {
  if (hasRequiredWarning) return warning_1;
  hasRequiredWarning = 1;
  var emptyFunction = requireEmptyFunction();
  function printWarning(format) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    var argIndex = 0;
    var message2 = "Warning: " + format.replace(/%s/g, function() {
      return args[argIndex++];
    });
    if (typeof console !== "undefined") {
      console.error(message2);
    }
    try {
      throw new Error(message2);
    } catch (x) {
    }
  }
  var warning = process.env.NODE_ENV !== "production" ? function(condition, format) {
    if (format === void 0) {
      throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }
      printWarning.apply(void 0, [format].concat(args));
    }
  } : emptyFunction;
  warning_1 = warning;
  return warning_1;
}
var ReactRelayPaginationContainer;
var hasRequiredReactRelayPaginationContainer;
function requireReactRelayPaginationContainer() {
  if (hasRequiredReactRelayPaginationContainer) return ReactRelayPaginationContainer;
  hasRequiredReactRelayPaginationContainer = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _extends2 = _interopRequireDefault(require_extends());
  var _objectWithoutPropertiesLoose2 = _interopRequireDefault(requireObjectWithoutPropertiesLoose());
  var _assertThisInitialized2 = _interopRequireDefault(requireAssertThisInitialized());
  var _inheritsLoose2 = _interopRequireDefault(requireInheritsLoose());
  var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
  var _objectSpread3 = _interopRequireDefault(requireObjectSpread2());
  var _excluded = ["componentRef"], _excluded2 = ["componentRef", "__relayContext", "__rootIsQueryRenderer"], _excluded3 = ["componentRef", "__relayContext", "__rootIsQueryRenderer"];
  var buildReactRelayContainer = requireBuildReactRelayContainer();
  var getRootVariablesForFragments = requireGetRootVariablesForFragments();
  var _require = requireReactRelayContainerUtils(), getComponentName = _require.getComponentName, getContainerName = _require.getContainerName;
  var ReactRelayContext2 = requireReactRelayContext();
  var ReactRelayQueryFetcher = requireReactRelayQueryFetcher();
  var _require2 = requireRelayContext(), assertRelayContext = _require2.assertRelayContext;
  var areEqual = requireAreEqual();
  var invariant = requireBrowser();
  var React = require$$0__default;
  var _require3 = require$$11, ConnectionInterface = _require3.ConnectionInterface, Observable = _require3.Observable, RelayFeatureFlags = _require3.RelayFeatureFlags, createFragmentSpecResolver = _require3.createFragmentSpecResolver, createOperationDescriptor = _require3.createOperationDescriptor, getDataIDsFromObject = _require3.getDataIDsFromObject, getRequest = _require3.getRequest, getVariablesFromObject = _require3.getVariablesFromObject, isScalarAndEqual = _require3.isScalarAndEqual;
  var warning = requireWarning();
  var FORWARD = "forward";
  function createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayPaginationContainer: Unable to synthesize a getConnectionFromProps function.") : invariant(false) : void 0;
    return function(props) {
      var data = props[metadata.fragmentName];
      for (var i = 0; i < path.length; i++) {
        if (!data || typeof data !== "object") {
          return null;
        }
        data = data[path[i]];
      }
      return data;
    };
  }
  function createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayPaginationContainer: Unable to synthesize a getFragmentVariables function.") : invariant(false) : void 0;
    return function(prevVars, totalCount) {
      return (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, prevVars), {}, (0, _defineProperty2["default"])({}, countVariable, totalCount));
    };
  }
  function findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for (var fragmentName in fragments) {
      var fragment = fragments[fragmentName];
      var connectionMetadata = fragment.metadata && fragment.metadata.connection;
      if (fragment.metadata !== void 0) {
        isRelayModern = true;
      }
      if (connectionMetadata) {
        !(connectionMetadata.length === 1) ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayPaginationContainer: Only a single @connection is supported, `%s` has %s.", fragmentName, connectionMetadata.length) : invariant(false) : void 0;
        !!foundConnectionMetadata ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayPaginationContainer: Only a single fragment with @connection is supported.") : invariant(false) : void 0;
        foundConnectionMetadata = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, connectionMetadata[0]), {}, {
          fragmentName
        });
      }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayPaginationContainer: A @connection directive must be present.") : invariant(false) : void 0;
    return foundConnectionMetadata || {};
  }
  function toObserver(observerOrCallback) {
    return typeof observerOrCallback === "function" ? {
      error: observerOrCallback,
      complete: observerOrCallback,
      unsubscribe: function unsubscribe(subscription) {
        typeof observerOrCallback === "function" && observerOrCallback();
      }
    } : observerOrCallback || {};
  }
  function createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = getComponentName(Component);
    var containerName = getContainerName(Component);
    var metadata = findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayPaginationContainer: Unable to infer direction of the connection, possibly because both first and last are provided.") : invariant(false) : void 0;
    var getFragmentVariables = connectionConfig.getFragmentVariables || createGetFragmentVariables(metadata);
    return _class = /* @__PURE__ */ function(_React$Component) {
      (0, _inheritsLoose2["default"])(_class2, _React$Component);
      function _class2(props) {
        var _props$__rootIsQueryR, _this;
        _this = _React$Component.call(this, props) || this;
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
          _this.setState({
            data: _this._resolver.resolve()
          });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_hasMore", function() {
          var connectionData = _this._getConnectionData();
          return !!(connectionData && connectionData.hasMore && connectionData.cursor);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isLoading", function() {
          return !!_this._refetchSubscription;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
          if (!_this._canFetchPage("refetchConnection")) {
            return {
              dispose: function dispose() {
              }
            };
          }
          _this._refetchVariables = refetchVariables;
          var paginatingVariables = {
            count: totalCount,
            cursor: null,
            totalCount
          };
          var fetch = _this._fetchPage(paginatingVariables, toObserver(observerOrCallback), {
            force: true
          });
          return {
            dispose: fetch.unsubscribe
          };
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
          if (!_this._canFetchPage("loadMore")) {
            return {
              dispose: function dispose() {
              }
            };
          }
          var observer = toObserver(observerOrCallback);
          var connectionData = _this._getConnectionData();
          if (!connectionData) {
            Observable.create(function(sink) {
              return sink.complete();
            }).subscribe(observer);
            return null;
          }
          var totalCount = connectionData.edgeCount + pageSize;
          if (options && options.force) {
            return _this._refetchConnection(totalCount, observerOrCallback);
          }
          var _ConnectionInterface$ = ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
          var cursor = connectionData.cursor;
          process.env.NODE_ENV !== "production" ? warning(cursor != null && cursor !== "", "ReactRelayPaginationContainer: Cannot `loadMore` without valid `%s` (got `%s`)", direction === FORWARD ? END_CURSOR : START_CURSOR, cursor) : void 0;
          var paginatingVariables = {
            count: pageSize,
            cursor,
            totalCount
          };
          var fetch = _this._fetchPage(paginatingVariables, observer, options);
          return {
            dispose: fetch.unsubscribe
          };
        });
        var relayContext = assertRelayContext(props.__relayContext);
        var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
        _this._isARequestInFlight = false;
        _this._refetchSubscription = null;
        _this._refetchVariables = null;
        if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
          _this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
        } else {
          _this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
        }
        _this.state = {
          data: _this._resolver.resolve(),
          prevContext: relayContext,
          contextForChildren: relayContext,
          relayProp: _this._buildRelayProp(relayContext),
          resolverGeneration: 0
        };
        _this._isUnmounted = false;
        _this._hasFetched = false;
        return _this;
      }
      var _proto = _class2.prototype;
      _proto.componentDidMount = function componentDidMount() {
        this._isUnmounted = false;
        if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
          this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        }
      };
      _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
          if (prevState.resolverGeneration !== this.state.resolverGeneration) {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
          } else {
            this._rerenderIfStoreHasChanged();
          }
        }
      };
      _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        var _this2 = this;
        var _nextProps$__rootIsQu;
        var relayContext = assertRelayContext(nextProps.__relayContext);
        var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
        var prevIDs = getDataIDsFromObject(fragments, this.props);
        var nextIDs = getDataIDsFromObject(fragments, nextProps);
        var prevRootVariables = getRootVariablesForFragments(fragments, this.props);
        var nextRootVariables = getRootVariablesForFragments(fragments, nextProps);
        if (relayContext.environment !== this.state.prevContext.environment || !areEqual(prevRootVariables, nextRootVariables) || !areEqual(prevIDs, nextIDs)) {
          this._cleanup();
          if (RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
          } else {
            this._resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
          }
          this.setState(function(prevState) {
            return {
              prevContext: relayContext,
              contextForChildren: relayContext,
              relayProp: _this2._buildRelayProp(relayContext),
              resolverGeneration: prevState.resolverGeneration + 1
            };
          });
        } else if (!this._hasFetched) {
          this._resolver.setProps(nextProps);
        }
        var data = this._resolver.resolve();
        if (data !== this.state.data) {
          this.setState({
            data
          });
        }
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        this._isUnmounted = true;
        this._cleanup();
      };
      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) {
          return true;
        }
        var keys = Object.keys(nextProps);
        for (var ii = 0; ii < keys.length; ii++) {
          var key = keys[ii];
          if (key === "__relayContext") {
            if (nextState.prevContext.environment !== this.state.prevContext.environment) {
              return true;
            }
          } else {
            if (!fragments.hasOwnProperty(key) && !isScalarAndEqual(nextProps[key], this.props[key])) {
              return true;
            }
          }
        }
        return false;
      };
      _proto._buildRelayProp = function _buildRelayProp(relayContext) {
        return {
          hasMore: this._hasMore,
          isLoading: this._isLoading,
          loadMore: this._loadMore,
          refetchConnection: this._refetchConnection,
          environment: relayContext.environment
        };
      };
      _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
        var data = this.state.data;
        var maybeNewData = this._resolver.resolve();
        if (data !== maybeNewData) {
          this.setState({
            data: maybeNewData
          });
        }
      };
      _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
        var data = this.state.data;
        var maybeNewData = this._resolver.resolve();
        this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
        if (data !== maybeNewData) {
          this.setState({
            data: maybeNewData
          });
        }
      };
      _proto._getConnectionData = function _getConnectionData() {
        var _this$props = this.props;
        _this$props.componentRef;
        var restProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
        var props = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, restProps), this.state.data);
        var connectionData = getConnectionFromProps(props);
        if (connectionData == null) {
          return null;
        }
        var _ConnectionInterface$2 = ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
        !(typeof connectionData === "object") ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayPaginationContainer: Expected `getConnectionFromProps()` in `%s`to return `null` or a plain object with %s and %s properties, got `%s`.", componentName, EDGES, PAGE_INFO, connectionData) : invariant(false) : void 0;
        var edges = connectionData[EDGES];
        var pageInfo = connectionData[PAGE_INFO];
        if (edges == null || pageInfo == null) {
          return null;
        }
        !Array.isArray(edges) ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayPaginationContainer: Expected `getConnectionFromProps()` in `%s`to return an object with %s: Array, got `%s`.", componentName, EDGES, edges) : invariant(false) : void 0;
        !(typeof pageInfo === "object") ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayPaginationContainer: Expected `getConnectionFromProps()` in `%s`to return an object with %s: Object, got `%s`.", componentName, PAGE_INFO, pageInfo) : invariant(false) : void 0;
        var hasMore = direction === FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
        var cursor = direction === FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
        if (typeof hasMore !== "boolean" || edges.length !== 0 && typeof cursor === "undefined") {
          process.env.NODE_ENV !== "production" ? warning(false, "ReactRelayPaginationContainer: Cannot paginate without %s fields in `%s`. Be sure to fetch %s (got `%s`) and %s (got `%s`).", PAGE_INFO, componentName, direction === FORWARD ? HAS_NEXT_PAGE : HAS_PREV_PAGE, hasMore, direction === FORWARD ? END_CURSOR : START_CURSOR, cursor) : void 0;
          return null;
        }
        return {
          cursor,
          edgeCount: edges.length,
          hasMore
        };
      };
      _proto._getQueryFetcher = function _getQueryFetcher() {
        if (!this._queryFetcher) {
          this._queryFetcher = new ReactRelayQueryFetcher();
        }
        return this._queryFetcher;
      };
      _proto._canFetchPage = function _canFetchPage(method) {
        if (this._isUnmounted) {
          process.env.NODE_ENV !== "production" ? warning(false, "ReactRelayPaginationContainer: Unexpected call of `%s` on unmounted container `%s`. It looks like some instances of your container still trying to fetch data but they already unmounted. Please make sure you clear all timers, intervals, async calls, etc that may trigger `%s` call.", method, containerName, method) : void 0;
          return false;
        }
        return true;
      };
      _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
        var _this3 = this;
        var _assertRelayContext = assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
        var _this$props2 = this.props;
        _this$props2.componentRef;
        _this$props2.__relayContext;
        _this$props2.__rootIsQueryRenderer;
        var restProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, _excluded2);
        var props = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, restProps), this.state.data);
        var fragmentVariables;
        var rootVariables = getRootVariablesForFragments(fragments, restProps);
        fragmentVariables = getVariablesFromObject(fragments, restProps);
        fragmentVariables = (0, _objectSpread3["default"])((0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
        var fetchVariables = connectionConfig.getVariables(props, {
          count: paginatingVariables.count,
          cursor: paginatingVariables.cursor
        }, fragmentVariables);
        !(typeof fetchVariables === "object" && fetchVariables !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, "ReactRelayPaginationContainer: Expected `getVariables()` to return an object, got `%s` in `%s`.", fetchVariables, componentName) : invariant(false) : void 0;
        fetchVariables = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
        fragmentVariables = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, fetchVariables), fragmentVariables);
        var cacheConfig = options ? {
          force: !!options.force
        } : void 0;
        if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) {
          cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
        }
        var request = getRequest(connectionConfig.query);
        var operation = createOperationDescriptor(request, fetchVariables, cacheConfig);
        var refetchSubscription = null;
        if (this._refetchSubscription) {
          this._refetchSubscription.unsubscribe();
        }
        this._hasFetched = true;
        var onNext = function onNext2(payload, complete) {
          var prevData = _this3._resolver.resolve();
          _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
          var nextData = _this3._resolver.resolve();
          if (!areEqual(prevData, nextData)) {
            _this3.setState({
              data: nextData,
              contextForChildren: {
                environment: _this3.props.__relayContext.environment
              }
            }, complete);
          } else {
            complete();
          }
        };
        var cleanup = function cleanup2() {
          if (_this3._refetchSubscription === refetchSubscription) {
            _this3._refetchSubscription = null;
            _this3._isARequestInFlight = false;
          }
        };
        this._isARequestInFlight = true;
        refetchSubscription = this._getQueryFetcher().execute({
          environment,
          operation,
          preservePreviousReferences: true
        }).mergeMap(function(payload) {
          return Observable.create(function(sink) {
            onNext(payload, function() {
              sink.next();
              sink.complete();
            });
          });
        })["do"]({
          error: cleanup,
          complete: cleanup,
          unsubscribe: cleanup
        }).subscribe(observer || {});
        this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
        return refetchSubscription;
      };
      _proto._cleanup = function _cleanup() {
        this._resolver.dispose();
        this._refetchVariables = null;
        this._hasFetched = false;
        if (this._refetchSubscription) {
          this._refetchSubscription.unsubscribe();
          this._refetchSubscription = null;
          this._isARequestInFlight = false;
        }
        if (this._queryFetcher) {
          this._queryFetcher.dispose();
        }
      };
      _proto.render = function render() {
        var _this$props3 = this.props, componentRef = _this$props3.componentRef;
        _this$props3.__relayContext;
        _this$props3.__rootIsQueryRenderer;
        var props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props3, _excluded3);
        return /* @__PURE__ */ React.createElement(ReactRelayContext2.Provider, {
          value: this.state.contextForChildren
        }, /* @__PURE__ */ React.createElement(Component, (0, _extends2["default"])({}, props, this.state.data, {
          ref: componentRef,
          relay: this.state.relayProp
        })));
      };
      return _class2;
    }(React.Component), (0, _defineProperty2["default"])(_class, "displayName", containerName), _class;
  }
  function createContainer(Component, fragmentSpec, connectionConfig) {
    return buildReactRelayContainer(Component, fragmentSpec, function(ComponentClass, fragments) {
      return createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
  }
  ReactRelayPaginationContainer = {
    createContainer
  };
  return ReactRelayPaginationContainer;
}
var ReactRelayQueryRenderer_1;
var hasRequiredReactRelayQueryRenderer;
function requireReactRelayQueryRenderer() {
  if (hasRequiredReactRelayQueryRenderer) return ReactRelayQueryRenderer_1;
  hasRequiredReactRelayQueryRenderer = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var _assertThisInitialized2 = _interopRequireDefault(requireAssertThisInitialized());
  var _inheritsLoose2 = _interopRequireDefault(requireInheritsLoose());
  var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
  var ReactRelayContext2 = requireReactRelayContext();
  var ReactRelayQueryFetcher = requireReactRelayQueryFetcher();
  var ReactRelayQueryRendererContext2 = requireReactRelayQueryRendererContext();
  var areEqual = requireAreEqual();
  var React = require$$0__default;
  var _require = require$$11, createOperationDescriptor = _require.createOperationDescriptor, deepFreeze = _require.deepFreeze, getRequest = _require.getRequest;
  var requestCache = {};
  var queryRendererContext = {
    rootIsQueryRenderer: true
  };
  var ReactRelayQueryRenderer = /* @__PURE__ */ function(_React$Component) {
    (0, _inheritsLoose2["default"])(ReactRelayQueryRenderer2, _React$Component);
    function ReactRelayQueryRenderer2(props) {
      var _this;
      _this = _React$Component.call(this, props) || this;
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
        var error = params.error == null ? null : params.error;
        var snapshot = params.snapshot == null ? null : params.snapshot;
        _this.setState(function(prevState) {
          var prevRequestCacheKey = prevState.requestCacheKey;
          if (prevRequestCacheKey) {
            delete requestCache[prevRequestCacheKey];
          }
          if (snapshot === prevState.snapshot && error === prevState.error) {
            return null;
          }
          return {
            renderProps: getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
            snapshot,
            requestCacheKey: null
          };
        });
      });
      var retryCallbacks = {
        handleDataChange: null,
        handleRetryAfterError: null
      };
      var queryFetcher;
      var requestCacheKey;
      if (props.query) {
        var query = props.query;
        var request = getRequest(query);
        requestCacheKey = getRequestCacheKey(request.params, props.variables);
        queryFetcher = requestCache[requestCacheKey] ? requestCache[requestCacheKey].queryFetcher : new ReactRelayQueryFetcher();
      } else {
        queryFetcher = new ReactRelayQueryFetcher();
      }
      _this._maybeHiddenOrFastRefresh = false;
      _this.state = (0, _objectSpread2["default"])({
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        prevQuery: props.query,
        queryFetcher,
        retryCallbacks
      }, fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
      return _this;
    }
    ReactRelayQueryRenderer2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !areEqual(prevState.prevPropsVariables, nextProps.variables)) {
        return resetQueryStateForUpdate(nextProps, prevState);
      }
      return null;
    };
    var _proto = ReactRelayQueryRenderer2.prototype;
    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;
      if (this._maybeHiddenOrFastRefresh === true) {
        this._maybeHiddenOrFastRefresh = false;
        this.setState(function(prevState) {
          var newState = resetQueryStateForUpdate(_this2.props, prevState);
          var requestCacheKey2 = newState.requestCacheKey, queryFetcher2 = newState.queryFetcher;
          if (requestCacheKey2 != null && requestCache[requestCacheKey2] != null) {
            queryFetcher2.setOnDataChange(_this2._handleDataChange);
          }
          return newState;
        });
        return;
      }
      var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
      if (requestCacheKey) {
        delete requestCache[requestCacheKey];
      }
      retryCallbacks.handleDataChange = this._handleDataChange;
      retryCallbacks.handleRetryAfterError = function(error) {
        return _this2.setState(function(prevState) {
          var prevRequestCacheKey = prevState.requestCacheKey;
          if (prevRequestCacheKey) {
            delete requestCache[prevRequestCacheKey];
          }
          return {
            renderProps: getLoadingRenderProps(),
            requestCacheKey: null
          };
        });
      };
      if (this.props.query) {
        queryFetcher.setOnDataChange(this._handleDataChange);
      }
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
      var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
      if (requestCacheKey) {
        delete requestCache[requestCacheKey];
        delete this.state.requestCacheKey;
      }
      if (this.props.query && queryFetcher !== prevState.queryFetcher) {
        queryFetcher.setOnDataChange(this._handleDataChange);
      }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.state.queryFetcher.dispose();
      this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
      var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
      if (process.env.NODE_ENV !== "production") {
        deepFreeze(renderProps);
      }
      return /* @__PURE__ */ React.createElement(ReactRelayContext2.Provider, {
        value: relayContext
      }, /* @__PURE__ */ React.createElement(ReactRelayQueryRendererContext2.Provider, {
        value: queryRendererContext
      }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer2;
  }(React.Component);
  function getLoadingRenderProps() {
    return {
      error: null,
      props: null,
      retry: null
    };
  }
  function getEmptyRenderProps() {
    return {
      error: null,
      props: {},
      retry: null
    };
  }
  function getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
      error: error ? error : null,
      props: snapshot ? snapshot.data : null,
      retry: function retry(cacheConfigOverride) {
        var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
        if (syncSnapshot && typeof retryCallbacks.handleDataChange === "function") {
          retryCallbacks.handleDataChange({
            snapshot: syncSnapshot
          });
        } else if (error && typeof retryCallbacks.handleRetryAfterError === "function") {
          retryCallbacks.handleRetryAfterError(error);
        }
      }
    };
  }
  function getRequestCacheKey(request, variables) {
    return JSON.stringify({
      id: request.cacheID ? request.cacheID : request.id,
      variables
    });
  }
  function resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
      var request = getRequest(query);
      var requestCacheKey = getRequestCacheKey(request.params, props.variables);
      queryFetcher = requestCache[requestCacheKey] ? requestCache[requestCacheKey].queryFetcher : new ReactRelayQueryFetcher(prevSelectionReferences);
    } else {
      queryFetcher = new ReactRelayQueryFetcher(prevSelectionReferences);
    }
    return (0, _objectSpread2["default"])({
      prevQuery: props.query,
      prevPropsEnvironment: props.environment,
      prevPropsVariables: props.variables,
      queryFetcher
    }, fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
  }
  function fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
      var request = getRequest(query);
      var operation = createOperationDescriptor(request, variables, cacheConfig);
      var relayContext = {
        environment: genericEnvironment
      };
      if (typeof requestCacheKey === "string" && requestCache[requestCacheKey]) {
        var snapshot = requestCache[requestCacheKey].snapshot;
        if (snapshot) {
          return {
            error: null,
            relayContext,
            renderProps: getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
            snapshot,
            requestCacheKey
          };
        } else {
          return {
            error: null,
            relayContext,
            renderProps: getLoadingRenderProps(),
            snapshot: null,
            requestCacheKey
          };
        }
      }
      try {
        var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
        var querySnapshot = queryFetcher.fetch({
          environment: genericEnvironment,
          onDataChange: null,
          operation
        });
        var _snapshot = querySnapshot || storeSnapshot;
        requestCacheKey = requestCacheKey || getRequestCacheKey(request.params, props.variables);
        requestCache[requestCacheKey] = {
          queryFetcher,
          snapshot: _snapshot
        };
        if (!_snapshot) {
          return {
            error: null,
            relayContext,
            renderProps: getLoadingRenderProps(),
            snapshot: null,
            requestCacheKey
          };
        }
        return {
          error: null,
          relayContext,
          renderProps: getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
          snapshot: _snapshot,
          requestCacheKey
        };
      } catch (error) {
        return {
          error,
          relayContext,
          renderProps: getRenderProps(error, null, queryFetcher, retryCallbacks),
          snapshot: null,
          requestCacheKey
        };
      }
    } else {
      queryFetcher.dispose();
      var _relayContext = {
        environment: genericEnvironment
      };
      return {
        error: null,
        relayContext: _relayContext,
        renderProps: getEmptyRenderProps(),
        requestCacheKey: null
      };
    }
  }
  ReactRelayQueryRenderer_1 = ReactRelayQueryRenderer;
  return ReactRelayQueryRenderer_1;
}
var ReactRelayRefetchContainer;
var hasRequiredReactRelayRefetchContainer;
function requireReactRelayRefetchContainer() {
  if (hasRequiredReactRelayRefetchContainer) return ReactRelayRefetchContainer;
  hasRequiredReactRelayRefetchContainer = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _extends2 = _interopRequireDefault(require_extends());
  var _objectWithoutPropertiesLoose2 = _interopRequireDefault(requireObjectWithoutPropertiesLoose());
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var _assertThisInitialized2 = _interopRequireDefault(requireAssertThisInitialized());
  var _inheritsLoose2 = _interopRequireDefault(requireInheritsLoose());
  var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
  var _excluded = ["componentRef", "__relayContext", "__rootIsQueryRenderer"];
  var buildReactRelayContainer = requireBuildReactRelayContainer();
  var getRootVariablesForFragments = requireGetRootVariablesForFragments();
  var _require = requireReactRelayContainerUtils(), getContainerName = _require.getContainerName;
  var ReactRelayContext2 = requireReactRelayContext();
  var ReactRelayQueryFetcher = requireReactRelayQueryFetcher();
  var _require2 = requireRelayContext(), assertRelayContext = _require2.assertRelayContext;
  var areEqual = requireAreEqual();
  var React = require$$0__default;
  var _require3 = require$$11, Observable = _require3.Observable, createFragmentSpecResolver = _require3.createFragmentSpecResolver, createOperationDescriptor = _require3.createOperationDescriptor, getDataIDsFromObject = _require3.getDataIDsFromObject, getRequest = _require3.getRequest, getVariablesFromObject = _require3.getVariablesFromObject, isScalarAndEqual = _require3.isScalarAndEqual;
  var warning = requireWarning();
  function createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = getContainerName(Component);
    return _class = /* @__PURE__ */ function(_React$Component) {
      (0, _inheritsLoose2["default"])(_class2, _React$Component);
      function _class2(props) {
        var _props$__rootIsQueryR, _this;
        _this = _React$Component.call(this, props) || this;
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
          var resolverFromThisUpdate = _this.state.resolver;
          _this.setState(function(updatedState) {
            return resolverFromThisUpdate === updatedState.resolver ? {
              data: updatedState.resolver.resolve()
            } : null;
          });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
          if (_this._isUnmounted) {
            process.env.NODE_ENV !== "production" ? warning(false, "ReactRelayRefetchContainer: Unexpected call of `refetch` on unmounted container `%s`. It looks like some instances of your container still trying to refetch the data but they already unmounted. Please make sure you clear all timers, intervals, async calls, etc that may trigger `refetch`.", containerName) : void 0;
            return {
              dispose: function dispose() {
              }
            };
          }
          var _assertRelayContext = assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
          var rootVariables = getRootVariablesForFragments(fragments, _this.props);
          var fetchVariables = typeof refetchVariables === "function" ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
          fetchVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rootVariables), fetchVariables);
          var fragmentVariables = renderVariables ? (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
          var cacheConfig = options ? {
            force: !!options.force
          } : void 0;
          if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) {
            cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
          }
          var observer = typeof observerOrCallback === "function" ? {
            next: observerOrCallback,
            error: observerOrCallback
          } : observerOrCallback || {};
          var query = getRequest(taggedNode);
          var operation = createOperationDescriptor(query, fetchVariables, cacheConfig);
          _this.state.localVariables = fetchVariables;
          _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
          var refetchSubscription;
          var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
          if (storeSnapshot != null) {
            _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
            _this.setState(function(latestState) {
              return {
                data: latestState.resolver.resolve(),
                contextForChildren: {
                  environment: _this.props.__relayContext.environment
                }
              };
            }, function() {
              observer.next && observer.next();
              observer.complete && observer.complete();
            });
            return {
              dispose: function dispose() {
              }
            };
          }
          _this._getQueryFetcher().execute({
            environment,
            operation,
            preservePreviousReferences: true
          }).mergeMap(function(response) {
            _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
            return Observable.create(function(sink) {
              return _this.setState(function(latestState) {
                return {
                  data: latestState.resolver.resolve(),
                  contextForChildren: {
                    environment: _this.props.__relayContext.environment
                  }
                };
              }, function() {
                sink.next();
                sink.complete();
              });
            });
          })["finally"](function() {
            if (_this._refetchSubscription === refetchSubscription) {
              _this._refetchSubscription = null;
            }
          }).subscribe((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
              _this._refetchSubscription = refetchSubscription = subscription;
              observer.start && observer.start(subscription);
            }
          }));
          return {
            dispose: function dispose() {
              refetchSubscription && refetchSubscription.unsubscribe();
            }
          };
        });
        var relayContext = assertRelayContext(props.__relayContext);
        var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
        _this._refetchSubscription = null;
        var resolver = createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
        _this.state = {
          data: resolver.resolve(),
          localVariables: null,
          prevProps: props,
          prevPropsContext: relayContext,
          contextForChildren: relayContext,
          relayProp: getRelayProp(relayContext.environment, _this._refetch),
          resolver
        };
        _this._isUnmounted = false;
        return _this;
      }
      var _proto = _class2.prototype;
      _proto.componentDidMount = function componentDidMount() {
        this._isUnmounted = false;
        this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
      };
      _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (this.state.resolver !== prevState.resolver) {
          prevState.resolver.dispose();
          this._queryFetcher && this._queryFetcher.dispose();
          this._refetchSubscription && this._refetchSubscription.unsubscribe();
          this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        } else {
          this._rerenderIfStoreHasChanged();
        }
      };
      _class2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var _nextProps$__rootIsQu;
        var prevProps = prevState.prevProps;
        var relayContext = assertRelayContext(nextProps.__relayContext);
        var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
        var prevIDs = getDataIDsFromObject(fragments, prevProps);
        var nextIDs = getDataIDsFromObject(fragments, nextProps);
        var prevRootVariables = getRootVariablesForFragments(fragments, prevProps);
        var nextRootVariables = getRootVariablesForFragments(fragments, nextProps);
        var resolver = prevState.resolver;
        if (prevState.prevPropsContext.environment !== relayContext.environment || !areEqual(prevRootVariables, nextRootVariables) || !areEqual(prevIDs, nextIDs)) {
          resolver = createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
          return {
            data: resolver.resolve(),
            localVariables: null,
            prevProps: nextProps,
            prevPropsContext: relayContext,
            contextForChildren: relayContext,
            relayProp: getRelayProp(relayContext.environment, prevState.relayProp.refetch),
            resolver
          };
        } else if (!prevState.localVariables) {
          resolver.setProps(nextProps);
        }
        var data = resolver.resolve();
        if (data !== prevState.data) {
          return {
            data,
            prevProps: nextProps
          };
        }
        return null;
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        this._isUnmounted = true;
        this.state.resolver.dispose();
        this._queryFetcher && this._queryFetcher.dispose();
        this._refetchSubscription && this._refetchSubscription.unsubscribe();
      };
      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) {
          return true;
        }
        var keys = Object.keys(nextProps);
        for (var ii = 0; ii < keys.length; ii++) {
          var key = keys[ii];
          if (key === "__relayContext") {
            if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) {
              return true;
            }
          } else {
            if (!fragments.hasOwnProperty(key) && !isScalarAndEqual(nextProps[key], this.props[key])) {
              return true;
            }
          }
        }
        return false;
      };
      _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
        var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
        var maybeNewData = resolver.resolve();
        if (data !== maybeNewData) {
          this.setState({
            data: maybeNewData
          });
        }
      };
      _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
        var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
        var maybeNewData = resolver.resolve();
        resolver.setCallback(this.props, this._handleFragmentDataUpdate);
        if (data !== maybeNewData) {
          this.setState({
            data: maybeNewData
          });
        }
      };
      _proto._getFragmentVariables = function _getFragmentVariables() {
        return getVariablesFromObject(fragments, this.props);
      };
      _proto._getQueryFetcher = function _getQueryFetcher() {
        if (!this._queryFetcher) {
          this._queryFetcher = new ReactRelayQueryFetcher();
        }
        return this._queryFetcher;
      };
      _proto.render = function render() {
        var _this$props = this.props, componentRef = _this$props.componentRef;
        _this$props.__relayContext;
        _this$props.__rootIsQueryRenderer;
        var props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
        var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
        return /* @__PURE__ */ React.createElement(ReactRelayContext2.Provider, {
          value: contextForChildren
        }, /* @__PURE__ */ React.createElement(Component, (0, _extends2["default"])({}, props, this.state.data, {
          ref: componentRef,
          relay: relayProp
        })));
      };
      return _class2;
    }(React.Component), (0, _defineProperty2["default"])(_class, "displayName", containerName), _class;
  }
  function getRelayProp(environment, refetch) {
    return {
      environment,
      refetch
    };
  }
  function createContainer(Component, fragmentSpec, taggedNode) {
    return buildReactRelayContainer(Component, fragmentSpec, function(ComponentClass, fragments) {
      return createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
  }
  ReactRelayRefetchContainer = {
    createContainer
  };
  return ReactRelayRefetchContainer;
}
var ProfilerContext_1;
var hasRequiredProfilerContext;
function requireProfilerContext() {
  if (hasRequiredProfilerContext) return ProfilerContext_1;
  hasRequiredProfilerContext = 1;
  var React = require$$0__default;
  var ProfilerContext = React.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
      return cb();
    }
  });
  ProfilerContext_1 = ProfilerContext;
  return ProfilerContext_1;
}
var useRelayEnvironment_1;
var hasRequiredUseRelayEnvironment;
function requireUseRelayEnvironment() {
  if (hasRequiredUseRelayEnvironment) return useRelayEnvironment_1;
  hasRequiredUseRelayEnvironment = 1;
  var ReactRelayContext2 = requireReactRelayContext();
  var invariant = requireBrowser();
  var _require = require$$0__default, useContext2 = _require.useContext;
  function useRelayEnvironment() {
    var context = useContext2(ReactRelayContext2);
    !(context != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "useRelayEnvironment: Expected to have found a Relay environment provided by a `RelayEnvironmentProvider` component. This usually means that useRelayEnvironment was used in a component that is not a descendant of a `RelayEnvironmentProvider`. Please make sure a `RelayEnvironmentProvider` has been rendered somewhere as a parent or ancestor of your component.") : invariant(false) : void 0;
    return context.environment;
  }
  useRelayEnvironment_1 = useRelayEnvironment;
  return useRelayEnvironment_1;
}
var EntryPointContainer_react;
var hasRequiredEntryPointContainer_react;
function requireEntryPointContainer_react() {
  if (hasRequiredEntryPointContainer_react) return EntryPointContainer_react;
  hasRequiredEntryPointContainer_react = 1;
  var ProfilerContext = requireProfilerContext();
  var useRelayEnvironment = requireUseRelayEnvironment();
  var React = require$$0__default;
  var _require = require$$0__default, useContext2 = _require.useContext, useEffect2 = _require.useEffect;
  var warning = requireWarning();
  function EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    process.env.NODE_ENV !== "production" ? warning(entryPointReference.isDisposed === false, "<EntryPointContainer>: Expected entryPointReference to not be disposed yet. This is because disposing the entrypoint marks it for future garbage collection, and as such may no longer be present in the Relay store. In the future, this will become a hard error.") : void 0;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = useContext2(ProfilerContext);
    var environment = useRelayEnvironment();
    useEffect2(function() {
      environment.__log({
        name: "entrypoint.root.consume",
        profilerContext,
        rootModuleID
      });
    }, [environment, profilerContext, rootModuleID]);
    return /* @__PURE__ */ React.createElement(Component, {
      entryPoints,
      extraProps,
      props,
      queries
    });
  }
  EntryPointContainer_react = EntryPointContainer;
  return EntryPointContainer_react;
}
var loadQuery_1;
var hasRequiredLoadQuery;
function requireLoadQuery() {
  if (hasRequiredLoadQuery) return loadQuery_1;
  hasRequiredLoadQuery = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var invariant = requireBrowser();
  var React = require$$0__default;
  var _require = require$$11, fetchQueryDeduped = _require.__internal.fetchQueryDeduped, Observable = _require.Observable, PreloadableQueryRegistry = _require.PreloadableQueryRegistry, RelayFeatureFlags = _require.RelayFeatureFlags, ReplaySubject = _require.ReplaySubject, createOperationDescriptor = _require.createOperationDescriptor, getRequest = _require.getRequest, getRequestIdentifier = _require.getRequestIdentifier;
  var warning = requireWarning();
  var RenderDispatcher = null;
  var fetchKey = 100001;
  function useTrackLoadQueryInRender() {
    if (RenderDispatcher === null) {
      var _React$__SECRET_INTER, _React$__SECRET_INTER2;
      RenderDispatcher = (_React$__SECRET_INTER = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER === void 0 ? void 0 : (_React$__SECRET_INTER2 = _React$__SECRET_INTER.ReactCurrentDispatcher) === null || _React$__SECRET_INTER2 === void 0 ? void 0 : _React$__SECRET_INTER2.current;
    }
  }
  function loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _React$__SECRET_INTER3, _React$__SECRET_INTER4, _options$__nameForWar, _options$fetchPolicy;
    var CurrentDispatcher = (_React$__SECRET_INTER3 = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER3 === void 0 ? void 0 : (_React$__SECRET_INTER4 = _React$__SECRET_INTER3.ReactCurrentDispatcher) === null || _React$__SECRET_INTER4 === void 0 ? void 0 : _React$__SECRET_INTER4.current;
    process.env.NODE_ENV !== "production" ? warning(RenderDispatcher == null || CurrentDispatcher !== RenderDispatcher, "Relay: `%s` should not be called inside a React render function.", (_options$__nameForWar = options === null || options === void 0 ? void 0 : options.__nameForWarning) !== null && _options$__nameForWar !== void 0 ? _options$__nameForWar : "loadQuery") : void 0;
    fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : "store-or-network";
    var networkCacheConfig = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
      force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource2(operation, networkObservable2) {
      didExecuteNetworkSource = true;
      return environment.executeWithSource({
        operation,
        source: networkObservable2
      });
    };
    var executionSubject = new ReplaySubject();
    var returnedObservable = Observable.create(function(sink) {
      return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest2(params2) {
      didMakeNetworkRequest = true;
      var observable;
      var subject = new ReplaySubject();
      if (RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) {
        var identifier = "raw-network-request-" + getRequestIdentifier(params2, variables);
        observable = fetchQueryDeduped(environment, identifier, function() {
          var network2 = environment.getNetwork();
          return network2.execute(params2, variables, networkCacheConfig);
        });
      } else {
        var network = environment.getNetwork();
        observable = network.execute(params2, variables, networkCacheConfig);
      }
      var _observable$subscribe = observable.subscribe({
        error: function error(err) {
          networkError = err;
          subject.error(err);
        },
        next: function next(data) {
          subject.next(data);
        },
        complete: function complete() {
          subject.complete();
        }
      }), unsubscribe = _observable$subscribe.unsubscribe;
      unsubscribeFromNetworkRequest = unsubscribe;
      return Observable.create(function(sink) {
        var subjectSubscription = subject.subscribe(sink);
        return function() {
          subjectSubscription.unsubscribe();
          unsubscribeFromNetworkRequest();
        };
      });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped2(operation, fetchFn) {
      if (RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) {
        didMakeNetworkRequest = true;
      }
      var _fetchQueryDeduped$su = fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
        error: function error(err) {
          executionSubject.error(err);
        },
        next: function next(data) {
          executionSubject.next(data);
        },
        complete: function complete() {
          executionSubject.complete();
        }
      });
      unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute2(concreteRequest) {
      var operation = createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
      retainReference = environment.retain(operation);
      if (fetchPolicy === "store-only") {
        return;
      }
      var shouldFetch = fetchPolicy !== "store-or-network" || environment.check(operation).status !== "available";
      if (shouldFetch) {
        executeDeduped(operation, function() {
          var networkObservable2 = makeNetworkRequest(concreteRequest.params);
          var executeObservable = executeWithNetworkSource(operation, networkObservable2);
          return executeObservable;
        });
      }
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === "PreloadableConcreteRequest") {
      var preloadableConcreteRequest = preloadableRequest;
      params = preloadableConcreteRequest.params;
      var _params = params;
      queryId = _params.id;
      !(queryId !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: `loadQuery` requires that preloadable query `%s` has a persisted query id", params.name) : invariant(false) : void 0;
      var _module = PreloadableQueryRegistry.get(queryId);
      if (_module != null) {
        checkAvailabilityAndExecute(_module);
      } else {
        var networkObservable = fetchPolicy === "store-only" ? null : makeNetworkRequest(params);
        var _PreloadableQueryRegi = PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
          cancelOnLoadCallback();
          var operation = createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
          retainReference = environment.retain(operation);
          if (networkObservable != null) {
            executeDeduped(operation, function() {
              return executeWithNetworkSource(operation, networkObservable);
            });
          }
        });
        cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
      }
    } else {
      var graphQlTaggedNode = preloadableRequest;
      var request = getRequest(graphQlTaggedNode);
      params = request.params;
      queryId = params.cacheID != null ? params.cacheID : params.id;
      checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery2() {
      if (isReleased) {
        return;
      }
      retainReference && retainReference.dispose();
      isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest2() {
      if (isNetworkRequestCancelled) {
        return;
      }
      if (didExecuteNetworkSource) {
        unsubscribeFromExecution && unsubscribeFromExecution();
      } else {
        unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
      }
      cancelOnLoadCallback && cancelOnLoadCallback();
      isNetworkRequestCancelled = true;
    };
    return {
      kind: "PreloadedQuery",
      environment,
      environmentProviderOptions,
      dispose: function dispose() {
        if (isDisposed) {
          return;
        }
        releaseQuery();
        cancelNetworkRequest();
        isDisposed = true;
      },
      releaseQuery,
      cancelNetworkRequest,
      fetchKey,
      id: queryId,
      get isDisposed() {
        return isDisposed || isReleased;
      },
      get networkError() {
        return networkError;
      },
      name: params.name,
      networkCacheConfig,
      fetchPolicy,
      source: didMakeNetworkRequest ? returnedObservable : void 0,
      variables
    };
  }
  loadQuery_1 = {
    loadQuery,
    useTrackLoadQueryInRender
  };
  return loadQuery_1;
}
var loadEntryPoint_1;
var hasRequiredLoadEntryPoint;
function requireLoadEntryPoint() {
  if (hasRequiredLoadEntryPoint) return loadEntryPoint_1;
  hasRequiredLoadEntryPoint = 1;
  var _require = requireLoadQuery(), loadQuery = _require.loadQuery;
  function loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) {
      loadingPromise = entryPoint.root.load();
    }
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
      var queriesPropNames = Object.keys(queries);
      queriesPropNames.forEach(function(queryPropName) {
        var _queries$queryPropNam = queries[queryPropName], environmentProviderOptions = _queries$queryPropNam.environmentProviderOptions, options = _queries$queryPropNam.options, parameters = _queries$queryPropNam.parameters, variables = _queries$queryPropNam.variables;
        var environment = environmentProvider.getEnvironment(environmentProviderOptions);
        preloadedQueries[queryPropName] = loadQuery(environment, parameters, variables, {
          fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
          networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
          __nameForWarning: "loadEntryPoint"
        }, environmentProviderOptions);
      });
    }
    if (entryPoints != null) {
      var entryPointPropNames = Object.keys(entryPoints);
      entryPointPropNames.forEach(function(entryPointPropName) {
        var entryPointDescription = entryPoints[entryPointPropName];
        if (entryPointDescription == null) {
          return;
        }
        var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
        preloadedEntryPoints[entryPointPropName] = loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
      });
    }
    var isDisposed = false;
    return {
      dispose: function dispose() {
        if (isDisposed) {
          return;
        }
        if (preloadedQueries != null) {
          Object.values(preloadedQueries).forEach(function(_ref) {
            var innerDispose = _ref.dispose;
            innerDispose();
          });
        }
        if (preloadedEntryPoints != null) {
          Object.values(preloadedEntryPoints).forEach(function(_ref2) {
            var innerDispose = _ref2.dispose;
            innerDispose();
          });
        }
        isDisposed = true;
      },
      entryPoints: preloadedEntryPoints,
      extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
      getComponent: function getComponent() {
        var componentModule = entryPoint.root.getModuleIfRequired();
        if (componentModule == null) {
          var _loadingPromise;
          loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
          throw loadingPromise;
        }
        var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
        return component;
      },
      get isDisposed() {
        return isDisposed;
      },
      queries: preloadedQueries,
      rootModuleID: entryPoint.root.getModuleId()
    };
  }
  loadEntryPoint_1 = loadEntryPoint;
  return loadEntryPoint_1;
}
var RelayEnvironmentProvider_1;
var hasRequiredRelayEnvironmentProvider;
function requireRelayEnvironmentProvider() {
  if (hasRequiredRelayEnvironmentProvider) return RelayEnvironmentProvider_1;
  hasRequiredRelayEnvironmentProvider = 1;
  var ReactRelayContext2 = requireReactRelayContext();
  var React = require$$0__default;
  var useMemo2 = React.useMemo;
  function RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = useMemo2(function() {
      return {
        environment,
        getEnvironmentForActor
      };
    }, [environment, getEnvironmentForActor]);
    return /* @__PURE__ */ React.createElement(ReactRelayContext2.Provider, {
      value: context
    }, children);
  }
  RelayEnvironmentProvider_1 = RelayEnvironmentProvider;
  return RelayEnvironmentProvider_1;
}
var LRUCache_1;
var hasRequiredLRUCache;
function requireLRUCache() {
  if (hasRequiredLRUCache) return LRUCache_1;
  hasRequiredLRUCache = 1;
  var invariant = requireBrowser();
  var LRUCache = /* @__PURE__ */ function() {
    function LRUCache2(capacity) {
      this._capacity = capacity;
      !(this._capacity > 0) ? process.env.NODE_ENV !== "production" ? invariant(false, "LRUCache: Unable to create instance of cache with zero or negative capacity.") : invariant(false) : void 0;
      this._map = /* @__PURE__ */ new Map();
    }
    var _proto = LRUCache2.prototype;
    _proto.set = function set(key, value) {
      this._map["delete"](key);
      this._map.set(key, value);
      if (this._map.size > this._capacity) {
        var firstKey = this._map.keys().next();
        if (!firstKey.done) {
          this._map["delete"](firstKey.value);
        }
      }
    };
    _proto.get = function get(key) {
      var value = this._map.get(key);
      if (value != null) {
        this._map["delete"](key);
        this._map.set(key, value);
      }
      return value;
    };
    _proto.has = function has(key) {
      return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
      this._map["delete"](key);
    };
    _proto.size = function size() {
      return this._map.size;
    };
    _proto.capacity = function capacity() {
      return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
      this._map.clear();
    };
    return LRUCache2;
  }();
  function create(capacity) {
    return new LRUCache(capacity);
  }
  LRUCache_1 = {
    create
  };
  return LRUCache_1;
}
var SuspenseResource_1;
var hasRequiredSuspenseResource;
function requireSuspenseResource() {
  if (hasRequiredSuspenseResource) return SuspenseResource_1;
  hasRequiredSuspenseResource = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
  var warning = requireWarning();
  var TEMPORARY_RETAIN_DURATION_MS = 5 * 60 * 1e3;
  var SuspenseResource = /* @__PURE__ */ function() {
    function SuspenseResource2(retain) {
      var _this = this;
      (0, _defineProperty2["default"])(this, "_retainCount", 0);
      (0, _defineProperty2["default"])(this, "_retainDisposable", null);
      (0, _defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
      this._retain = function(environment) {
        _this._retainCount++;
        if (_this._retainCount === 1) {
          _this._retainDisposable = retain(environment);
        }
        return {
          dispose: function dispose() {
            _this._retainCount = Math.max(0, _this._retainCount - 1);
            if (_this._retainCount === 0) {
              if (_this._retainDisposable != null) {
                _this._retainDisposable.dispose();
                _this._retainDisposable = null;
              } else {
                process.env.NODE_ENV !== "production" ? warning(false, "Relay: Expected disposable to release query to be defined.If you're seeing this, this is likely a bug in Relay.") : void 0;
              }
            }
          }
        };
      };
    }
    var _proto = SuspenseResource2.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
      var _this2 = this;
      var _this$_releaseTempora;
      if (environment.isServer()) {
        return {
          dispose: function dispose() {
          }
        };
      }
      var retention = this._retain(environment);
      var releaseQueryTimeout = null;
      var releaseTemporaryRetain = function releaseTemporaryRetain2() {
        clearTimeout(releaseQueryTimeout);
        releaseQueryTimeout = null;
        _this2._releaseTemporaryRetain = null;
        retention.dispose();
      };
      releaseQueryTimeout = setTimeout(releaseTemporaryRetain, TEMPORARY_RETAIN_DURATION_MS);
      (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 ? void 0 : _this$_releaseTempora.call(this);
      this._releaseTemporaryRetain = releaseTemporaryRetain;
      return {
        dispose: function dispose() {
          var _this$_releaseTempora2;
          (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 ? void 0 : _this$_releaseTempora2.call(_this2);
        }
      };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
      var disposable = this._retain(environment);
      this.releaseTemporaryRetain();
      return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
      var _this$_releaseTempora3;
      (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 ? void 0 : _this$_releaseTempora3.call(this);
      this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
      return this._retainCount;
    };
    return SuspenseResource2;
  }();
  SuspenseResource_1 = SuspenseResource;
  return SuspenseResource_1;
}
var QueryResource;
var hasRequiredQueryResource;
function requireQueryResource() {
  if (hasRequiredQueryResource) return QueryResource;
  hasRequiredQueryResource = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
  var LRUCache = requireLRUCache();
  var SuspenseResource = requireSuspenseResource();
  var invariant = requireBrowser();
  var _require = require$$11, isPromise = _require.isPromise;
  var warning = requireWarning();
  var CACHE_CAPACITY = 1e3;
  var DEFAULT_FETCH_POLICY = "store-or-network";
  var DEFAULT_LIVE_FETCH_POLICY = "store-and-network";
  var WEAKMAP_SUPPORTED = typeof WeakMap === "function";
  function operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== void 0;
  }
  function getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : operationIsLiveQuery(operation) ? DEFAULT_LIVE_FETCH_POLICY : DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) {
      return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    }
    return cacheIdentifier;
  }
  function getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
      __id: operation.fragment.dataID,
      __fragments: (0, _defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
      __fragmentOwner: operation.request
    };
    return {
      cacheIdentifier,
      fragmentNode: operation.request.node.fragment,
      fragmentRef: rootFragmentRef,
      operation
    };
  }
  var nextID = 2e5;
  function createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new SuspenseResource(function(environment) {
      var retention = environment.retain(operation);
      return {
        dispose: function dispose() {
          if (isLiveQuery && currentNetworkSubscription != null) {
            currentNetworkSubscription.unsubscribe();
          }
          retention.dispose();
          onDispose(cacheEntry);
        }
      };
    });
    var cacheEntry = {
      cacheIdentifier,
      id: nextID++,
      processedPayloadsCount: 0,
      operationAvailability,
      getValue: function getValue() {
        return currentValue;
      },
      setValue: function setValue(val) {
        currentValue = val;
      },
      setNetworkSubscription: function setNetworkSubscription(subscription) {
        if (isLiveQuery && currentNetworkSubscription != null) {
          currentNetworkSubscription.unsubscribe();
        }
        currentNetworkSubscription = subscription;
      },
      temporaryRetain: function temporaryRetain(environment) {
        return suspenseResource.temporaryRetain(environment);
      },
      permanentRetain: function permanentRetain(environment) {
        return suspenseResource.permanentRetain(environment);
      },
      releaseTemporaryRetain: function releaseTemporaryRetain() {
        suspenseResource.releaseTemporaryRetain();
      }
    };
    return cacheEntry;
  }
  var QueryResourceImpl = /* @__PURE__ */ function() {
    function QueryResourceImpl2(environment) {
      var _this = this;
      (0, _defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
        _this._cache["delete"](cacheEntry.cacheIdentifier);
      });
      this._environment = environment;
      this._cache = LRUCache.create(CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl2.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
      var cacheIdentifier = getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
      return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
      var environment = this._environment;
      var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : operationIsLiveQuery(operation) ? DEFAULT_LIVE_FETCH_POLICY : DEFAULT_FETCH_POLICY;
      var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
      var cacheEntry = this._cache.get(cacheIdentifier);
      var temporaryRetainDisposable = null;
      var entryWasCached = cacheEntry != null;
      if (cacheEntry == null) {
        cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, observer), {}, {
          unsubscribe: function unsubscribe(subscription) {
            if (temporaryRetainDisposable != null) {
              temporaryRetainDisposable.dispose();
            }
            var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
            observerUnsubscribe && observerUnsubscribe(subscription);
          }
        }));
      }
      temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
      var cachedValue = cacheEntry.getValue();
      if (isPromise(cachedValue)) {
        environment.__log({
          name: "suspense.query",
          fetchPolicy,
          isPromiseCached: entryWasCached,
          operation,
          queryAvailability: cacheEntry.operationAvailability,
          renderPolicy
        });
        throw cachedValue;
      }
      if (cachedValue instanceof Error) {
        throw cachedValue;
      }
      return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
      var environment = this._environment;
      var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
      var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
      var disposable = cacheEntry.permanentRetain(environment);
      environment.__log({
        name: "queryresource.retain",
        profilerContext,
        resourceID: cacheEntry.id
      });
      return {
        dispose: function dispose() {
          disposable.dispose();
        }
      };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
      var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
      if (cacheEntry != null) {
        cacheEntry.releaseTemporaryRetain();
      }
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
      var environment = this._environment;
      var cacheIdentifier = getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
      return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
      var cacheEntry = this._cache.get(cacheIdentifier);
      if (cacheEntry == null) {
        cacheEntry = createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
        this._cache.set(cacheIdentifier, cacheEntry);
      }
      return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
      var _this2 = this;
      var environment = this._environment;
      var queryAvailability = environment.check(operation);
      var queryStatus = queryAvailability.status;
      var hasFullQuery = queryStatus === "available";
      var canPartialRender = hasFullQuery || renderPolicy === "partial" && queryStatus !== "stale";
      var shouldFetch;
      var shouldAllowRender;
      var resolveNetworkPromise = function resolveNetworkPromise2() {
      };
      switch (fetchPolicy) {
        case "store-only": {
          shouldFetch = false;
          shouldAllowRender = true;
          break;
        }
        case "store-or-network": {
          shouldFetch = !hasFullQuery;
          shouldAllowRender = canPartialRender;
          break;
        }
        case "store-and-network": {
          shouldFetch = true;
          shouldAllowRender = canPartialRender;
          break;
        }
        case "network-only":
        default: {
          shouldFetch = true;
          shouldAllowRender = false;
          break;
        }
      }
      if (shouldAllowRender) {
        var queryResult = getQueryResult(operation, cacheIdentifier);
        var _cacheEntry = createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
        this._cache.set(cacheIdentifier, _cacheEntry);
      }
      if (shouldFetch) {
        var _queryResult = getQueryResult(operation, cacheIdentifier);
        var networkSubscription;
        fetchObservable.subscribe({
          start: function start(subscription) {
            networkSubscription = subscription;
            var cacheEntry2 = _this2._cache.get(cacheIdentifier);
            if (cacheEntry2) {
              cacheEntry2.setNetworkSubscription(networkSubscription);
            }
            var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
            if (observerStart) {
              var subscriptionWithConditionalCancelation = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, subscription), {}, {
                unsubscribe: function unsubscribe() {
                  if (operationIsLiveQuery(operation)) {
                    subscription.unsubscribe();
                  }
                }
              });
              observerStart(subscriptionWithConditionalCancelation);
            }
          },
          next: function next() {
            var cacheEntry2 = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
            cacheEntry2.processedPayloadsCount += 1;
            cacheEntry2.setValue(_queryResult);
            resolveNetworkPromise();
            var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
            if (observerNext != null) {
              var snapshot = environment.lookup(operation.fragment);
              observerNext(snapshot);
            }
          },
          error: function error(_error) {
            var cacheEntry2 = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
            if (cacheEntry2.processedPayloadsCount === 0) {
              cacheEntry2.setValue(_error);
            } else {
              process.env.NODE_ENV !== "production" ? warning(false, "QueryResource: An incremental payload for query `%s` returned an error: `%s`.", operation.fragment.node.name, String(_error.message)) : void 0;
            }
            resolveNetworkPromise();
            networkSubscription = null;
            cacheEntry2.setNetworkSubscription(null);
            var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
            observerError && observerError(_error);
          },
          complete: function complete() {
            resolveNetworkPromise();
            networkSubscription = null;
            var cacheEntry2 = _this2._cache.get(cacheIdentifier);
            if (cacheEntry2) {
              cacheEntry2.setNetworkSubscription(null);
            }
            var observerComplete2 = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete2 && observerComplete2();
          },
          unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
        });
        var _cacheEntry2 = this._cache.get(cacheIdentifier);
        if (!_cacheEntry2) {
          var networkPromise = new Promise(function(resolve) {
            resolveNetworkPromise = resolve;
          });
          networkPromise.displayName = "Relay(" + operation.fragment.node.name + ")";
          _cacheEntry2 = createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
          this._cache.set(cacheIdentifier, _cacheEntry2);
        }
      } else {
        var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
        observerComplete && observerComplete();
      }
      var cacheEntry = this._cache.get(cacheIdentifier);
      !(cacheEntry != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected to have cached a result when attempting to fetch query.If you're seeing this, this is likely a bug in Relay.") : invariant(false) : void 0;
      environment.__log({
        name: "queryresource.fetch",
        resourceID: cacheEntry.id,
        operation,
        profilerContext,
        fetchPolicy,
        renderPolicy,
        queryAvailability,
        shouldFetch
      });
      return cacheEntry;
    };
    return QueryResourceImpl2;
  }();
  function createQueryResource(environment) {
    return new QueryResourceImpl(environment);
  }
  var dataResources = WEAKMAP_SUPPORTED ? /* @__PURE__ */ new WeakMap() : /* @__PURE__ */ new Map();
  function getQueryResourceForEnvironment(environment) {
    var cached = dataResources.get(environment);
    if (cached) {
      return cached;
    }
    var newDataResource = createQueryResource(environment);
    dataResources.set(environment, newDataResource);
    return newDataResource;
  }
  QueryResource = {
    createQueryResource,
    getQueryResourceForEnvironment,
    getQueryCacheIdentifier
  };
  return QueryResource;
}
var useUnsafeRef_DEPRECATED_1;
var hasRequiredUseUnsafeRef_DEPRECATED;
function requireUseUnsafeRef_DEPRECATED() {
  if (hasRequiredUseUnsafeRef_DEPRECATED) return useUnsafeRef_DEPRECATED_1;
  hasRequiredUseUnsafeRef_DEPRECATED = 1;
  var _require = require$$0__default, useMemo2 = _require.useMemo;
  function useUnsafeRef_DEPRECATED(init) {
    return useMemo2(function() {
      return {
        current: init
      };
    }, []);
  }
  useUnsafeRef_DEPRECATED_1 = useUnsafeRef_DEPRECATED;
  return useUnsafeRef_DEPRECATED_1;
}
var useFetchTrackingRef_1;
var hasRequiredUseFetchTrackingRef;
function requireUseFetchTrackingRef() {
  if (hasRequiredUseFetchTrackingRef) return useFetchTrackingRef_1;
  hasRequiredUseFetchTrackingRef = 1;
  var useUnsafeRef_DEPRECATED = requireUseUnsafeRef_DEPRECATED();
  var _require = require$$0__default, useCallback2 = _require.useCallback, useEffect2 = _require.useEffect;
  function useFetchTrackingRef() {
    var subscriptionRef = useUnsafeRef_DEPRECATED(null);
    var isFetchingRef = useUnsafeRef_DEPRECATED(false);
    var disposeFetch = useCallback2(function() {
      if (subscriptionRef.current != null) {
        subscriptionRef.current.unsubscribe();
        subscriptionRef.current = null;
      }
      isFetchingRef.current = false;
    }, []);
    var startFetch = useCallback2(function(subscription) {
      subscriptionRef.current = subscription;
      isFetchingRef.current = true;
    }, []);
    var completeFetch = useCallback2(function() {
      subscriptionRef.current = null;
      isFetchingRef.current = false;
    }, []);
    useEffect2(function() {
      return disposeFetch;
    }, [disposeFetch]);
    return {
      isFetchingRef,
      startFetch,
      disposeFetch,
      completeFetch
    };
  }
  useFetchTrackingRef_1 = useFetchTrackingRef;
  return useFetchTrackingRef_1;
}
var createForOfIteratorHelper = { exports: {} };
var unsupportedIterableToArray = { exports: {} };
var arrayLikeToArray = { exports: {} };
var hasRequiredArrayLikeToArray;
function requireArrayLikeToArray() {
  if (hasRequiredArrayLikeToArray) return arrayLikeToArray.exports;
  hasRequiredArrayLikeToArray = 1;
  (function(module) {
    function _arrayLikeToArray(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n2 = Array(a); e < a; e++) n2[e] = r[e];
      return n2;
    }
    module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(arrayLikeToArray);
  return arrayLikeToArray.exports;
}
var hasRequiredUnsupportedIterableToArray;
function requireUnsupportedIterableToArray() {
  if (hasRequiredUnsupportedIterableToArray) return unsupportedIterableToArray.exports;
  hasRequiredUnsupportedIterableToArray = 1;
  (function(module) {
    var arrayLikeToArray2 = requireArrayLikeToArray();
    function _unsupportedIterableToArray(r, a) {
      if (r) {
        if ("string" == typeof r) return arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray2(r, a) : void 0;
      }
    }
    module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(unsupportedIterableToArray);
  return unsupportedIterableToArray.exports;
}
var hasRequiredCreateForOfIteratorHelper;
function requireCreateForOfIteratorHelper() {
  if (hasRequiredCreateForOfIteratorHelper) return createForOfIteratorHelper.exports;
  hasRequiredCreateForOfIteratorHelper = 1;
  (function(module) {
    var unsupportedIterableToArray2 = requireUnsupportedIterableToArray();
    function _createForOfIteratorHelper(r, e) {
      var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (!t) {
        if (Array.isArray(r) || (t = unsupportedIterableToArray2(r)) || e && r && "number" == typeof r.length) {
          t && (r = t);
          var _n = 0, F = function F2() {
          };
          return {
            s: F,
            n: function n2() {
              return _n >= r.length ? {
                done: true
              } : {
                done: false,
                value: r[_n++]
              };
            },
            e: function e2(r2) {
              throw r2;
            },
            f: F
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var o, a = true, u = false;
      return {
        s: function s2() {
          t = t.call(r);
        },
        n: function n2() {
          var r2 = t.next();
          return a = r2.done, r2;
        },
        e: function e2(r2) {
          u = true, o = r2;
        },
        f: function f() {
          try {
            a || null == t["return"] || t["return"]();
          } finally {
            if (u) throw o;
          }
        }
      };
    }
    module.exports = _createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(createForOfIteratorHelper);
  return createForOfIteratorHelper.exports;
}
var toConsumableArray = { exports: {} };
var arrayWithoutHoles = { exports: {} };
var hasRequiredArrayWithoutHoles;
function requireArrayWithoutHoles() {
  if (hasRequiredArrayWithoutHoles) return arrayWithoutHoles.exports;
  hasRequiredArrayWithoutHoles = 1;
  (function(module) {
    var arrayLikeToArray2 = requireArrayLikeToArray();
    function _arrayWithoutHoles(r) {
      if (Array.isArray(r)) return arrayLikeToArray2(r);
    }
    module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(arrayWithoutHoles);
  return arrayWithoutHoles.exports;
}
var iterableToArray = { exports: {} };
var hasRequiredIterableToArray;
function requireIterableToArray() {
  if (hasRequiredIterableToArray) return iterableToArray.exports;
  hasRequiredIterableToArray = 1;
  (function(module) {
    function _iterableToArray(r) {
      if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(iterableToArray);
  return iterableToArray.exports;
}
var nonIterableSpread = { exports: {} };
var hasRequiredNonIterableSpread;
function requireNonIterableSpread() {
  if (hasRequiredNonIterableSpread) return nonIterableSpread.exports;
  hasRequiredNonIterableSpread = 1;
  (function(module) {
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(nonIterableSpread);
  return nonIterableSpread.exports;
}
var hasRequiredToConsumableArray;
function requireToConsumableArray() {
  if (hasRequiredToConsumableArray) return toConsumableArray.exports;
  hasRequiredToConsumableArray = 1;
  (function(module) {
    var arrayWithoutHoles2 = requireArrayWithoutHoles();
    var iterableToArray2 = requireIterableToArray();
    var unsupportedIterableToArray2 = requireUnsupportedIterableToArray();
    var nonIterableSpread2 = requireNonIterableSpread();
    function _toConsumableArray(r) {
      return arrayWithoutHoles2(r) || iterableToArray2(r) || unsupportedIterableToArray2(r) || nonIterableSpread2();
    }
    module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(toConsumableArray);
  return toConsumableArray.exports;
}
var useFragmentInternal_1;
var hasRequiredUseFragmentInternal;
function requireUseFragmentInternal() {
  if (hasRequiredUseFragmentInternal) return useFragmentInternal_1;
  hasRequiredUseFragmentInternal = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var _createForOfIteratorHelper2 = _interopRequireDefault(requireCreateForOfIteratorHelper());
  var _toConsumableArray2 = _interopRequireDefault(requireToConsumableArray());
  var _require = requireQueryResource(), getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
  var useRelayEnvironment = requireUseRelayEnvironment();
  var invariant = requireBrowser();
  var _require2 = require$$0__default, useDebugValue = _require2.useDebugValue, useEffect2 = _require2.useEffect, useMemo2 = _require2.useMemo, useRef2 = _require2.useRef, useState2 = _require2.useState;
  var _require3 = require$$11, _require3$__internal = _require3.__internal, fetchQueryInternal = _require3$__internal.fetchQuery, getPromiseForActiveRequest = _require3$__internal.getPromiseForActiveRequest, RelayFeatureFlags = _require3.RelayFeatureFlags, areEqualSelectors = _require3.areEqualSelectors, createOperationDescriptor = _require3.createOperationDescriptor, getPendingOperationsForFragment = _require3.getPendingOperationsForFragment, getSelector = _require3.getSelector, getVariablesFromFragment = _require3.getVariablesFromFragment, handlePotentialSnapshotErrors = _require3.handlePotentialSnapshotErrors, recycleNodesInto = _require3.recycleNodesInto;
  var warning = requireWarning();
  function isMissingData(state) {
    if (state.kind === "bailout") {
      return false;
    } else if (state.kind === "singular") {
      return state.snapshot.isMissingData;
    } else {
      return state.snapshots.some(function(s2) {
        return s2.isMissingData;
      });
    }
  }
  function getMissingClientEdges(state) {
    if (state.kind === "bailout") {
      return null;
    } else if (state.kind === "singular") {
      var _state$snapshot$missi;
      return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
      var edges = null;
      var _iterator = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var snapshot = _step.value;
          if (snapshot.missingClientEdges) {
            var _edges;
            edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                var edge = _step2.value;
                edges.push(edge);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return edges;
    }
  }
  function getSuspendingLiveResolver(state) {
    if (state.kind === "bailout") {
      return null;
    } else if (state.kind === "singular") {
      var _state$snapshot$missi2;
      return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
      var missingFields = null;
      var _iterator3 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
          var snapshot = _step3.value;
          if (snapshot.missingLiveResolverFields) {
            var _missingFields;
            missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
            var _iterator4 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
                var edge = _step4.value;
                missingFields.push(edge);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return missingFields;
    }
  }
  function handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === "singular") {
      var _state$snapshot$selec, _state$snapshot$selec2;
      handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === "plural") {
      var _iterator5 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
          var _snapshot$selector$no, _snapshot$selector$no2;
          var snapshot = _step5.value;
          handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }
  function handleMissedUpdates(environment, state) {
    if (state.kind === "bailout") {
      return null;
    }
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) {
      return null;
    }
    if (state.kind === "singular") {
      var currentSnapshot = environment.lookup(state.snapshot.selector);
      var updatedData = recycleNodesInto(state.snapshot.data, currentSnapshot.data);
      var updatedCurrentSnapshot = {
        data: updatedData,
        isMissingData: currentSnapshot.isMissingData,
        missingClientEdges: currentSnapshot.missingClientEdges,
        missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
        seenRecords: currentSnapshot.seenRecords,
        selector: currentSnapshot.selector,
        missingRequiredFields: currentSnapshot.missingRequiredFields,
        relayResolverErrors: currentSnapshot.relayResolverErrors,
        errorResponseFields: currentSnapshot.errorResponseFields
      };
      return [updatedData !== state.snapshot.data, {
        kind: "singular",
        snapshot: updatedCurrentSnapshot,
        epoch: currentEpoch
      }];
    } else {
      var didMissUpdates = false;
      var currentSnapshots = [];
      for (var index = 0; index < state.snapshots.length; index++) {
        var snapshot = state.snapshots[index];
        var _currentSnapshot = environment.lookup(snapshot.selector);
        var _updatedData = recycleNodesInto(snapshot.data, _currentSnapshot.data);
        var _updatedCurrentSnapshot = {
          data: _updatedData,
          isMissingData: _currentSnapshot.isMissingData,
          missingClientEdges: _currentSnapshot.missingClientEdges,
          missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
          seenRecords: _currentSnapshot.seenRecords,
          selector: _currentSnapshot.selector,
          missingRequiredFields: _currentSnapshot.missingRequiredFields,
          relayResolverErrors: _currentSnapshot.relayResolverErrors,
          errorResponseFields: _currentSnapshot.errorResponseFields
        };
        if (_updatedData !== snapshot.data) {
          didMissUpdates = true;
        }
        currentSnapshots.push(_updatedCurrentSnapshot);
      }
      !(currentSnapshots.length === state.snapshots.length) ? process.env.NODE_ENV !== "production" ? invariant(false, "Expected same number of snapshots") : invariant(false) : void 0;
      return [didMissUpdates, {
        kind: "plural",
        snapshots: currentSnapshots,
        epoch: currentEpoch
      }];
    }
  }
  function handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, originalVariables), {}, {
      id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource2 = getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource2.prepare(queryOperationDescriptor, fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [queryResult, getPromiseForActiveRequest(environment, queryOperationDescriptor.request)];
  }
  function subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === "bailout") {
      return function() {
      };
    } else if (state.kind === "singular") {
      var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
        setState(function(prevState) {
          if (prevState.kind !== "singular" || prevState.snapshot.selector !== latestSnapshot.selector) {
            var updates = handleMissedUpdates(environment, prevState);
            if (updates != null) {
              var dataChanged = updates[0], nextState = updates[1];
              environment.__log({
                name: "useFragment.subscription.missedUpdates",
                hasDataChanges: dataChanged
              });
              hasPendingStateChanges.current = dataChanged;
              return dataChanged ? nextState : prevState;
            } else {
              return prevState;
            }
          }
          hasPendingStateChanges.current = true;
          return {
            kind: "singular",
            snapshot: latestSnapshot,
            epoch: environment.getStore().getEpoch()
          };
        });
      });
      return function() {
        disposable.dispose();
      };
    } else {
      var disposables = state.snapshots.map(function(snapshot, index) {
        return environment.subscribe(snapshot, function(latestSnapshot) {
          setState(function(prevState) {
            var _prevState$snapshots$;
            if (prevState.kind !== "plural" || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
              var updates = handleMissedUpdates(environment, prevState);
              if (updates != null) {
                var dataChanged = updates[0], nextState = updates[1];
                environment.__log({
                  name: "useFragment.subscription.missedUpdates",
                  hasDataChanges: dataChanged
                });
                hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                return dataChanged ? nextState : prevState;
              } else {
                return prevState;
              }
            }
            var updated = (0, _toConsumableArray2["default"])(prevState.snapshots);
            updated[index] = latestSnapshot;
            hasPendingStateChanges.current = true;
            return {
              kind: "plural",
              snapshots: updated,
              epoch: environment.getStore().getEpoch()
            };
          });
        });
      });
      return function() {
        var _iterator6 = (0, _createForOfIteratorHelper2["default"])(disposables), _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done; ) {
            var d = _step6.value;
            d.dispose();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      };
    }
  }
  function getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) {
      return {
        kind: "bailout"
      };
    } else if (fragmentSelector.kind === "PluralReaderSelector") {
      return {
        kind: "plural",
        snapshots: fragmentSelector.selectors.map(function(s2) {
          return environment.lookup(s2);
        }),
        epoch: environment.getStore().getEpoch()
      };
    } else {
      return {
        kind: "singular",
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
      };
    }
  }
  function useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = useMemo2(function() {
      return getSelector(fragmentNode, fragmentRef);
    }, [fragmentNode, fragmentRef]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) {
      !(fragmentRef == null || Array.isArray(fragmentRef)) ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected fragment pointer%s for fragment `%s` to be an array, instead got `%s`. Remove `@relay(plural: true)` from fragment `%s` to allow the prop to be an object.", fragmentNode.name, typeof fragmentRef, fragmentNode.name) : invariant(false) : void 0;
    } else {
      !!Array.isArray(fragmentRef) ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected fragment pointer%s for fragment `%s` not to be an array, instead got `%s`. Add `@relay(plural: true)` to fragment `%s` to allow the prop to be an array.", fragmentNode.name, typeof fragmentRef, fragmentNode.name) : invariant(false) : void 0;
    }
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected to receive an object where `...%s` was spread, but the fragment reference was not found`. This is most likely the result of:\n- Forgetting to spread `%s` in `%s`'s parent's fragment.\n- Conditionally fetching `%s` but unconditionally passing %s prop to `%s`. If the parent fragment only fetches the fragment conditionally - with e.g. `@include`, `@skip`, or inside a `... on SomeType { }` spread  - then the fragment reference will not exist. In this case, pass `null` if the conditions for evaluating the fragment are not met (e.g. if the `@include(if)` value is false.)", fragmentNode.name, fragmentNode.name, hookDisplayName, fragmentNode.name, hookDisplayName) : invariant(false) : void 0;
    var environment = useRelayEnvironment();
    var _useState = useState2(function() {
      return getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = useState2(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = useState2(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = useState2(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
      setPreviousFragmentSelector(fragmentSelector);
      setPreviousEnvironment(environment);
      var newState = getFragmentState(environment, fragmentSelector);
      setState(newState);
      setSubscribedState(newState);
      state = newState;
      subscribedState = newState;
    }
    var committedFragmentSelectorRef = useRef2(false);
    useEffect2(function() {
      committedFragmentSelectorRef.current = fragmentSelector;
    }, [fragmentSelector]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
      var _useMemo = useMemo2(function() {
        var missingClientEdges = getMissingClientEdges(state);
        var clientEdgeQueries2;
        var activeRequestPromises2 = [];
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
          clientEdgeQueries2 = [];
          var _iterator7 = (0, _createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done; ) {
              var edge = _step7.value;
              var _handleMissingClientE = handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
              clientEdgeQueries2.push(queryResult);
              if (requestPromise != null) {
                activeRequestPromises2.push(requestPromise);
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
        return [clientEdgeQueries2, activeRequestPromises2];
      }, [state, environment, fragmentNode, fragmentRef, queryOptions]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
      if (activeRequestPromises.length) {
        throw Promise.all(activeRequestPromises);
      }
      useEffect2(function() {
        var QueryResource2 = getQueryResourceForEnvironment(environment);
        if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
          var disposables = [];
          var _iterator8 = (0, _createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done; ) {
              var query = _step8.value;
              disposables.push(QueryResource2.retain(query));
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
          return function() {
            var _iterator9 = (0, _createForOfIteratorHelper2["default"])(disposables), _step9;
            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done; ) {
                var disposable = _step9.value;
                disposable.dispose();
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          };
        }
      }, [environment, clientEdgeQueries]);
    }
    if (isMissingData(state)) {
      var suspendingLiveResolvers = getSuspendingLiveResolver(state);
      if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) {
        throw Promise.all(suspendingLiveResolvers.map(function(_ref) {
          var liveStateID = _ref.liveStateID;
          return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
      }
      if (RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
        !(fragmentSelector != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "refinement, see invariants above") : invariant(false) : void 0;
        var fragmentOwner = fragmentSelector.kind === "PluralReaderSelector" ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) {
          throw pendingOperationsResult.promise;
        }
      }
    }
    handlePotentialSnapshotErrorsForState(environment, state);
    var hasPendingStateChanges = useRef2(false);
    useEffect2(function() {
      var currentState = subscribedState;
      var updates2 = handleMissedUpdates(environment, subscribedState);
      if (updates2 !== null) {
        var didMissUpdates = updates2[0], updatedState2 = updates2[1];
        if (didMissUpdates) {
          setState(updatedState2);
        }
        currentState = updatedState2;
      }
      return subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [environment, subscribedState]);
    if (hasPendingStateChanges.current) {
      var updates = handleMissedUpdates(environment, state);
      if (updates != null) {
        var hasStateUpdates = updates[0], updatedState = updates[1];
        if (hasStateUpdates) {
          setState(updatedState);
          state = updatedState;
        }
      }
      hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
      var fragmentRefIsNullish = fragmentRef == null;
      data = useMemo2(function() {
        if (state.kind === "bailout") {
          return fragmentRefIsNullish ? null : [];
        } else {
          !(state.kind === "plural") ? process.env.NODE_ENV !== "production" ? invariant(false, "Expected state to be plural because fragment is plural") : invariant(false) : void 0;
          return state.snapshots.map(function(s2) {
            return s2.data;
          });
        }
      }, [state, fragmentRefIsNullish]);
    } else if (state.kind === "bailout") {
      data = null;
    } else {
      !(state.kind === "singular") ? process.env.NODE_ENV !== "production" ? invariant(false, "Expected state to be singular because fragment is singular") : invariant(false) : void 0;
      data = state.snapshot.data;
    }
    if (RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || process.env.NODE_ENV !== "production") {
      if (fragmentRef != null && (data === void 0 || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === void 0;
      }))) {
        process.env.NODE_ENV !== "production" ? warning(false, "Relay: Expected to have been able to read non-null data for fragment `%s` declared in `%s`, since fragment reference was non-null. Make sure that that `%s`'s parent isn't holding on to and/or passing a fragment reference for data that has been deleted.", fragmentNode.name, hookDisplayName, hookDisplayName) : void 0;
      }
    }
    if (process.env.NODE_ENV !== "production") {
      useDebugValue({
        fragment: fragmentNode.name,
        data
      });
    }
    return data;
  }
  useFragmentInternal_1 = useFragmentInternal;
  return useFragmentInternal_1;
}
var useLazyLoadQueryNode_1;
var hasRequiredUseLazyLoadQueryNode;
function requireUseLazyLoadQueryNode() {
  if (hasRequiredUseLazyLoadQueryNode) return useLazyLoadQueryNode_1;
  hasRequiredUseLazyLoadQueryNode = 1;
  var ProfilerContext = requireProfilerContext();
  var _require = requireQueryResource(), getQueryCacheIdentifier = _require.getQueryCacheIdentifier, getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
  var useFetchTrackingRef = requireUseFetchTrackingRef();
  var useFragmentInternal = requireUseFragmentInternal();
  var useRelayEnvironment = requireUseRelayEnvironment();
  var React = require$$0__default;
  var useContext2 = React.useContext, useEffect2 = React.useEffect, useState2 = React.useState, useRef2 = React.useRef;
  function useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = useRelayEnvironment();
    var profilerContext = useContext2(ProfilerContext);
    var QueryResource2 = getQueryResourceForEnvironment(environment);
    var _useState = useState2(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = useFetchTrackingRef(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : "");
    var cacheIdentifier = getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
      return QueryResource2.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
        start: startFetch,
        complete: completeFetch,
        error: completeFetch
      }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = useRef2(false);
    useEffect2(function() {
      return function() {
        maybeHiddenOrFastRefresh.current = true;
      };
    }, []);
    useEffect2(function() {
      if (maybeHiddenOrFastRefresh.current === true) {
        maybeHiddenOrFastRefresh.current = false;
        forceUpdate(function(n2) {
          return n2 + 1;
        });
        return;
      }
      var disposable = QueryResource2.retain(preparedQueryResult, profilerContext);
      return function() {
        disposable.dispose();
      };
    }, [environment, cacheIdentifier]);
    useEffect2(function() {
      QueryResource2.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = useFragmentInternal(fragmentNode, fragmentRef, componentDisplayName);
    return data;
  }
  useLazyLoadQueryNode_1 = useLazyLoadQueryNode;
  return useLazyLoadQueryNode_1;
}
var useMemoVariables_1;
var hasRequiredUseMemoVariables;
function requireUseMemoVariables() {
  if (hasRequiredUseMemoVariables) return useMemoVariables_1;
  hasRequiredUseMemoVariables = 1;
  var areEqual = requireAreEqual();
  var _require = require$$0__default, useState2 = _require.useState;
  function useMemoVariables(variables) {
    var _useState = useState2(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if (areEqual(variables, mirroredVariables)) {
      return mirroredVariables;
    } else {
      setMirroredVariables(variables);
      return variables;
    }
  }
  useMemoVariables_1 = useMemoVariables;
  return useMemoVariables_1;
}
var useMemoOperationDescriptor_1;
var hasRequiredUseMemoOperationDescriptor;
function requireUseMemoOperationDescriptor() {
  if (hasRequiredUseMemoOperationDescriptor) return useMemoOperationDescriptor_1;
  hasRequiredUseMemoOperationDescriptor = 1;
  var useMemoVariables = requireUseMemoVariables();
  var React = require$$0__default;
  var _require = require$$11, createOperationDescriptor = _require.createOperationDescriptor, getRequest = _require.getRequest;
  var useMemo2 = React.useMemo;
  function useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = useMemoVariables(variables);
    var memoCacheConfig = useMemoVariables(cacheConfig || {});
    return useMemo2(function() {
      return createOperationDescriptor(getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [gqlQuery, memoVariables, memoCacheConfig]);
  }
  useMemoOperationDescriptor_1 = useMemoOperationDescriptor;
  return useMemoOperationDescriptor_1;
}
var useLazyLoadQuery_1;
var hasRequiredUseLazyLoadQuery;
function requireUseLazyLoadQuery() {
  if (hasRequiredUseLazyLoadQuery) return useLazyLoadQuery_1;
  hasRequiredUseLazyLoadQuery = 1;
  var _require = requireLoadQuery(), useTrackLoadQueryInRender = _require.useTrackLoadQueryInRender;
  var useLazyLoadQueryNode = requireUseLazyLoadQueryNode();
  var useMemoOperationDescriptor = requireUseMemoOperationDescriptor();
  var useRelayEnvironment = requireUseRelayEnvironment();
  var _require2 = require$$11, fetchQuery = _require2.__internal.fetchQuery;
  function useLazyLoadQuery(gqlQuery, variables, options) {
    useTrackLoadQueryInRender();
    var environment = useRelayEnvironment();
    var query = useMemoOperationDescriptor(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
      force: true
    });
    var data = useLazyLoadQueryNode({
      componentDisplayName: "useLazyLoadQuery()",
      fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
      fetchObservable: fetchQuery(environment, query),
      fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
      query,
      renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
  }
  useLazyLoadQuery_1 = useLazyLoadQuery;
  return useLazyLoadQuery_1;
}
var useClientQuery_1;
var hasRequiredUseClientQuery;
function requireUseClientQuery() {
  if (hasRequiredUseClientQuery) return useClientQuery_1;
  hasRequiredUseClientQuery = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var useLazyLoadQuery = requireUseLazyLoadQuery();
  function useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return useLazyLoadQuery(query, variables, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options), {}, {
      fetchPolicy: "store-only"
    }));
  }
  useClientQuery_1 = useClientQuery;
  return useClientQuery_1;
}
var useIsMountedRef_1;
var hasRequiredUseIsMountedRef;
function requireUseIsMountedRef() {
  if (hasRequiredUseIsMountedRef) return useIsMountedRef_1;
  hasRequiredUseIsMountedRef = 1;
  var _require = require$$0__default, useEffect2 = _require.useEffect, useRef2 = _require.useRef;
  function useIsMountedRef() {
    var isMountedRef = useRef2(true);
    useEffect2(function() {
      isMountedRef.current = true;
      return function() {
        isMountedRef.current = false;
      };
    }, []);
    return isMountedRef;
  }
  useIsMountedRef_1 = useIsMountedRef;
  return useIsMountedRef_1;
}
var useEntryPointLoader;
var hasRequiredUseEntryPointLoader;
function requireUseEntryPointLoader() {
  if (hasRequiredUseEntryPointLoader) return useEntryPointLoader;
  hasRequiredUseEntryPointLoader = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _createForOfIteratorHelper2 = _interopRequireDefault(requireCreateForOfIteratorHelper());
  var loadEntryPoint = requireLoadEntryPoint();
  var _require = requireLoadQuery(), useTrackLoadQueryInRender = _require.useTrackLoadQueryInRender;
  var useIsMountedRef = requireUseIsMountedRef();
  var _require2 = require$$0__default, useCallback2 = _require2.useCallback, useEffect2 = _require2.useEffect, useRef2 = _require2.useRef, useState2 = _require2.useState;
  var initialNullEntryPointReferenceState = {
    kind: "NullEntryPointReference"
  };
  function useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    useTrackLoadQueryInRender();
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = useIsMountedRef();
    var undisposedEntryPointReferencesRef = useRef2(/* @__PURE__ */ new Set([initialEntryPointReferenceInternal]));
    var _useState = useState2(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = useState2(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = useCallback2(function() {
      if (isMountedRef.current) {
        var nullEntryPointReference = {
          kind: "NullEntryPointReference"
        };
        undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
        setEntryPointReference(nullEntryPointReference);
      }
    }, [setEntryPointReference, isMountedRef]);
    var entryPointLoaderCallback = useCallback2(function(params) {
      if (isMountedRef.current) {
        var updatedEntryPointReference = loadEntryPoint(environmentProvider, entryPoint, params);
        undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
        setEntryPointReference(updatedEntryPointReference);
        setEntryPointParams(params);
      }
    }, [environmentProvider, entryPoint, setEntryPointReference, isMountedRef]);
    var maybeHiddenOrFastRefresh = useRef2(false);
    useEffect2(function() {
      return function() {
        maybeHiddenOrFastRefresh.current = true;
      };
    }, []);
    useEffect2(function() {
      if (maybeHiddenOrFastRefresh.current === true) {
        maybeHiddenOrFastRefresh.current = false;
        if (entryPointReference.kind !== "NullEntryPointReference" && entryPointParams != null) {
          entryPointLoaderCallback(entryPointParams);
        }
        return;
      }
      var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
      if (isMountedRef.current) {
        var _iterator = (0, _createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var undisposedEntryPointReference = _step.value;
            if (undisposedEntryPointReference === entryPointReference) {
              break;
            }
            undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
            if (undisposedEntryPointReference.kind !== "NullEntryPointReference") {
              undisposedEntryPointReference.dispose();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, [entryPointReference, entryPointParams, entryPointLoaderCallback, isMountedRef]);
    useEffect2(function() {
      return function disposeAllRemainingEntryPointReferences() {
        var _iterator2 = (0, _createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
            var unhandledStateChange = _step2.value;
            if (unhandledStateChange.kind !== "NullEntryPointReference") {
              unhandledStateChange.dispose();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };
    }, []);
    return [entryPointReference.kind === "NullEntryPointReference" ? null : entryPointReference, entryPointLoaderCallback, disposeEntryPoint];
  }
  useEntryPointLoader = useLoadEntryPoint;
  return useEntryPointLoader;
}
var useStaticFragmentNodeWarning_1;
var hasRequiredUseStaticFragmentNodeWarning;
function requireUseStaticFragmentNodeWarning() {
  if (hasRequiredUseStaticFragmentNodeWarning) return useStaticFragmentNodeWarning_1;
  hasRequiredUseStaticFragmentNodeWarning = 1;
  var useUnsafeRef_DEPRECATED = requireUseUnsafeRef_DEPRECATED();
  var warning = requireWarning();
  function useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    if (process.env.NODE_ENV !== "production") {
      var initialPropRef = useUnsafeRef_DEPRECATED(fragmentNode.name);
      process.env.NODE_ENV !== "production" ? warning(initialPropRef.current === fragmentNode.name, "Relay: The %s has to remain the same over the lifetime of a component. Changing it is not supported and will result in unexpected behavior.", warningContext) : void 0;
    }
  }
  useStaticFragmentNodeWarning_1 = useStaticFragmentNodeWarning;
  return useStaticFragmentNodeWarning_1;
}
var useFragment_1;
var hasRequiredUseFragment;
function requireUseFragment() {
  if (hasRequiredUseFragment) return useFragment_1;
  hasRequiredUseFragment = 1;
  var _require = requireLoadQuery(), useTrackLoadQueryInRender = _require.useTrackLoadQueryInRender;
  var useFragmentInternal = requireUseFragmentInternal();
  var useStaticFragmentNodeWarning = requireUseStaticFragmentNodeWarning();
  var _require2 = require$$0__default, useDebugValue = _require2.useDebugValue;
  var _require3 = require$$11, getFragment2 = _require3.getFragment;
  function useFragment(fragment, key) {
    useTrackLoadQueryInRender();
    var fragmentNode = getFragment2(fragment);
    useStaticFragmentNodeWarning(fragmentNode, "first argument of useFragment()");
    var data = useFragmentInternal(fragmentNode, key, "useFragment()");
    if (process.env.NODE_ENV !== "production") {
      useDebugValue({
        fragment: fragmentNode.name,
        data
      });
    }
    return data;
  }
  useFragment_1 = useFragment;
  return useFragment_1;
}
var useMutation_1;
var hasRequiredUseMutation;
function requireUseMutation() {
  if (hasRequiredUseMutation) return useMutation_1;
  hasRequiredUseMutation = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var useIsMountedRef = requireUseIsMountedRef();
  var useRelayEnvironment = requireUseRelayEnvironment();
  var React = require$$0__default;
  var _require = require$$11, defaultCommitMutation = _require.commitMutation;
  var useState2 = React.useState, useEffect2 = React.useEffect, useRef2 = React.useRef, useCallback2 = React.useCallback;
  function useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultCommitMutation;
    var environment = useRelayEnvironment();
    var isMountedRef = useIsMountedRef();
    var environmentRef = useRef2(environment);
    var mutationRef = useRef2(mutation);
    var inFlightMutationsRef = useRef2(/* @__PURE__ */ new Set());
    var _useState = useState2(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = useCallback2(function(disposable) {
      if (environmentRef.current === environment && mutationRef.current === mutation) {
        inFlightMutationsRef.current["delete"](disposable);
        if (isMountedRef.current) {
          setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
      }
    }, [environment, isMountedRef, mutation]);
    useEffect2(function() {
      if (environmentRef.current !== environment || mutationRef.current !== mutation) {
        inFlightMutationsRef.current = /* @__PURE__ */ new Set();
        if (isMountedRef.current) {
          setMutationInFlight(false);
        }
        environmentRef.current = environment;
        mutationRef.current = mutation;
      }
    }, [environment, isMountedRef, mutation]);
    var commit = useCallback2(function(config) {
      if (isMountedRef.current) {
        setMutationInFlight(true);
      }
      var disposable = commitMutationFn(environment, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, config), {}, {
        mutation,
        onCompleted: function onCompleted(response, errors) {
          var _config$onCompleted;
          cleanup(disposable);
          (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 ? void 0 : _config$onCompleted.call(config, response, errors);
        },
        onError: function onError(error) {
          var _config$onError;
          cleanup(disposable);
          (_config$onError = config.onError) === null || _config$onError === void 0 ? void 0 : _config$onError.call(config, error);
        },
        onUnsubscribe: function onUnsubscribe() {
          var _config$onUnsubscribe;
          cleanup(disposable);
          (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 ? void 0 : _config$onUnsubscribe.call(config);
        },
        onNext: function onNext() {
          var _config$onNext;
          (_config$onNext = config.onNext) === null || _config$onNext === void 0 ? void 0 : _config$onNext.call(config);
        }
      }));
      inFlightMutationsRef.current.add(disposable);
      return disposable;
    }, [cleanup, commitMutationFn, environment, isMountedRef, mutation]);
    return [commit, isMutationInFlight];
  }
  useMutation_1 = useMutation;
  return useMutation_1;
}
var useIsOperationNodeActive_1;
var hasRequiredUseIsOperationNodeActive;
function requireUseIsOperationNodeActive() {
  if (hasRequiredUseIsOperationNodeActive) return useIsOperationNodeActive_1;
  hasRequiredUseIsOperationNodeActive = 1;
  var useRelayEnvironment = requireUseRelayEnvironment();
  var invariant = requireBrowser();
  var React = require$$0__default;
  var _require = require$$11, getObservableForActiveRequest = _require.__internal.getObservableForActiveRequest, getSelector = _require.getSelector;
  var useEffect2 = React.useEffect, useState2 = React.useState, useMemo2 = React.useMemo;
  function useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = useRelayEnvironment();
    var observable = useMemo2(function() {
      var selector = getSelector(fragmentNode, fragmentRef);
      if (selector == null) {
        return null;
      }
      !(selector.kind === "SingularReaderSelector") ? process.env.NODE_ENV !== "production" ? invariant(false, "useIsOperationNodeActive: Plural fragments are not supported.") : invariant(false) : void 0;
      return getObservableForActiveRequest(environment, selector.owner);
    }, [environment, fragmentNode, fragmentRef]);
    var _useState = useState2(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    useEffect2(function() {
      var subscription;
      setIsActive(observable != null);
      if (observable != null) {
        var onCompleteOrError = function onCompleteOrError2() {
          setIsActive(false);
        };
        subscription = observable.subscribe({
          complete: onCompleteOrError,
          error: onCompleteOrError
        });
      }
      return function() {
        if (subscription) {
          subscription.unsubscribe();
        }
      };
    }, [observable]);
    return isActive;
  }
  useIsOperationNodeActive_1 = useIsOperationNodeActive;
  return useIsOperationNodeActive_1;
}
var useLoadMoreFunction_1;
var hasRequiredUseLoadMoreFunction;
function requireUseLoadMoreFunction() {
  if (hasRequiredUseLoadMoreFunction) return useLoadMoreFunction_1;
  hasRequiredUseLoadMoreFunction = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var useFetchTrackingRef = requireUseFetchTrackingRef();
  var useIsMountedRef = requireUseIsMountedRef();
  var useIsOperationNodeActive = requireUseIsOperationNodeActive();
  var useRelayEnvironment = requireUseRelayEnvironment();
  var invariant = requireBrowser();
  var _require = require$$0__default, useCallback2 = _require.useCallback, useEffect2 = _require.useEffect, useState2 = _require.useState;
  var _require2 = require$$11, fetchQuery = _require2.__internal.fetchQuery, ConnectionInterface = _require2.ConnectionInterface, createOperationDescriptor = _require2.createOperationDescriptor, getPaginationVariables = _require2.getPaginationVariables, getRefetchMetadata = _require2.getRefetchMetadata, getSelector = _require2.getSelector, getValueAtPath = _require2.getValueAtPath;
  var warning = requireWarning();
  function useLoadMoreFunction(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = useRelayEnvironment();
    var _useFetchTrackingRef = useFetchTrackingRef(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === "object" ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = useIsMountedRef();
    var _useState = useState2(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = useState2(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = useIsOperationNodeActive(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
      disposeFetch();
      onReset();
      setMirroredEnvironment(environment);
      setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    useEffect2(function() {
      return function() {
        disposeFetch();
      };
    }, [disposeFetch]);
    var loadMore = useCallback2(function(count, options) {
      var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
      if (isMountedRef.current !== true) {
        process.env.NODE_ENV !== "production" ? warning(false, "Relay: Unexpected fetch on unmounted component for fragment `%s` in `%s`. It looks like some instances of your component are still trying to fetch data but they already unmounted. Please make sure you clear all timers, intervals, async calls, etc that may trigger a fetch.", fragmentNode.name, componentDisplayName) : void 0;
        return {
          dispose: function dispose() {
          }
        };
      }
      var fragmentSelector = getSelector(fragmentNode, fragmentRef);
      if (isFetchingRef.current === true || fragmentData == null || isParentQueryActive) {
        if (fragmentSelector == null) {
          process.env.NODE_ENV !== "production" ? warning(false, "Relay: Unexpected fetch while using a null fragment ref for fragment `%s` in `%s`. When fetching more items, we expect initial fragment data to be non-null. Please make sure you're passing a valid fragment ref to `%s` before paginating.", fragmentNode.name, componentDisplayName, componentDisplayName) : void 0;
        }
        if (onComplete) {
          onComplete(null);
        }
        return {
          dispose: function dispose() {
          }
        };
      }
      !(fragmentSelector != null && fragmentSelector.kind !== "PluralReaderSelector") ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected to be able to find a non-plural fragment owner for fragment `%s` when using `%s`. If you're seeing this, this is likely a bug in Relay.", fragmentNode.name, componentDisplayName) : invariant(false) : void 0;
      var parentVariables = fragmentSelector.owner.variables;
      var fragmentVariables = fragmentSelector.variables;
      var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
      var baseVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, parentVariables), fragmentVariables);
      var paginationVariables = getPaginationVariables(direction, count, cursor, baseVariables, (0, _objectSpread2["default"])({}, extraVariables), paginationMetadata);
      if (identifierInfo != null) {
        if (typeof identifierValue !== "string") {
          process.env.NODE_ENV !== "production" ? warning(false, "Relay: Expected result to have a string  `%s` in order to refetch, got `%s`.", identifierInfo.identifierField, identifierValue) : void 0;
        }
        paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
      }
      var paginationQuery = createOperationDescriptor(paginationRequest, paginationVariables, {
        force: true
      });
      fetchQuery(environment, paginationQuery).subscribe((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, observer), {}, {
        start: function start(subscription) {
          startFetch(subscription);
          observer.start && observer.start(subscription);
        },
        complete: function complete() {
          completeFetch();
          observer.complete && observer.complete();
          onComplete && onComplete(null);
        },
        error: function error(_error) {
          completeFetch();
          observer.error && observer.error(_error);
          onComplete && onComplete(_error);
        }
      }));
      return {
        dispose: disposeFetch
      };
    }, [environment, identifierValue, direction, cursor, startFetch, disposeFetch, completeFetch, isFetchingRef, isParentQueryActive, fragmentData, fragmentNode.name, fragmentRef, componentDisplayName]);
    return [loadMore, hasMore, disposeFetch];
  }
  function getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) {
      return {
        cursor: null,
        hasMore: false
      };
    }
    !(typeof connection === "object") ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected connection in fragment `%s` to have been `null`, or a plain object with %s and %s properties. Instead got `%s`.", fragmentNode.name, EDGES, PAGE_INFO, connection) : invariant(false) : void 0;
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) {
      return {
        cursor: null,
        hasMore: false
      };
    }
    !Array.isArray(edges) ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected connection in fragment `%s` to have a plural `%s` field. Instead got `%s`.", fragmentNode.name, EDGES, edges) : invariant(false) : void 0;
    !(typeof pageInfo === "object") ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected connection in fragment `%s` to have a `%s` field. Instead got `%s`.", fragmentNode.name, PAGE_INFO, pageInfo) : invariant(false) : void 0;
    var cursor = direction === "forward" ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === "string") ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected page info for connection in fragment `%s` to have a valid `%s`. Instead got `%s`.", fragmentNode.name, START_CURSOR, cursor) : invariant(false) : void 0;
    var hasMore;
    if (direction === "forward") {
      hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    } else {
      hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    }
    return {
      cursor,
      hasMore
    };
  }
  useLoadMoreFunction_1 = useLoadMoreFunction;
  return useLoadMoreFunction_1;
}
var readFragmentInternal_1;
var hasRequiredReadFragmentInternal;
function requireReadFragmentInternal() {
  if (hasRequiredReadFragmentInternal) return readFragmentInternal_1;
  hasRequiredReadFragmentInternal = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var _createForOfIteratorHelper2 = _interopRequireDefault(requireCreateForOfIteratorHelper());
  var _require = requireQueryResource(), getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
  var invariant = requireBrowser();
  var _require2 = require$$11, fetchQueryInternal = _require2.__internal.fetchQuery, RelayFeatureFlags = _require2.RelayFeatureFlags, createOperationDescriptor = _require2.createOperationDescriptor, getPendingOperationsForFragment = _require2.getPendingOperationsForFragment, getSelector = _require2.getSelector, getVariablesFromFragment = _require2.getVariablesFromFragment, handlePotentialSnapshotErrors = _require2.handlePotentialSnapshotErrors;
  var warning = requireWarning();
  function isMissingData(state) {
    if (state.kind === "bailout") {
      return false;
    } else if (state.kind === "singular") {
      return state.snapshot.isMissingData;
    } else {
      return state.snapshots.some(function(s2) {
        return s2.isMissingData;
      });
    }
  }
  function getMissingClientEdges(state) {
    if (state.kind === "bailout") {
      return null;
    } else if (state.kind === "singular") {
      var _state$snapshot$missi;
      return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
      var edges = null;
      var _iterator = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var snapshot = _step.value;
          if (snapshot.missingClientEdges) {
            var _edges;
            edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
            var _iterator2 = (0, _createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                var edge = _step2.value;
                edges.push(edge);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return edges;
    }
  }
  function handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === "singular") {
      var _state$snapshot$selec, _state$snapshot$selec2;
      handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === "plural") {
      var _iterator3 = (0, _createForOfIteratorHelper2["default"])(state.snapshots), _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
          var _snapshot$selector$no, _snapshot$selector$no2;
          var snapshot = _step3.value;
          handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }
  function handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, originalVariables), {}, {
      id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource2 = getQueryResourceForEnvironment(environment);
    return QueryResource2.prepare(queryOperationDescriptor, fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
  }
  function getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) {
      return {
        kind: "bailout"
      };
    } else if (fragmentSelector.kind === "PluralReaderSelector") {
      if (fragmentSelector.selectors.length === 0) {
        return {
          kind: "bailout"
        };
      } else {
        return {
          kind: "plural",
          snapshots: fragmentSelector.selectors.map(function(s2) {
            return environment.lookup(s2);
          }),
          epoch: environment.getStore().getEpoch()
        };
      }
    } else {
      return {
        kind: "singular",
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
      };
    }
  }
  function readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) {
      !(fragmentRef == null || Array.isArray(fragmentRef)) ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected fragment pointer%s for fragment `%s` to be an array, instead got `%s`. Remove `@relay(plural: true)` from fragment `%s` to allow the prop to be an object.", fragmentKey != null ? " for key `".concat(fragmentKey, "`") : "", fragmentNode.name, typeof fragmentRef, fragmentNode.name) : invariant(false) : void 0;
    } else {
      !!Array.isArray(fragmentRef) ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected fragment pointer%s for fragment `%s` not to be an array, instead got `%s`. Add `@relay(plural: true)` to fragment `%s` to allow the prop to be an array.", fragmentKey != null ? " for key `".concat(fragmentKey, "`") : "", fragmentNode.name, typeof fragmentRef, fragmentNode.name) : invariant(false) : void 0;
    }
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected to receive an object where `...%s` was spread, but the fragment reference was not found`. This is most likely the result of:\n- Forgetting to spread `%s` in `%s`'s parent's fragment.\n- Conditionally fetching `%s` but unconditionally passing %s prop to `%s`. If the parent fragment only fetches the fragment conditionally - with e.g. `@include`, `@skip`, or inside a `... on SomeType { }` spread  - then the fragment reference will not exist. In this case, pass `null` if the conditions for evaluating the fragment are not met (e.g. if the `@include(if)` value is false.)", fragmentNode.name, fragmentNode.name, hookDisplayName, fragmentNode.name, fragmentKey == null ? "a fragment reference" : "the `".concat(fragmentKey, "`"), hookDisplayName) : invariant(false) : void 0;
    var state = getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
      var missingClientEdges = getMissingClientEdges(state);
      if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
        clientEdgeQueries = [];
        var _iterator4 = (0, _createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
            var edge = _step4.value;
            clientEdgeQueries.push(handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
    if (isMissingData(state)) {
      !(fragmentSelector != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "refinement, see invariants above") : invariant(false) : void 0;
      var fragmentOwner = fragmentSelector.kind === "PluralReaderSelector" ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
      var pendingOperationsResult = getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
      if (pendingOperationsResult) {
        throw pendingOperationsResult.promise;
      }
      handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === "bailout") {
      data = isPlural ? [] : null;
    } else if (state.kind === "singular") {
      data = state.snapshot.data;
    } else {
      data = state.snapshots.map(function(s2) {
        return s2.data;
      });
    }
    if (RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || process.env.NODE_ENV !== "production") {
      if (fragmentRef != null && (data === void 0 || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === void 0;
      }))) {
        process.env.NODE_ENV !== "production" ? warning(false, "Relay: Expected to have been able to read non-null data for fragment `%s` declared in `%s`, since fragment reference was non-null. Make sure that that `%s`'s parent isn't holding on to and/or passing a fragment reference for data that has been deleted.", fragmentNode.name, hookDisplayName, hookDisplayName) : void 0;
      }
    }
    return {
      data,
      clientEdgeQueries
    };
  }
  readFragmentInternal_1 = readFragmentInternal;
  return readFragmentInternal_1;
}
var useQueryLoader_1;
var hasRequiredUseQueryLoader;
function requireUseQueryLoader() {
  if (hasRequiredUseQueryLoader) return useQueryLoader_1;
  hasRequiredUseQueryLoader = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _createForOfIteratorHelper2 = _interopRequireDefault(requireCreateForOfIteratorHelper());
  var _require = requireLoadQuery(), loadQuery = _require.loadQuery, useTrackLoadQueryInRender = _require.useTrackLoadQueryInRender;
  var useIsMountedRef = requireUseIsMountedRef();
  var useRelayEnvironment = requireUseRelayEnvironment();
  var _require2 = require$$0__default, useCallback2 = _require2.useCallback, useEffect2 = _require2.useEffect, useRef2 = _require2.useRef, useState2 = _require2.useState;
  var _require3 = require$$11, getRequest = _require3.getRequest;
  var initialNullQueryReferenceState = {
    kind: "NullQueryReference"
  };
  function requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === "PreloadableConcreteRequest") {
      return preloadableRequest.params.metadata.live !== void 0;
    }
    var request = getRequest(preloadableRequest);
    return request.params.metadata.live !== void 0;
  }
  function useQueryLoader(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : initialNullQueryReferenceState;
    var environment = useRelayEnvironment();
    useTrackLoadQueryInRender();
    var isMountedRef = useIsMountedRef();
    var undisposedQueryReferencesRef = useRef2(/* @__PURE__ */ new Set([initialQueryReferenceInternal]));
    var _useState = useState2(function() {
      return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = useState2(function() {
      return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
      undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
      setPreviousInitialQueryReference(initialQueryReferenceInternal);
      setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = useCallback2(function() {
      if (isMountedRef.current) {
        undisposedQueryReferencesRef.current.add(initialNullQueryReferenceState);
        setQueryReference(initialNullQueryReferenceState);
      }
    }, [isMountedRef]);
    var queryLoaderCallback = useCallback2(function(variables, options) {
      var mergedOptions = options != null && options.hasOwnProperty("__environment") ? {
        fetchPolicy: options.fetchPolicy,
        networkCacheConfig: options.networkCacheConfig,
        __nameForWarning: options.__nameForWarning
      } : options;
      if (isMountedRef.current) {
        var _options$__environmen;
        var updatedQueryReference = loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        undisposedQueryReferencesRef.current.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
      }
    }, [environment, preloadableRequest, setQueryReference, isMountedRef]);
    var maybeHiddenOrFastRefresh = useRef2(false);
    useEffect2(function() {
      return function() {
        maybeHiddenOrFastRefresh.current = true;
      };
    }, []);
    useEffect2(function() {
      if (maybeHiddenOrFastRefresh.current === true) {
        maybeHiddenOrFastRefresh.current = false;
        if (queryReference.kind !== "NullQueryReference") {
          queryLoaderCallback(queryReference.variables, {
            fetchPolicy: queryReference.fetchPolicy,
            networkCacheConfig: queryReference.networkCacheConfig
          });
        }
        return;
      }
      var undisposedQueryReferences = undisposedQueryReferencesRef.current;
      if (isMountedRef.current) {
        var _iterator = (0, _createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var undisposedQueryReference = _step.value;
            if (undisposedQueryReference === queryReference) {
              break;
            }
            undisposedQueryReferences["delete"](undisposedQueryReference);
            if (undisposedQueryReference.kind !== "NullQueryReference") {
              if (requestIsLiveQuery(preloadableRequest)) {
                undisposedQueryReference.dispose && undisposedQueryReference.dispose();
              } else {
                undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, [queryReference, isMountedRef, queryLoaderCallback, preloadableRequest]);
    useEffect2(function() {
      return function disposeAllRemainingQueryReferences() {
        var _iterator2 = (0, _createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
            var undisposedQueryReference = _step2.value;
            if (undisposedQueryReference.kind !== "NullQueryReference") {
              if (requestIsLiveQuery(preloadableRequest)) {
                undisposedQueryReference.dispose && undisposedQueryReference.dispose();
              } else {
                undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };
    }, [preloadableRequest]);
    return [queryReference.kind === "NullQueryReference" ? null : queryReference, queryLoaderCallback, disposeQuery];
  }
  useQueryLoader_1 = useQueryLoader;
  return useQueryLoader_1;
}
var useRefetchableFragmentInternal;
var hasRequiredUseRefetchableFragmentInternal;
function requireUseRefetchableFragmentInternal() {
  if (hasRequiredUseRefetchableFragmentInternal) return useRefetchableFragmentInternal;
  hasRequiredUseRefetchableFragmentInternal = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var ProfilerContext = requireProfilerContext();
  var _require = requireQueryResource(), getQueryResourceForEnvironment = _require.getQueryResourceForEnvironment;
  var readFragmentInternal = requireReadFragmentInternal();
  var useFragmentInternal = requireUseFragmentInternal();
  var useIsMountedRef = requireUseIsMountedRef();
  var useQueryLoader = requireUseQueryLoader();
  var useRelayEnvironment = requireUseRelayEnvironment();
  var invariant = requireBrowser();
  var _require2 = require$$0__default, useCallback2 = _require2.useCallback, useContext2 = _require2.useContext, useReducer = _require2.useReducer;
  var _require3 = require$$11, fetchQuery = _require3.__internal.fetchQuery, createOperationDescriptor = _require3.createOperationDescriptor, getFragmentIdentifier = _require3.getFragmentIdentifier, getRefetchMetadata = _require3.getRefetchMetadata, getSelector = _require3.getSelector, getValueAtPath = _require3.getValueAtPath;
  var warning = requireWarning();
  function reducer(state, action) {
    switch (action.type) {
      case "refetch": {
        var _action$refetchEnviro;
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state), {}, {
          fetchPolicy: action.fetchPolicy,
          mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
          onComplete: action.onComplete,
          refetchEnvironment: action.refetchEnvironment,
          refetchQuery: action.refetchQuery,
          renderPolicy: action.renderPolicy
        });
      }
      case "reset": {
        return {
          fetchPolicy: void 0,
          mirroredEnvironment: action.environment,
          mirroredFragmentIdentifier: action.fragmentIdentifier,
          onComplete: void 0,
          refetchQuery: null,
          renderPolicy: void 0
        };
      }
      default: {
        action.type;
        throw new Error("useRefetchableFragmentNode: Unexpected action type");
      }
    }
  }
  function useRefetchableFragmentNode(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = useRelayEnvironment();
    var _getRefetchMetadata = getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = useReducer(reducer, {
      fetchPolicy: void 0,
      mirroredEnvironment: parentEnvironment,
      mirroredFragmentIdentifier: fragmentIdentifier,
      onComplete: void 0,
      refetchEnvironment: null,
      refetchQuery: null,
      renderPolicy: void 0
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource2 = getQueryResourceForEnvironment(environment);
    var profilerContext = useContext2(ProfilerContext);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = useQueryLoader(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
      dispatch({
        type: "reset",
        environment,
        fragmentIdentifier
      });
      disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
      var debugPreviousIDAndTypename;
      if (process.env.NODE_ENV !== "production") {
        debugPreviousIDAndTypename = debugFunctions.getInitialIDAndType(refetchQuery.request.variables, fragmentRefPathInResponse, identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierQueryVariableName, environment);
      }
      var handleQueryCompleted = function handleQueryCompleted2(maybeError) {
        onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
      };
      var fetchObservable = queryRef.source != null ? queryRef.source : fetchQuery(environment, refetchQuery);
      var queryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource2.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
          error: handleQueryCompleted,
          complete: function complete() {
            if (process.env.NODE_ENV !== "production") {
              debugFunctions.checkSameTypeAfterRefetch(debugPreviousIDAndTypename, environment, fragmentNode, componentDisplayName);
            }
            handleQueryCompleted();
          }
        }, queryRef.fetchKey, profilerContext);
      });
      var queryData = readFragmentInternal(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
      !(queryData != null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Relay: Expected to be able to read refetch query response. If you're seeing this, this is likely a bug in Relay.") : invariant(false) : void 0;
      var refetchedFragmentRef = getValueAtPath(queryData, fragmentRefPathInResponse);
      fragmentRef = refetchedFragmentRef;
      if (process.env.NODE_ENV !== "production") {
        debugFunctions.checkSameIDAfterRefetch(debugPreviousIDAndTypename, fragmentRef, fragmentNode, componentDisplayName);
      }
    }
    var fragmentData = useFragmentInternal(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
      fragmentData,
      fragmentRef,
      refetch
    };
  }
  function useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = useIsMountedRef();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === "object" ? fragmentData[identifierInfo.identifierField] : null;
    return useCallback2(function(providedRefetchVariables, options) {
      if (isMountedRef.current !== true) {
        process.env.NODE_ENV !== "production" ? warning(false, "Relay: Unexpected call to `refetch` on unmounted component for fragment `%s` in `%s`. It looks like some instances of your component are still trying to fetch data but they already unmounted. Please make sure you clear all timers, intervals, async calls, etc that may trigger a fetch.", fragmentNode.name, componentDisplayName) : void 0;
        return {
          dispose: function dispose() {
          }
        };
      }
      if (parentFragmentRef == null) {
        process.env.NODE_ENV !== "production" ? warning(false, "Relay: Unexpected call to `refetch` while using a null fragment ref for fragment `%s` in `%s`. When calling `refetch`, we expect initial fragment data to be non-null. Please make sure you're passing a valid fragment ref to `%s` before calling `refetch`, or make sure you pass all required variables to `refetch`.", fragmentNode.name, componentDisplayName, componentDisplayName) : void 0;
      }
      var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
      var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
      var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
      var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
      var fragmentSelector = getSelector(fragmentNode, parentFragmentRef);
      var parentVariables;
      var fragmentVariables;
      if (fragmentSelector == null) {
        parentVariables = {};
        fragmentVariables = {};
      } else if (fragmentSelector.kind === "PluralReaderSelector") {
        var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
        parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
        fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
      } else {
        parentVariables = fragmentSelector.owner.variables;
        fragmentVariables = fragmentSelector.variables;
      }
      var refetchVariables = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
      if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
        if (typeof identifierValue !== "string") {
          process.env.NODE_ENV !== "production" ? warning(false, "Relay: Expected result to have a string  `%s` in order to refetch, got `%s`.", identifierInfo.identifierField, identifierValue) : void 0;
        }
        refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
      }
      var refetchQuery = createOperationDescriptor(refetchableRequest, refetchVariables, {
        force: true
      });
      loadQuery(refetchQuery.request.variables, {
        fetchPolicy,
        __environment: refetchEnvironment,
        __nameForWarning: "refetch"
      });
      dispatch({
        type: "refetch",
        fetchPolicy,
        onComplete,
        refetchEnvironment,
        refetchQuery,
        renderPolicy
      });
      return {
        dispose: disposeQuery
      };
    }, [fragmentIdentifier, dispatch, disposeQuery, identifierValue, loadQuery]);
  }
  var debugFunctions;
  if (process.env.NODE_ENV !== "production") {
    debugFunctions = {
      getInitialIDAndType: function getInitialIDAndType(memoRefetchVariables, fragmentRefPathInResponse, identifierQueryVariableName, environment) {
        var _require4 = require$$11, Record = _require4.Record;
        var id = memoRefetchVariables === null || memoRefetchVariables === void 0 ? void 0 : memoRefetchVariables[identifierQueryVariableName !== null && identifierQueryVariableName !== void 0 ? identifierQueryVariableName : "id"];
        if (fragmentRefPathInResponse.length !== 1 || fragmentRefPathInResponse[0] !== "node" || id == null) {
          return null;
        }
        var recordSource = environment.getStore().getSource();
        var record = recordSource.get(id);
        var typename = record == null ? null : Record.getType(record);
        if (typename == null) {
          return null;
        }
        return {
          id,
          typename
        };
      },
      checkSameTypeAfterRefetch: function checkSameTypeAfterRefetch(previousIDAndType, environment, fragmentNode, componentDisplayName) {
        var _require5 = require$$11, Record = _require5.Record;
        if (!previousIDAndType) {
          return;
        }
        var recordSource = environment.getStore().getSource();
        var record = recordSource.get(previousIDAndType.id);
        var typename = record && Record.getType(record);
        if (typename !== previousIDAndType.typename) {
          process.env.NODE_ENV !== "production" ? warning(false, "Relay: Call to `refetch` returned data with a different __typename: was `%s`, now `%s`, on `%s` in `%s`. Please make sure the server correctly implementsunique id requirement.", previousIDAndType.typename, typename, fragmentNode.name, componentDisplayName) : void 0;
        }
      },
      checkSameIDAfterRefetch: function checkSameIDAfterRefetch(previousIDAndTypename, refetchedFragmentRef, fragmentNode, componentDisplayName) {
        if (previousIDAndTypename == null) {
          return;
        }
        var _require6 = require$$11, ID_KEY = _require6.ID_KEY;
        var resultID = refetchedFragmentRef[ID_KEY];
        if (resultID != null && resultID !== previousIDAndTypename.id) {
          process.env.NODE_ENV !== "production" ? warning(false, "Relay: Call to `refetch` returned a different id, expected `%s`, got `%s`, on `%s` in `%s`. Please make sure the server correctly implements unique id requirement.", resultID, previousIDAndTypename.id, fragmentNode.name, componentDisplayName) : void 0;
        }
      }
    };
  }
  useRefetchableFragmentInternal = useRefetchableFragmentNode;
  return useRefetchableFragmentInternal;
}
var usePaginationFragment_1;
var hasRequiredUsePaginationFragment;
function requireUsePaginationFragment() {
  if (hasRequiredUsePaginationFragment) return usePaginationFragment_1;
  hasRequiredUsePaginationFragment = 1;
  var _interopRequireDefault = requireInteropRequireDefault()["default"];
  var _objectSpread2 = _interopRequireDefault(requireObjectSpread2());
  var useLoadMoreFunction = requireUseLoadMoreFunction();
  var useRefetchableFragmentInternal2 = requireUseRefetchableFragmentInternal();
  var useRelayEnvironment = requireUseRelayEnvironment();
  var useStaticFragmentNodeWarning = requireUseStaticFragmentNodeWarning();
  var _require = require$$0__default, useCallback2 = _require.useCallback, useDebugValue = _require.useDebugValue, useState2 = _require.useState;
  var _require2 = require$$11, getFragment2 = _require2.getFragment, getFragmentIdentifier = _require2.getFragmentIdentifier, getPaginationMetadata = _require2.getPaginationMetadata;
  function usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = getFragment2(fragmentInput);
    useStaticFragmentNodeWarning(fragmentNode, "first argument of usePaginationFragment()");
    var componentDisplayName = "usePaginationFragment()";
    var _getPaginationMetadat = getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = useRefetchableFragmentInternal2(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = useLoadMore({
      componentDisplayName,
      connectionPathInFragmentData,
      direction: "backward",
      fragmentData,
      fragmentIdentifier,
      fragmentNode,
      fragmentRef,
      paginationMetadata,
      paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = useLoadMore({
      componentDisplayName,
      connectionPathInFragmentData,
      direction: "forward",
      fragmentData,
      fragmentIdentifier,
      fragmentNode,
      fragmentRef,
      paginationMetadata,
      paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = useCallback2(function(variables, options) {
      disposeFetchNext();
      disposeFetchPrevious();
      return refetch(variables, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options), {}, {
        __environment: void 0
      }));
    }, [disposeFetchNext, disposeFetchPrevious, refetch]);
    if (process.env.NODE_ENV !== "production") {
      useDebugValue({
        fragment: fragmentNode.name,
        data: fragmentData,
        hasNext,
        isLoadingNext,
        hasPrevious,
        isLoadingPrevious
      });
    }
    return {
      data: fragmentData,
      loadNext,
      loadPrevious,
      hasNext,
      hasPrevious,
      isLoadingNext,
      isLoadingPrevious,
      refetch: refetchPagination
    };
  }
  function useLoadMore(args) {
    var environment = useRelayEnvironment();
    var _useState = useState2(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore2(value) {
      var _environment$getSched;
      var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
      if (schedule) {
        schedule(function() {
          reallySetIsLoadingMore(value);
        });
      } else {
        reallySetIsLoadingMore(value);
      }
    };
    var observer = {
      start: function start() {
        return setIsLoadingMore(true);
      },
      complete: function complete() {
        return setIsLoadingMore(false);
      },
      error: function error() {
        return setIsLoadingMore(false);
      }
    };
    var handleReset = function handleReset2() {
      return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = useLoadMoreFunction((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, args), {}, {
      observer,
      onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [loadMore, hasMore, isLoadingMore, disposeFetch];
  }
  usePaginationFragment_1 = usePaginationFragment;
  return usePaginationFragment_1;
}
var usePreloadedQuery_1;
var hasRequiredUsePreloadedQuery;
function requireUsePreloadedQuery() {
  if (hasRequiredUsePreloadedQuery) return usePreloadedQuery_1;
  hasRequiredUsePreloadedQuery = 1;
  var _require = requireLoadQuery(), useTrackLoadQueryInRender = _require.useTrackLoadQueryInRender;
  var useLazyLoadQueryNode = requireUseLazyLoadQueryNode();
  var useMemoOperationDescriptor = requireUseMemoOperationDescriptor();
  var useRelayEnvironment = requireUseRelayEnvironment();
  var invariant = requireBrowser();
  var _require2 = require$$0__default, useDebugValue = _require2.useDebugValue;
  var _require3 = require$$11, _require3$__internal = _require3.__internal, fetchQueryDeduped = _require3$__internal.fetchQueryDeduped, fetchQuery = _require3$__internal.fetchQuery;
  var warning = requireWarning();
  function usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    useTrackLoadQueryInRender();
    var environment = useRelayEnvironment();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = useMemoOperationDescriptor(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === "PreloadedQuery_DEPRECATED") {
      !(operation.request.node.params.name === preloadedQuery.name) ? process.env.NODE_ENV !== "production" ? invariant(false, "usePreloadedQuery(): Expected data to be prefetched for query `%s`, got prefetch results for query `%s`.", operation.request.node.params.name, preloadedQuery.name) : invariant(false) : void 0;
      useLazyLoadQueryNodeParams = {
        componentDisplayName: "usePreloadedQuery()",
        fetchKey,
        fetchObservable: fetchQueryDeduped(environment, operation.request.identifier, function() {
          if (environment === preloadedQuery.environment && source != null) {
            return environment.executeWithSource({
              operation,
              source
            });
          } else {
            return environment.execute({
              operation
            });
          }
        }),
        fetchPolicy,
        query: operation,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
      };
    } else {
      process.env.NODE_ENV !== "production" ? warning(preloadedQuery.isDisposed === false, "usePreloadedQuery(): Expected preloadedQuery to not be disposed yet. This is because disposing the query marks it for future garbage collection, and as such query results may no longer be present in the Relay store. In the future, this will become a hard error.") : void 0;
      var fallbackFetchObservable = fetchQuery(environment, operation);
      var fetchObservable;
      if (source != null && environment === preloadedQuery.environment) {
        fetchObservable = source.ifEmpty(fallbackFetchObservable);
      } else if (environment !== preloadedQuery.environment) {
        process.env.NODE_ENV !== "production" ? warning(false, "usePreloadedQuery(): usePreloadedQuery was passed a preloaded query that was created with a different environment than the one that is currently in context. In the future, this will become a hard error.") : void 0;
        fetchObservable = fallbackFetchObservable;
      } else {
        fetchObservable = fallbackFetchObservable;
      }
      useLazyLoadQueryNodeParams = {
        componentDisplayName: "usePreloadedQuery()",
        fetchObservable,
        fetchKey,
        fetchPolicy,
        query: operation,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
      };
    }
    var data = useLazyLoadQueryNode(useLazyLoadQueryNodeParams);
    if (process.env.NODE_ENV !== "production") {
      useDebugValue({
        query: preloadedQuery.name,
        variables: preloadedQuery.variables,
        data,
        fetchKey,
        fetchPolicy,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
      });
    }
    return data;
  }
  usePreloadedQuery_1 = usePreloadedQuery;
  return usePreloadedQuery_1;
}
var useRefetchableFragment_1;
var hasRequiredUseRefetchableFragment;
function requireUseRefetchableFragment() {
  if (hasRequiredUseRefetchableFragment) return useRefetchableFragment_1;
  hasRequiredUseRefetchableFragment = 1;
  var useRefetchableFragmentInternal2 = requireUseRefetchableFragmentInternal();
  var useStaticFragmentNodeWarning = requireUseStaticFragmentNodeWarning();
  var _require = require$$0__default, useDebugValue = _require.useDebugValue;
  var _require2 = require$$11, getFragment2 = _require2.getFragment;
  function useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = getFragment2(fragmentInput);
    useStaticFragmentNodeWarning(fragmentNode, "first argument of useRefetchableFragment()");
    var _useRefetchableFragme = useRefetchableFragmentInternal2(fragmentNode, fragmentRef, "useRefetchableFragment()"), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    if (process.env.NODE_ENV !== "production") {
      useDebugValue({
        fragment: fragmentNode.name,
        data: fragmentData
      });
    }
    return [fragmentData, refetch];
  }
  useRefetchableFragment_1 = useRefetchableFragment;
  return useRefetchableFragment_1;
}
var useSubscribeToInvalidationState_1;
var hasRequiredUseSubscribeToInvalidationState;
function requireUseSubscribeToInvalidationState() {
  if (hasRequiredUseSubscribeToInvalidationState) return useSubscribeToInvalidationState_1;
  hasRequiredUseSubscribeToInvalidationState = 1;
  var useRelayEnvironment = requireUseRelayEnvironment();
  var _require = require$$0__default, useEffect2 = _require.useEffect, useRef2 = _require.useRef;
  function useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = useRelayEnvironment();
    var disposableRef = useRef2(null);
    var stableDataIDs = Array.from(dataIDs).sort().join("");
    useEffect2(function() {
      var store2 = environment.getStore();
      var invalidationState = store2.lookupInvalidationState(dataIDs);
      var disposable = store2.subscribeToInvalidationState(invalidationState, callback);
      disposableRef.current = disposable;
      return function() {
        return disposable.dispose();
      };
    }, [stableDataIDs, callback, environment]);
    return {
      dispose: function dispose() {
        if (disposableRef.current != null) {
          disposableRef.current.dispose();
        }
      }
    };
  }
  useSubscribeToInvalidationState_1 = useSubscribeToInvalidationState;
  return useSubscribeToInvalidationState_1;
}
var useSubscription_1;
var hasRequiredUseSubscription;
function requireUseSubscription() {
  if (hasRequiredUseSubscription) return useSubscription_1;
  hasRequiredUseSubscription = 1;
  var useRelayEnvironment = requireUseRelayEnvironment();
  var _require = require$$0__default, useEffect2 = _require.useEffect;
  var _require2 = require$$11, requestSubscription = _require2.requestSubscription;
  function useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : requestSubscription;
    var environment = useRelayEnvironment();
    useEffect2(function() {
      var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
      return dispose;
    }, [environment, config, actualRequestSubscription]);
  }
  useSubscription_1 = useSubscription;
  return useSubscription_1;
}
var lib;
var hasRequiredLib;
function requireLib() {
  if (hasRequiredLib) return lib;
  hasRequiredLib = 1;
  var ReactRelayContext2 = requireReactRelayContext();
  var ReactRelayFragmentContainer2 = requireReactRelayFragmentContainer();
  var ReactRelayLocalQueryRenderer = requireReactRelayLocalQueryRenderer();
  var ReactRelayPaginationContainer2 = requireReactRelayPaginationContainer();
  var ReactRelayQueryRenderer = requireReactRelayQueryRenderer();
  var ReactRelayRefetchContainer2 = requireReactRelayRefetchContainer();
  var EntryPointContainer = requireEntryPointContainer_react();
  var loadEntryPoint = requireLoadEntryPoint();
  var _require = requireLoadQuery(), loadQuery = _require.loadQuery;
  var ProfilerContext = requireProfilerContext();
  var RelayEnvironmentProvider = requireRelayEnvironmentProvider();
  var useClientQuery = requireUseClientQuery();
  var useEntryPointLoader2 = requireUseEntryPointLoader();
  var useFragment = requireUseFragment();
  var useLazyLoadQuery = requireUseLazyLoadQuery();
  var useMutation = requireUseMutation();
  var usePaginationFragment = requireUsePaginationFragment();
  var usePreloadedQuery = requireUsePreloadedQuery();
  var useQueryLoader = requireUseQueryLoader();
  var useRefetchableFragment = requireUseRefetchableFragment();
  var useRelayEnvironment = requireUseRelayEnvironment();
  var useSubscribeToInvalidationState = requireUseSubscribeToInvalidationState();
  var useSubscription = requireUseSubscription();
  var RelayRuntime = require$$11;
  lib = {
    ConnectionHandler: RelayRuntime.ConnectionHandler,
    QueryRenderer: ReactRelayQueryRenderer,
    LocalQueryRenderer: ReactRelayLocalQueryRenderer,
    MutationTypes: RelayRuntime.MutationTypes,
    RangeOperations: RelayRuntime.RangeOperations,
    ReactRelayContext: ReactRelayContext2,
    applyOptimisticMutation: RelayRuntime.applyOptimisticMutation,
    commitLocalUpdate: RelayRuntime.commitLocalUpdate,
    commitMutation: RelayRuntime.commitMutation,
    createFragmentContainer: ReactRelayFragmentContainer2.createContainer,
    createPaginationContainer: ReactRelayPaginationContainer2.createContainer,
    createRefetchContainer: ReactRelayRefetchContainer2.createContainer,
    fetchQuery_DEPRECATED: RelayRuntime.fetchQuery_DEPRECATED,
    graphql: RelayRuntime.graphql,
    readInlineData: RelayRuntime.readInlineData,
    requestSubscription: RelayRuntime.requestSubscription,
    EntryPointContainer,
    RelayEnvironmentProvider,
    ProfilerContext,
    fetchQuery: RelayRuntime.fetchQuery,
    loadQuery,
    loadEntryPoint,
    useClientQuery,
    useFragment,
    useLazyLoadQuery,
    useEntryPointLoader: useEntryPointLoader2,
    useQueryLoader,
    useMutation,
    usePaginationFragment,
    usePreloadedQuery,
    useRefetchableFragment,
    useRelayEnvironment,
    useSubscribeToInvalidationState,
    useSubscription
  };
  return lib;
}
var reactRelay;
var hasRequiredReactRelay;
function requireReactRelay() {
  if (hasRequiredReactRelay) return reactRelay;
  hasRequiredReactRelay = 1;
  reactRelay = requireLib();
  return reactRelay;
}
var reactRelayExports = requireReactRelay();
const pageInfoFragment = node$C;
const node$B = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "tagConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "tagFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "pageInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TagConnection",
  "abstractKey": null
};
node$B.hash = "38b4fc998400fa7a60762ec83a89ba81";
const tagConnectionFragment = node$B;
const node$A = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "tagFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Tag",
  "abstractKey": null
};
node$A.hash = "e54dff492851ff154c2624e05cec16a8";
const tagFragment = node$A;
const node$z = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": null,
        "direction": "forward",
        "path": [
          "tagsFilteredList"
        ]
      }
    ]
  },
  "name": "tagListFragment",
  "selections": [
    {
      "alias": "tagsFilteredList",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "TagConnection",
      "kind": "LinkedField",
      "name": "__tagListFragment___tagsFilteredList_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TagEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Tag",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "tagFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "tagConnectionFragment"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node$z.hash = "67ccb4289a34c48a9d03df751de7d5f3";
const tagListFragment = node$z;
const storeTagFragments = {
  tagListFragment,
  tagFragment,
  tagConnectionFragment,
  pageInfoFragment
};
const node$y = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "drawingSetConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DrawingSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DrawingSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "pageInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DrawingSetConnection",
  "abstractKey": null
};
node$y.hash = "c0c993a143b666843903346f7eeab64a";
const drawingSetConnectionFragment = node$y;
const node$x = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "drawingSetEdgeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DrawingSet",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "drawingSetFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DrawingSetEdge",
  "abstractKey": null
};
node$x.hash = "4cff0a971182f2960bf9d60a6ceef28a";
const drawingSetEdgeFragment = node$x;
const node$w = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "drawingSetFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdById",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentJobId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previousJobId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "measureUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "versionDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectId",
      "storageKey": null
    }
  ],
  "type": "DrawingSet",
  "abstractKey": null
};
node$w.hash = "92041ab36ae9a76a6a76beca6877ac31";
const drawingSetFragment = node$w;
const node$v = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "drawingSetJobFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdById",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "drawingSetId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stageProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stageStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedAt",
      "storageKey": null
    }
  ],
  "type": "DrawingSetJob",
  "abstractKey": null
};
node$v.hash = "90df543f534d2aa06b6129202757046a";
const drawingSetJobFragment = node$v;
const node$u = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": null,
        "direction": "forward",
        "path": [
          "drawingSetList"
        ]
      }
    ]
  },
  "name": "drawingSetListFragment",
  "selections": [
    {
      "alias": "drawingSetList",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "DrawingSetConnection",
      "kind": "LinkedField",
      "name": "__drawingSetListFragment___drawingSetList_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DrawingSetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "drawingSetFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "drawingSetConnectionFragment"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node$u.hash = "7993b023291ff89c34667346225b3d9e";
const drawingSetListFragment = node$u;
const node$t = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "drawingSetSheetConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DrawingSetSheetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DrawingSetSheet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetSheetFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageTableInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "pageTableInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DrawingSetSheetTableConnection",
  "abstractKey": null
};
node$t.hash = "943bde879c456f4ecab72bae5b721dba";
const drawingSetSheetConnectionFragment = node$t;
const node$s = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "drawingSetSheetFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdById",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "versionDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "drawingSetId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRemoved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revision",
      "storageKey": null
    }
  ],
  "type": "DrawingSetSheet",
  "abstractKey": null
};
node$s.hash = "f168b69410cb48ddac294217d6395b6f";
const drawingSetSheetFragment = node$s;
const node$r = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": null,
        "direction": "forward",
        "path": [
          "drawingSetSheetTable"
        ]
      }
    ]
  },
  "name": "drawingSetSheetTableFragment",
  "selections": [
    {
      "alias": "drawingSetSheetTable",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "DrawingSetSheetTableConnection",
      "kind": "LinkedField",
      "name": "__drawingSetSheetTableFragment___drawingSetSheetTable_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DrawingSetSheetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetSheet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "drawingSetSheetFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "drawingSetSheetConnectionFragment"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageTableInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node$r.hash = "949dd6bbad833e61d66595d34ed8b7dd";
const drawingSetSheetTableFragment = node$r;
const node$q = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "drawingSetTableConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DrawingSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DrawingSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tags",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageTableInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "pageTableInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DrawingSetTableConnection",
  "abstractKey": null
};
node$q.hash = "bb1107ef85270acd64df7552e136edd7";
const drawingSetTableConnectionFragment = node$q;
const node$p = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": null,
        "direction": "forward",
        "path": [
          "drawingSetTable"
        ]
      }
    ]
  },
  "name": "drawingSetTableFragment",
  "selections": [
    {
      "alias": "drawingSetTable",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "DrawingSetTableConnection",
      "kind": "LinkedField",
      "name": "__drawingSetTableFragment___drawingSetTable_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DrawingSetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "drawingSetFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "drawingSetTableConnectionFragment"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageTableInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node$p.hash = "5503b93c58c6c714d5c2fc6f8c8388c6";
const drawingSetTableFragment = node$p;
const node$o = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "drawingSetVersionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdById",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "versionDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "drawingSetId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobId",
      "storageKey": null
    }
  ],
  "type": "DrawingSetVersion",
  "abstractKey": null
};
node$o.hash = "b6505af156fd3bad6165ad44c22371c2";
const drawingSetVersionFragment = node$o;
const node$n = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "drawingSetVersionListConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DrawingSetVersionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DrawingSetVersion",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetVersionFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "pageInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DrawingSetVersionConnection",
  "abstractKey": null
};
node$n.hash = "93607d430333a2daf0b3c5f91def82c1";
const drawingSetVersionListConnectionFragment = node$n;
const node$m = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": null,
        "direction": "forward",
        "path": [
          "drawingSetVersionList"
        ]
      }
    ]
  },
  "name": "drawingSetVersionListFragment",
  "selections": [
    {
      "alias": "drawingSetVersionList",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "DrawingSetVersionConnection",
      "kind": "LinkedField",
      "name": "__drawingSetVersionListFragment___drawingSetVersionList_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DrawingSetVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "drawingSetVersionFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "drawingSetVersionListConnectionFragment"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node$m.hash = "0de14bfb1e6ddd08bbdd7347c92aca33";
const drawingSetVersionListFragment = node$m;
const node$l = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "drawingSetVersionTableConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DrawingSetVersionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DrawingSetVersion",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetVersionFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageTableInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "pageTableInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DrawingSetVersionTableConnection",
  "abstractKey": null
};
node$l.hash = "438cd1ff1942cc5a46bf7da3fc196f86";
const drawingSetVersionTableConnectionFragment = node$l;
const node$k = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": null,
        "direction": "forward",
        "path": [
          "drawingSetVersionTable"
        ]
      }
    ]
  },
  "name": "drawingSetVersionTableFragment",
  "selections": [
    {
      "alias": "drawingSetVersionTable",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "DrawingSetVersionTableConnection",
      "kind": "LinkedField",
      "name": "__drawingSetVersionTableFragment___drawingSetVersionTable_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DrawingSetVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "drawingSetVersionFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "drawingSetVersionTableConnectionFragment"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageTableInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node$k.hash = "56c8d650346840d8dbfd39b74c6c79d9";
const drawingSetVersionTableFragment = node$k;
const node$j = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "pageTableInfoFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "limit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "page",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalPages",
      "storageKey": null
    }
  ],
  "type": "PageTableInfo",
  "abstractKey": null
};
node$j.hash = "5a3e4b7c6deb06755297067803d8ca7d";
const pageTableInfoFragment = node$j;
const node$i = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "projectConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Project",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "projectFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "pageInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectConnection",
  "abstractKey": null
};
node$i.hash = "d9bb67ef6f5692aae4f2500c135da080";
const projectConnectionFragment = node$i;
const node$h = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "projectFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created_at",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created_by",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deleted_at",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updated_at",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updated_by",
      "storageKey": null
    }
  ],
  "type": "Project",
  "abstractKey": null
};
node$h.hash = "9b0d80a3125faf1011e5cc02cf3c167e";
const projectFragment = node$h;
const node$g = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": null,
        "direction": "forward",
        "path": [
          "projectList"
        ]
      }
    ]
  },
  "name": "projectListFragment",
  "selections": [
    {
      "alias": "projectList",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "ProjectConnection",
      "kind": "LinkedField",
      "name": "__projectListFragment___projectList_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Project",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "projectFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "projectConnectionFragment"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node$g.hash = "3018ecf2c075f36a319559b56f32078a";
const projectListFragment = node$g;
const storeDrawingsFragments = {
  drawingSetFragment,
  drawingSetEdgeFragment,
  pageTableInfoFragment,
  drawingSetConnectionFragment,
  drawingSetTableConnectionFragment,
  drawingSetTableFragment,
  projectConnectionFragment,
  projectFragment,
  projectListFragment,
  drawingSetVersionTableConnectionFragment,
  drawingSetVersionListConnectionFragment,
  drawingSetVersionListFragment,
  drawingSetVersionFragment,
  drawingSetVersionTableFragment,
  drawingSetSheetConnectionFragment,
  drawingSetSheetFragment,
  drawingSetSheetTableFragment,
  drawingSetJobFragment,
  drawingSetListFragment,
  ...storeTagFragments
  // tagFragment,
};
const Tag = { "useTags": false, "field": { "id": { "name": "id", "title": "Id", "description": "", "type": "string", "isReadonly": true } }, "context": { "table": ["id"], "inspector": ["id"], "createMutation": ["id"], "updateMutation": ["id"] } };
const schema$1 = {
  Tag
};
const node$f = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "getTagFilteredListQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "tagListFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "getTagFilteredListQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "TagConnection",
          "kind": "LinkedField",
          "name": "tagsFilteredList",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TagEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Tag",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasPreviousPage",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [
            "input"
          ],
          "handle": "connection",
          "key": "tagListFragment___tagsFilteredList",
          "kind": "LinkedHandle",
          "name": "tagsFilteredList"
        }
      ]
    },
    "params": {
      "cacheID": "7a3dae0cf67d597a89056e97e65a5b03",
      "id": null,
      "metadata": {},
      "name": "getTagFilteredListQuery",
      "operationKind": "query",
      "text": "query getTagFilteredListQuery(\n  $input: TagsFilteredListInput!\n) {\n  ...tagListFragment_2VV6jB\n}\n\nfragment tagConnectionFragment on TagConnection {\n  edges {\n    cursor\n    node {\n      ...tagFragment\n    }\n  }\n}\n\nfragment tagFragment on Tag {\n  id\n}\n\nfragment tagListFragment_2VV6jB on Query {\n  tagsFilteredList(input: $input) {\n    edges {\n      cursor\n      node {\n        ...tagFragment\n        __typename\n      }\n    }\n    ...tagConnectionFragment\n  }\n}\n"
    }
  };
}();
node$f.hash = "017eea82b76f85e4f10fd4e96e8f383f";
const getTagFilteredListQuery = node$f;
const tagModel = {
  label: "Tag",
  name: "tag",
  queryList: getTagFilteredListQuery,
  schema: schema$1.Tag
};
const node$e = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "getDrawingSetJobQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetJob",
          "kind": "LinkedField",
          "name": "drawingSetJob",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetJobFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "getDrawingSetJobQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetJob",
          "kind": "LinkedField",
          "name": "drawingSetJob",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "drawingSetId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "finishedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobProgress",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stageProgress",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stageStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startedAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b4c557cdecf332a2a40a8513c63fdf8d",
      "id": null,
      "metadata": {},
      "name": "getDrawingSetJobQuery",
      "operationKind": "query",
      "text": "query getDrawingSetJobQuery(\n  $id: ID!\n) {\n  drawingSetJob(id: $id) {\n    ...drawingSetJobFragment\n    id\n  }\n}\n\nfragment drawingSetJobFragment on DrawingSetJob {\n  id\n  createdAt\n  updatedAt\n  createdById\n  drawingSetId\n  finishedAt\n  jobProgress\n  jobStatus\n  stage\n  stageProgress\n  stageStatus\n  startedAt\n}\n"
    }
  };
}();
node$e.hash = "68d6ab0b2435adfc76089eec52ff0dd0";
const getDrawingSetJobQuery = node$e;
const DrawingSetSheet = { "useTags": false, "field": { "id": { "name": "id", "title": "Id", "description": "", "type": "string", "isReadonly": true }, "drawingSetId": { "name": "drawingSetId", "title": "Drawing Set Id", "description": "", "type": "string", "isReadonly": false, "isFilterable": true }, "revision": { "name": "revision", "title": "Revision", "description": "", "type": "integer", "isReadonly": false }, "order": { "name": "order", "title": "Order", "description": "", "type": "integer", "isReadonly": false }, "name": { "name": "name", "title": "Name", "description": "", "type": "string", "isReadonly": false }, "number": { "name": "number", "title": "Number", "description": "", "type": "string", "isReadonly": false }, "versionDate": { "name": "versionDate", "title": "Version Date", "description": "", "type": "integer", "isReadonly": false, "isFilterable": true, "isOrderable": true }, "isRemoved": { "name": "isRemoved", "title": "Is Removed", "description": "", "type": "integer", "isReadonly": false }, "createdById": { "name": "createdById", "title": "Created By Id", "description": "", "type": "string", "isReadonly": false }, "createdAt": { "name": "createdAt", "title": "Created At", "description": "", "type": "integer", "isReadonly": false, "isOrderable": true }, "updatedAt": { "name": "updatedAt", "title": "Updated At", "description": "", "type": "integer", "isReadonly": true, "constraints": {}, "defaultSetter": "CURRENT_DATETIME", "isOrderable": true } }, "context": { "table": ["id", "drawingSetId", "revision", "order", "name", "number", "versionDate", "isRemoved", "createdAt", "updatedAt"], "inspector": ["id", "drawingSetId", "revision", "order", "name", "number", "versionDate", "isRemoved", "createdAt", "updatedAt"], "createMutation": ["id", "drawingSetId", "revision", "order", "name", "number", "versionDate", "isRemoved", "createdAt", "updatedAt"], "updateMutation": ["id", "drawingSetId", "revision", "order", "name", "number", "versionDate", "isRemoved", "updatedAt"] } };
const DrawingSetVersion = { "useTags": false, "field": { "id": { "name": "id", "title": "Id", "description": "", "type": "string", "isReadonly": true }, "status": { "name": "status", "title": "Status", "description": "", "type": "DrawingSetVersionStatus", "isReadonly": false }, "drawingSetId": { "name": "drawingSetId", "title": "Drawing Set Id", "description": "", "type": "string", "isReadonly": false, "isFilterable": true }, "versionDate": { "name": "versionDate", "title": "Version Date", "description": "", "type": "integer", "isReadonly": false, "isFilterable": true, "isOrderable": true }, "jobId": { "name": "jobId", "title": "Job Id", "description": "", "type": "string", "isReadonly": false }, "fileName": { "name": "fileName", "title": "File Name", "description": "", "type": "string", "isReadonly": true }, "createdById": { "name": "createdById", "title": "Created By Id", "description": "", "type": "string", "isReadonly": true, "constraints": {}, "defaultSetter": "AUTH_USER_ID" }, "createdAt": { "name": "createdAt", "title": "Created At", "description": "", "type": "integer", "isReadonly": true, "constraints": {}, "defaultSetter": "CURRENT_DATETIME" }, "updatedAt": { "name": "updatedAt", "title": "Updated At", "description": "", "type": "integer", "isReadonly": true, "constraints": {}, "defaultSetter": "CURRENT_DATETIME" } }, "context": { "table": ["id", "status", "drawingSetId", "versionDate", "jobId", "fileName", "createdById", "createdAt", "updatedAt"], "inspector": ["id", "status", "drawingSetId", "versionDate", "jobId", "fileName", "createdById", "createdAt", "updatedAt"], "createMutation": ["id", "status", "drawingSetId", "versionDate", "jobId", "fileName", "createdById", "createdAt", "updatedAt"], "updateMutation": ["status", "drawingSetId", "versionDate", "jobId", "fileName", "updatedAt"] } };
const DrawingSet = { "useTags": true, "field": { "id": { "name": "id", "title": "Id", "description": "", "type": "string", "isReadonly": true }, "projectId": { "name": "projectId", "title": "Project Id", "description": "", "type": "string", "isReadonly": false, "isRequired": true, "isFilterable": true }, "status": { "name": "status", "title": "Status", "description": "", "type": "DrawingSetStatus", "isReadonly": false }, "name": { "name": "name", "title": "Name", "description": "", "type": "string", "isReadonly": false, "isRequired": true, "isOrderable": true }, "versionDate": { "name": "versionDate", "title": "Version Date", "description": "", "type": "integer", "isReadonly": false }, "measureUnit": { "name": "measureUnit", "title": "Measure Unit", "description": "", "type": "MeasureUnit", "isReadonly": false }, "currentJobId": { "name": "currentJobId", "title": "Current Job Id", "description": "", "type": "string", "isReadonly": false }, "previousJobId": { "name": "previousJobId", "title": "Previous Job Id", "description": "", "type": "string", "isReadonly": false }, "fileName": { "name": "fileName", "title": "File Name", "description": "", "type": "string", "isReadonly": true }, "createdById": { "name": "createdById", "title": "Created By Id", "description": "", "type": "string", "isReadonly": true, "constraints": {}, "defaultSetter": "AUTH_USER_ID" }, "createdAt": { "name": "createdAt", "title": "Created At", "description": "", "type": "integer", "isReadonly": true, "constraints": {}, "defaultSetter": "CURRENT_DATETIME", "isOrderable": true }, "updatedAt": { "name": "updatedAt", "title": "Updated At", "description": "", "type": "integer", "isReadonly": true, "constraints": {}, "defaultSetter": "CURRENT_DATETIME" }, "tags": { "name": "tags", "title": "Tags", "description": "", "type": "string", "isReadonly": false, "constraints": { "toUniqueCommaList": true } } }, "context": { "table": ["id", "projectId", "status", "name", "versionDate", "measureUnit", "currentJobId", "previousJobId", "fileName", "createdById", "createdAt", "updatedAt", "tags"], "inspector": ["id", "projectId", "status", "name", "versionDate", "measureUnit", "currentJobId", "previousJobId", "fileName", "createdById", "createdAt", "updatedAt", "tags"], "createMutation": ["id", "projectId", "status", "name", "versionDate", "measureUnit", "currentJobId", "previousJobId", "fileName", "createdById", "createdAt", "updatedAt", "tags"], "updateMutation": ["projectId", "status", "name", "versionDate", "measureUnit", "currentJobId", "previousJobId", "fileName", "updatedAt", "tags"] } };
const DrawingSetJob = { "useTags": false, "field": { "id": { "name": "id", "title": "Id", "description": "", "type": "string", "isReadonly": false }, "drawingSetId": { "name": "drawingSetId", "title": "Drawing Set Id", "description": "", "type": "string", "isReadonly": false, "isFilterable": true }, "stage": { "name": "stage", "title": "Stage", "description": "", "type": "DrawingSetJobStageType", "isReadonly": false }, "stageStatus": { "name": "stageStatus", "title": "Stage Status", "description": "", "type": "StageStatus", "isReadonly": false }, "stageProgress": { "name": "stageProgress", "title": "Stage Progress", "description": "", "type": "number", "isReadonly": false }, "jobStatus": { "name": "jobStatus", "title": "Job Status", "description": "", "type": "JobStatus", "isReadonly": false }, "jobProgress": { "name": "jobProgress", "title": "Job Progress", "description": "", "type": "number", "isReadonly": false }, "createdById": { "name": "createdById", "title": "Created By Id", "description": "", "type": "string", "isReadonly": false }, "createdAt": { "name": "createdAt", "title": "Created At", "description": "", "type": "integer", "isReadonly": false, "isOrderable": true }, "updatedAt": { "name": "updatedAt", "title": "Updated At", "description": "", "type": "integer", "isReadonly": false }, "startedAt": { "name": "startedAt", "title": "Started At", "description": "", "type": "integer", "isReadonly": false }, "finishedAt": { "name": "finishedAt", "title": "Finished At", "description": "", "type": "integer", "isReadonly": false } }, "context": { "table": ["id", "drawingSetId", "stage", "stageStatus", "stageProgress", "jobStatus", "jobProgress", "createdById", "createdAt", "updatedAt", "startedAt", "finishedAt"], "inspector": ["id", "drawingSetId", "stage", "stageStatus", "stageProgress", "jobStatus", "jobProgress", "createdById", "createdAt", "updatedAt", "startedAt", "finishedAt"], "createMutation": ["id", "drawingSetId", "stage", "stageStatus", "stageProgress", "jobStatus", "jobProgress", "createdById", "createdAt", "updatedAt", "startedAt", "finishedAt"], "updateMutation": ["id", "drawingSetId", "stage", "stageStatus", "stageProgress", "jobStatus", "jobProgress", "createdById", "createdAt", "updatedAt", "startedAt", "finishedAt"] } };
const Project = { "useTags": false, "field": { "id": { "name": "id", "title": "Id", "description": "", "type": "string", "isReadonly": false, "isFilterable": true }, "name": { "name": "name", "title": "Name", "description": "", "type": "string", "isReadonly": false }, "number": { "name": "number", "title": "Number", "description": "", "type": "string", "isReadonly": false }, "status": { "name": "status", "title": "Status", "description": "", "type": "integer", "isReadonly": false }, "created_at": { "name": "created_at", "title": "Created At", "description": "", "type": "string", "isReadonly": false }, "updated_at": { "name": "updated_at", "title": "Updated At", "description": "", "type": "string", "isReadonly": false }, "deleted_at": { "name": "deleted_at", "title": "Deleted At", "description": "", "type": "string", "isReadonly": false }, "created_by": { "name": "created_by", "title": "Created By", "description": "", "type": "string", "isReadonly": false }, "updated_by": { "name": "updated_by", "title": "Updated By", "description": "", "type": "string", "isReadonly": false } }, "context": { "table": ["id", "name", "number", "status", "created_at", "updated_at", "deleted_at", "created_by", "updated_by"], "inspector": ["id", "name", "number", "status", "created_at", "updated_at", "deleted_at", "created_by", "updated_by"], "createMutation": ["id", "name", "number", "status", "created_at", "updated_at", "deleted_at", "created_by", "updated_by"], "updateMutation": ["id", "name", "number", "status", "created_at", "updated_at", "deleted_at", "created_by", "updated_by"] } };
const schema = {
  DrawingSetSheet,
  DrawingSetVersion,
  DrawingSet,
  DrawingSetJob,
  Project
};
const drawingSetJobModel = {
  label: "Drawing Set Job",
  name: "drawingSetJob",
  queryOne: getDrawingSetJobQuery,
  schema: schema.DrawingSetJob
};
const storeFragment = {};
const registerStoreFragments = (fragments) => {
  Object.assign(storeFragment, fragments);
  return storeFragment;
};
const getFragment = (name) => storeFragment[name];
const useFragmentFromStore = (fragmentRef) => {
  const fragments = fragmentRef == null ? void 0 : fragmentRef.__fragments;
  const [listNameOfFragments] = Object.keys(fragments || {});
  return reactRelayExports.useFragment(getFragment(listNameOfFragments || "pageTableInfoFragment"), fragmentRef);
};
const EntitySelectOption = ({ node: node2, listFieldName }) => {
  const dataEntity = useFragmentFromStore(node2);
  return (listFieldName == null ? void 0 : listFieldName.map((name) => dataEntity[name]).join(" ")) || dataEntity["name"];
};
memo(EntitySelectOption);
const DynamicListEntity = () => forwardRef(
  ({ model, listName, listFieldName, style, renderLabel, onSelect, input = {}, ...restProps }, ref) => {
    var _a;
    const resultEntityList = reactRelayExports.useLazyLoadQuery(
      model.queryList,
      { input, first: 100 },
      { fetchPolicy: "store-or-network" }
    );
    const data = useFragmentFromStore(resultEntityList);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { ref, allowClear: false, style, onSelect: (value) => {
      onSelect == null ? void 0 : onSelect(value, data[listName]);
    }, ...restProps, children: (_a = data[listName]) == null ? void 0 : _a.edges.map((edge) => /* @__PURE__ */ jsxRuntimeExports.jsx(Select.Option, { value: edge.node.__id, children: renderLabel ? renderLabel(edge.node) : /* @__PURE__ */ jsxRuntimeExports.jsx(EntitySelectOption, { node: edge.node, listFieldName }) }, edge.node.__id)) });
  }
);
const FieldDynamicListEntity = ({ field, style, ...restProps }) => {
  const fallback = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Form.Item, { label: field.title, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { disabled: field.isReadonly, loading: true, style }) }) });
  const FieldDynamicList = DynamicListEntity();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Form.Item, { name: field.name, label: field.title, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldDynamicList, { disabled: false, style, ...restProps }) }) });
};
memo(FieldDynamicListEntity);
const SmxInspectorContext = createContext({});
const InspectorProvider = ({
  connectionId,
  currentId,
  isLoading: initialLoading,
  isOpen: initialOpen,
  parentNode,
  parentData,
  parentModelName,
  filterProject,
  children
}) => {
  const [isLoading, setIsLoadingState] = useState(!!initialLoading);
  const [isOpen, setIsOpenState] = useState(!!initialOpen);
  const [errorInfo, setErrorInfoState] = useState();
  const setIsLoading = useCallback((value) => {
    setIsLoadingState(value);
  }, []);
  const setIsOpen = useCallback((value) => {
    setIsOpenState(value);
  }, []);
  const setErrorInfo = useCallback((value) => {
    setErrorInfoState(value);
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SmxInspectorContext.Provider,
    {
      value: {
        connectionId,
        isLoading,
        setIsLoading,
        errorInfo,
        setErrorInfo,
        isOpen,
        setIsOpen,
        currentId,
        parentNode,
        parentData,
        parentModelName,
        filterProject
      },
      children
    }
  );
};
const ViewerAppryze = memo(({ file, fileName, height = "186px" }) => {
  const webViewerRef = useRef(null);
  const [isViewerInitialized, setIsViewerInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [webViewer, setWebViewer] = useState(null);
  const fullDomain = window.location.origin;
  console.log(loading);
  useEffect(() => {
    let instance = null;
    const initWebViewer = async () => {
      if (!webViewerRef.current || isViewerInitialized) return;
      setLoading(true);
      try {
        instance = await WebViewer(
          {
            path: `${fullDomain}/webviewer/lib`,
            isReadOnly: true,
            enableAnnotations: false,
            fullAPI: false,
            enableMeasurement: false,
            enableRedaction: false,
            enableOptimizedWorkers: true
          },
          webViewerRef.current
        );
        const { UI } = instance;
        UI.disableElements([
          "toolbarGroup-Annotate",
          "toolbarGroup-Edit",
          "toolbarGroup-Insert",
          "toolbarGroup-Shapes",
          "toolbarGroup-Forms",
          "toolbarGroup-View",
          "toolbarGroup-FillAndSign",
          "toolbarGroup-Measure",
          "toolbarGroup-Redaction",
          "toolbarGroup-Text",
          "toolbarGroup-Notes",
          "toolbarGroup-Undo",
          "toolbarGroup-Search",
          "toolbarGroup-PageControls",
          "toolbar",
          "leftPanel",
          "leftPanelButton",
          "menuButton",
          "toolsHeader",
          "contextMenuPopup",
          "zoomOverlay",
          "searchButton",
          "ribbons",
          "toolbarGroup-View",
          "viewControlsButton",
          "header",
          "toolsHeader",
          "pageNavOverlay"
        ]);
        UI.setToolbarGroup("");
        setWebViewer(instance);
        setIsViewerInitialized(true);
      } catch (error) {
        console.error("Error initializing WebViewer:", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
    };
    if (!isViewerInitialized) {
      const timeoutId = setTimeout(() => {
        initWebViewer();
      }, 100);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    return () => {
      if (instance) {
        instance.UI.closeDocument();
        setWebViewer(null);
        setIsViewerInitialized(false);
      }
    };
  }, [isViewerInitialized, file]);
  useEffect(() => {
    if (!webViewer || !file) return;
    const loadDocument = () => {
      try {
        webViewer.UI.loadDocument(file, {
          filename: (file == null ? void 0 : file.name) || fileName
        });
      } catch (error) {
        console.error("Error loading document:", error);
      }
    };
    loadDocument();
  }, [webViewer, file]);
  return (
    // <Spin spinning={loading} style={{ width: '100%', height: '100%' }}>
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        ref: webViewerRef,
        style: {
          width: "100%",
          height
        }
      }
    )
  );
});
const ViewerWrapperAppryze = ({
  file,
  mode = "viewer",
  fileName,
  urlPictPreview,
  onClick
}) => {
  const [isMaximyze, setIsMaximyze] = useState(false);
  const close = (e) => {
    setIsMaximyze(false);
    e.stopPropagation();
  };
  const openModalView = (e) => {
    setIsMaximyze(true);
    e.stopPropagation();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    mode === "viewer" && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        onClick: openModalView,
        type: "text",
        variant: "filled",
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(FullscreenOutlined, {}),
        style: {
          position: "absolute",
          zIndex: 1e3,
          top: 0,
          left: 0
        }
      }
    ),
    mode === "viewer" && /* @__PURE__ */ jsxRuntimeExports.jsx(ViewerAppryze, { file, fileName }),
    mode === "pict" && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Image,
      {
        onClick: onClick || openModalView,
        width: 130,
        src: urlPictPreview,
        preview: false,
        style: { cursor: "pointer", border: "1px solid #ddd" }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Modal,
      {
        title: "Drawing view",
        open: isMaximyze,
        onCancel: close,
        width: "90%",
        style: { top: 20 },
        footer: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { type: "primary", onClick: close, children: "Close" }, "custom-ok")
        ],
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ViewerAppryze, { file, fileName, height: "calc(100vh - 156px)" })
      }
    )
  ] });
};
const { Dragger } = Upload;
const FieldUploadFile = () => {
  var _a;
  const form = Form.useFormInstance();
  const { errorInfo, setErrorInfo } = useContext(SmxInspectorContext);
  const [file, setFile] = useState(null);
  useEffect(() => {
    var _a2;
    if (!file) {
      form.setFieldsValue({
        file: null
      });
    } else {
      setErrorInfo == null ? void 0 : setErrorInfo({
        ...errorInfo,
        errorFields: (_a2 = errorInfo == null ? void 0 : errorInfo.errorFields) == null ? void 0 : _a2.filter((field) => !field.name.includes("file"))
      });
    }
  }, [file]);
  const props = {
    name: "file",
    multiple: true,
    maxCount: 1,
    accept: "application/pdf",
    showUploadList: false,
    beforeUpload: () => false,
    // customRequest,
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(">>>>>", info.file, info.fileList);
        setFile(info.file);
        form.setFieldsValue({
          fileName: info.file.name
        });
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    }
  };
  const hasError = (_a = errorInfo == null ? void 0 : errorInfo.errorFields) == null ? void 0 : _a.filter(
    (field) => field.name.includes("file") && field.errors.length
  ).length;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Form.Item, { name: "file", label: "File", rules: [{ required: true, message: "Upload file" }], children: /* @__PURE__ */ jsxRuntimeExports.jsx(Dragger, { ...props, style: hasError ? { border: "1px solid red" } : {}, children: !file ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { vertical: true, align: "center", style: { padding: "40px 0" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "ant-upload-drag-icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FilePdfOutlined, { style: { fontSize: 40 } }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "ant-upload-text", style: { fontSize: 14 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { color: "#1677ff" }, children: "Upload a file" }),
        ", drag and drop"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "ant-upload-hint", children: "PDF type only" })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          onClick: () => {
            setFile(null);
          },
          type: "text",
          variant: "filled",
          icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseOutlined, {}),
          style: {
            position: "absolute",
            zIndex: 1e3,
            top: 0,
            right: 0
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ViewerWrapperAppryze, { file })
    ] }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Form.Item, { name: "fileName", label: "File Name", rules: [{ required: true, message: "Fill out file name" }], children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { style: { width: "100%" }, disabled: true }) })
  ] });
};
const storeSimpleList = {
  measureUnit: [
    {
      id: "METER",
      value: "meter"
    },
    {
      id: "FEET",
      value: "feet"
    }
  ]
};
const FieldSimpleList = ({ listName, schemaField, message: message2 }) => {
  console.log(schemaField);
  const simpleList = storeSimpleList[listName];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Form.Item,
    {
      name: schemaField.name,
      label: schemaField.title,
      rules: [{ required: schemaField.isRequired, message: message2 || "Fill out data" }],
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { allowClear: true, children: simpleList.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx(Select.Option, { value: item.id, children: item.value }, item.id)) })
    }
  );
};
class LuxonError extends Error {
}
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}
class ConflictingSpecificationError extends LuxonError {
}
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}
class InvalidArgumentError extends LuxonError {
}
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}
const n = "numeric", s = "short", l = "long";
const DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
const DATE_MED = {
  year: n,
  month: s,
  day: n
};
const DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
const DATE_FULL = {
  year: n,
  month: l,
  day: n
};
const DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
const TIME_SIMPLE = {
  hour: n,
  minute: n
};
const TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
const TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
const TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
const TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
const TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
const TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
const TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
const DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
const DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
const DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
const DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
const DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
const DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
const DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
const DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
const DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}
let singleton$1 = null;
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new SystemZone();
    }
    return singleton$1;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
}
let dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
  }
  return dtfCache[zone];
}
const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
let ianaZoneCache = {};
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(s2) {
    return this.isValidZone(s2);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = IANAZone.isValidZone(name);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    const date = new Date(ts);
    if (isNaN(date)) return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
let intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
let intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
let intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts;
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
let weekInfoCache = {};
function getCachedWeekInfo(locString) {
  let data = weekInfoCache[locString];
  if (!data) {
    const locale = new Intl.Locale(locString);
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const { padTo, floor, ...otherOpts } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}
class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z = void 0;
    if (this.opts.timeZone) {
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({ minutes: dt.offset });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({ minutes: dt.offset });
      this.originalZone = dt.zone;
    }
    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return {
            ...part,
            value: offsetName
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}
const fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class Locale {
  static fromOpts(opts) {
    return Locale.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        validateWeekSettings(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }
  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const intl = format ? { month: length, day: "numeric" } : { month: length }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format ? { weekday: length, year: "numeric", month: "long", day: "numeric" } : { weekday: length }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays(
          (dt) => this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff(
      this,
      void 0,
      () => meridiems,
      () => {
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = { era: length };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(
          (dt) => this.extract(dt, intl, "era")
        );
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let singleton = null;
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset2) {
    return offset2 === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset2);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s2) {
    if (s2) {
      const r = s2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
}
class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
}
function normalizeZone(input, defaultZone2) {
  if (isUndefined(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone2;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
const numberingSystems = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
};
const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
let digitRegexCache = {};
function resetDigitRegexCache() {
  digitRegexCache = {};
}
function digitRegex({ numberingSystem }, append = "") {
  const ns = numberingSystem || "latn";
  if (!digitRegexCache[ns]) {
    digitRegexCache[ns] = {};
  }
  if (!digitRegexCache[ns][append]) {
    digitRegexCache[ns][append] = new RegExp(`${numberingSystems[ns]}${append}`);
  }
  return digitRegexCache[ns][append];
}
let now = () => Date.now(), defaultZone = "system", defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid, defaultWeekSettings = null;
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n2) {
    now = n2;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
}
class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}
const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i) => i < ordinal), day = ordinal - table[month0];
  return { month: month0 + 1, day };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear), validWeek = integerBetween(
    obj.weekNumber,
    1,
    weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)
  ), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}
function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v) => !integerBetween(v, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
function floorMod(x, n2) {
  return x - n2 * Math.floor(x / n2);
}
function padStart(input, n2 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n2, "0");
  } else {
    padded = ("" + input).padStart(n2, "0");
  }
  return padded;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f);
  }
}
function roundTo(number, digits, towardZero = false) {
  const factor = 10 ** digits, rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = { timeZoneName: offsetFormat, ...intlOpts };
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === void 0 || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
function formatOffset(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}
const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const meridiems = ["AM", "PM"];
const erasLong = ["Before Christ", "Anno Domini"];
const erasShort = ["BC", "AD"];
const erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens(splits, tokenToString) {
  let s2 = "";
  for (const token of splits) {
    if (token.literal) {
      s2 += token.val;
    } else {
      s2 += tokenToString(token.val);
    }
  }
  return s2;
}
const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n2, p = 0) {
    if (this.opts.forceSimple) {
      return padStart(n2, p);
    }
    const opts = { ...this.opts };
    if (p > 0) {
      opts.padTo = p;
    }
    return this.loc.numberFormatter(opts).format(n2);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract) => this.loc.extract(dt, opts, extract), formatOffset2 = (opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, meridiem = () => knownEnglish ? meridiemForDateTime(dt) : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), month = (length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"), weekday = (length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string(
      standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
      "weekday"
    ), maybeMacro = (token) => {
      const formatOpts = Formatter.macroTokenToFormatOpts(token);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    }, era = (length) => knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, "era"), tokenToString = (token) => {
      switch (token) {
        // ms
        case "S":
          return this.num(dt.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(dt.millisecond, 3);
        // seconds
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        // minutes
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        // hours
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        // offset
        case "Z":
          return formatOffset2({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return formatOffset2({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return formatOffset2({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return dt.zoneName;
        // meridiems
        case "a":
          return meridiem();
        // dates
        case "d":
          return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        // weekdays - format
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        // months - standalone
        case "L":
          return useDateTimeFormatter ? string({ month: "numeric", day: "numeric" }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string({ month: "2-digit", day: "numeric" }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        // months - format
        case "M":
          return useDateTimeFormatter ? string({ month: "numeric" }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string({ month: "2-digit" }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        // years
        case "y":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string({ year: "2-digit" }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 6);
        // eras
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "n":
          return this.num(dt.localWeekNumber);
        case "nn":
          return this.num(dt.localWeekNumber, 2);
        case "ii":
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt.localWeekYear, 4);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token);
      }
    };
    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const tokenToField = (token) => {
      switch (token[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, tokenToString = (lildur) => (token) => {
      const mapped = tokenToField(token);
      if (mapped) {
        return this.num(lildur.get(mapped), token.length);
      } else {
        return token;
      }
    }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(
      (found, { literal, val }) => literal ? found : found.concat(val),
      []
    ), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
}
const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
  return (m) => extractors.reduce(
    ([mergedVals, mergedZone, cursor], ex) => {
      const [val, zone, next] = ex(m, cursor);
      return [{ ...mergedVals, ...val }, zone || mergedZone, next];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function parse(s2, ...patterns) {
  if (s2 == null) {
    return [null, null];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s2);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}
function simpleParse(...keys) {
  return (match2, cursor) => {
    const ret = {};
    let i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match2[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match2, pos, fallback) {
  const m = match2[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match2, cursor) {
  const item = {
    year: int(match2, cursor),
    month: int(match2, cursor + 1, 1),
    day: int(match2, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}
function extractISOTime(match2, cursor) {
  const item = {
    hours: int(match2, cursor, 0),
    minutes: int(match2, cursor + 1, 0),
    seconds: int(match2, cursor + 2, 0),
    milliseconds: parseMillis(match2[cursor + 3])
  };
  return [item, null, cursor + 4];
}
function extractISOOffset(match2, cursor) {
  const local = !match2[cursor] && !match2[cursor + 1], fullOffset = signedOffset(match2[cursor + 1], match2[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone(match2, cursor) {
  const zone = match2[cursor] ? IANAZone.create(match2[cursor]) : null;
  return [{}, zone, cursor + 1];
}
const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
const isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s2, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s2[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = (num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num;
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
const rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [
    ,
    weekdayStr,
    dayStr,
    monthStr,
    yearStr,
    hourStr,
    minuteStr,
    secondStr,
    obsOffset,
    milOffset,
    offHourStr,
    offMinuteStr
  ] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone(offset2)];
}
function preprocessRFC2822(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseISODate(s2) {
  return parse(
    s2,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}
function parseRFC2822Date(s2) {
  return parse(preprocessRFC2822(s2), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s2) {
  return parse(
    s2,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}
function parseISODuration(s2) {
  return parse(s2, [isoDuration, extractISODuration]);
}
const extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s2) {
  return parse(s2, [isoTimeOnly, extractISOTimeOnly]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseSQL(s2) {
  return parse(
    s2,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}
const INVALID$2 = "Invalid Duration";
const lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, casualMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
}, daysInYearAccurate = 146097 / 400, daysInMonthAccurate = 146097 / 4800, accurateMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
};
const orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
const reverseUnits = orderedUnits$1.slice(0).reverse();
function clone$1(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...alts.values || {} },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
function normalizeValues(matrix, vals) {
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits$1.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
class Duration {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }
    this.values = config.values;
    this.loc = config.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration.fromObject({ milliseconds: count }, opts);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`
      );
    }
    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }
  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false
    };
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID$2;
    const l2 = orderedUnits$1.map((unit) => {
      const val = this.values[unit];
      if (isUndefined(val)) {
        return null;
      }
      return this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) }).format(val);
    }).filter((n2) => n2);
    return this.loc.listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts }).format(l2);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let s2 = "P";
    if (this.years !== 0) s2 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s2 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s2 += this.weeks + "W";
    if (this.days !== 0) s2 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s2 += "T";
    if (this.hours !== 0) s2 += this.hours + "H";
    if (this.minutes !== 0) s2 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s2 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s2 === "P") s2 += "T0S";
    return s2;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5) return null;
    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false
    };
    const dateTime = DateTime.fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration), result = {};
    for (const k of orderedUnits$1) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone$1(this, { values: result }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, { values: result }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid) return this;
    const mixed = { ...this.values, ...normalizeObject(values, Duration.normalizeUnit) };
    return clone$1(this, { values: mixed });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$1(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => Duration.normalizeUnit(u));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits$1) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber(vals[k])) {
          own += vals[k];
        }
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1e3 - i * 1e3) / 1e3;
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone$1(this, { values: built }, true);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, { values: negated }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      if (v1 === void 0 || v1 === 0) return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    for (const u of orderedUnits$1) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
}
const INVALID$1 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}
class Interval {
  /**
   * @private
   */
  constructor(config) {
    this.s = config.start;
    this.e = config.end;
    this.invalid = config.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s2, e] = (text || "").split("/", 2);
    if (s2 && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s2, opts);
        startIsValid = start.isValid;
      } catch (e2) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e2) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s2, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts == null ? void 0 : opts.useLocaleWeeks) {
      end = this.end.reconfigure({ locale: start.locale });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d) => this.contains(d)).sort((a, b) => a.toMillis() - b.toMillis()), results = [];
    let { s: s2 } = this, i = 0;
    while (s2 < this.e) {
      const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s2, next));
      s2 = next;
      i += 1;
    }
    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s2 } = this, idx = 1, next;
    const results = [];
    while (s2 < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s2, next));
      s2 = next;
      idx += 1;
    }
    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s2 = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
    if (s2 >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s2, e);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s2 = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s2, e);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals.sort((a, b) => a.s - b.s).reduce(
      ([sofar, current], item) => {
        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      },
      [[], null]
    );
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i) => [
      { time: i.s, type: "s" },
      { time: i.e, type: "e" }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return Interval.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return INVALID$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });
    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative(), localeWeek: hasLocaleWeekInfo() };
  }
}
function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - days % 7) / 7;
      }
    ],
    ["days", dayDiff]
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
        if (cursor > later) {
          highWater = cursor;
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [cursor, results, highWater, lowestOrder];
}
function diff(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s2]) => post(parseDigits(s2)) };
}
const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s2) {
  return s2.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s2) {
  return s2.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s2]) => strings.findIndex((i) => stripInsensitivities(s2) === stripInsensitivities(i)) + startIndex
    };
  }
}
function offset(regex, groups) {
  return { regex, deser: ([, h, m]) => signedOffset(h, m), groups };
}
function simple(regex) {
  return { regex, deser: ([s2]) => s2 };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function unitForToken(token, loc) {
  const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = (t) => ({ regex: RegExp(escapeToken(t.val)), deser: ([s2]) => s2, literal: true }), unitate = (t) => {
    if (token.literal) {
      return literal(t);
    }
    switch (t.val) {
      // era
      case "G":
        return oneOf(loc.eras("short"), 0);
      case "GG":
        return oneOf(loc.eras("long"), 0);
      // years
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      // months
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true), 1);
      case "MMMM":
        return oneOf(loc.months("long", true), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false), 1);
      // dates
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      // ordinals
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      // time
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one);
      // meridiem
      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      // weekdays
      case "E":
      case "c":
        return intUnit(one);
      case "EEE":
        return oneOf(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return literal(t);
    }
  };
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type];
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [`^${re}$`, units];
}
function match(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }
    return r;
  }, {});
  return [vals, zone, specificOffset];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}
class TokenParser {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return { input, tokens: this.tokens, invalidReason: this.invalidReason };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [null, null, void 0];
      if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError(
          "Can't include meridiem when specifying 24-hour format"
        );
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}
const INVALID = "Invalid DateTime";
const MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(
      dt.c,
      dt.loc.getMinDaysInFirstWeek(),
      dt.loc.getStartOfWeek()
    );
  }
  return dt.localWeekData;
}
function clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime({ ...current, ...alts, old: current });
}
function fixOffset(localTS, o, tz) {
  let utcGuess = localTS - o * 60 * 1e3;
  const o2 = tz.offset(utcGuess);
  if (o === o2) {
    return [utcGuess, o];
  }
  utcGuess -= (o2 - o) * 60 * 1e3;
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }
  return [localTS - Math.min(o2, o3) * 60 * 1e3, Math.max(o2, o3)];
}
function tsToObj(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = {
    ...inst.c,
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }, millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c);
  let [ts, o] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o = inst.zone.offset(ts);
  }
  return { ts, o };
}
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, {
      ...opts,
      zone: interpretationZone,
      specificOffset
    });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
function toISODate(o, extended) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
  let c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }
  if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);
    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}
const defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"], orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}
function guessOffsetForZone(zone) {
  if (!zoneOffsetGuessCache[zone]) {
    if (zoneOffsetTs === void 0) {
      zoneOffsetTs = Settings.now();
    }
    zoneOffsetGuessCache[zone] = zone.offset(zoneOffsetTs);
  }
  return zoneOffsetGuessCache[zone];
}
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  const loc = Locale.fromObject(opts);
  let ts, o;
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }
  return new DateTime({ ts, zone, loc, o });
}
function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round, format = (c, unit) => {
    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
    const formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  }, differ = (unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}
let zoneOffsetTs;
let zoneOffsetGuessCache = {};
class DateTime {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;
    let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    let c = null, o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c;
    this.o = o;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new DateTime({
      ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -864e13 || milliseconds > MAX_DATE) {
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }
    if (!inst.isValid) {
      return DateTime.invalid(inst.invalid);
    }
    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => t ? t.val : null).join("");
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }
  static resetCache() {
    zoneOffsetTs = void 0;
    zoneOffsetGuessCache = {};
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
    }
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [clone(this, { ts: ts1 }), clone(this, { ts: ts2 })];
    }
    return [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, { ts: newTS, zone });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone(this, { loc });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid) return this;
    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(
        { ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone(this, { ts, o });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;
    const o = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid ? this.plus({ [unit]: 1 }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    const ext = format === "extended";
    let c = toISODate(this, ext);
    c += "T";
    c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    let c = includePrefix ? "T" : "";
    return c + toISOTime(
      this,
      format === "extended",
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone
    );
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = { ...this.c };
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime.fromObject({}, { zone: this.zone }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;
    return diffRelative(options.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    });
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return new TokenParser(localeToUse, fmt);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError(
        "fromFormatParser requires an input string and a format parser"
      );
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(
        `fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`
      );
    }
    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(
        result,
        zone,
        opts,
        `format ${formatParser.format}`,
        text,
        specificOffset
      );
    }
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}
const useValidateInspectorForm = (form) => {
  const { setErrorInfo } = useContext(SmxInspectorContext);
  const validate = async () => {
    try {
      await (form == null ? void 0 : form.validateFields());
      setErrorInfo == null ? void 0 : setErrorInfo(void 0);
      return true;
    } catch (errorInfo) {
      console.log("Error validation:", errorInfo);
      setErrorInfo == null ? void 0 : setErrorInfo(errorInfo);
    }
    return false;
  };
  return { validate };
};
const initialState$3 = {
  currentEntityList: [],
  isCloseAll: false
};
const inspectorSlice = createSlice({
  name: "inspector",
  initialState: initialState$3,
  reducers: {
    setterInspector: (state, action) => ({
      ...state,
      ...action.payload
    }),
    setCurrentModel: (state, action) => {
      if (!state.currentEntityList.find((entity) => entity.key === action.payload.key)) {
        state.currentEntityList.push(action.payload);
      }
    },
    deleteCurrentModel: (state, action) => {
      state.currentEntityList = state.currentEntityList.filter((entity) => entity.key !== action.payload);
    },
    setManyModel: (state, action) => {
      state.currentEntityList = action.payload;
    }
  },
  extraReducers: () => {
  }
});
const { setCurrentModel, deleteCurrentModel, setterInspector, setManyModel, setStoreConnectionId: setStoreConnectionId$1 } = inspectorSlice.actions;
const inspectorReducer = inspectorSlice.reducer;
const parseArrayUrlParam = (paramName) => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get(paramName);
  if (!paramValue) {
    return [];
  }
  return paramValue.split(",").map((value) => decodeURIComponent(value.trim())).filter((value) => value.length > 0);
};
const initialState$2 = {
  isUpdateAfterUploadDrawingSetVersion: {},
  currentTags: parseArrayUrlParam("tags"),
  bufferTags: {},
  searchResult: {},
  isAndFilterTag: true,
  formDrawingSheetWasChanged: {}
};
const drawingsReducers = {
  setterDrawings: {
    reducer: (state, action) => {
      return { ...state, ...action.payload };
    },
    prepare: (payload) => {
      return { payload };
    }
  },
  setIsUpdateAfterUploadDrawingSetVersion: (state, action) => {
    state.isUpdateAfterUploadDrawingSetVersion = action.payload;
  },
  setSearchResult: (state, action) => {
    state.searchResult = { ...state.searchResult, ...action.payload };
  },
  setBuffer: (state, action) => {
    const newState = { ...state.bufferTags };
    Object.keys(action.payload).forEach((key) => {
      if (newState[key] && Array.isArray(newState[key])) {
        newState[key].push(...action.payload[key]);
      } else {
        newState[key] = action.payload[key];
      }
    });
    state.bufferTags = newState;
  },
  setFormDrawingSheetWasChanged: (state, action) => {
    state.formDrawingSheetWasChanged = { ...state.formDrawingSheetWasChanged, ...action.payload };
  }
};
const drawingsSlice = createSlice({
  name: "drawings",
  initialState: initialState$2,
  reducers: drawingsReducers,
  extraReducers: () => {
  }
});
const {
  setterDrawings,
  setIsUpdateAfterUploadDrawingSetVersion,
  setSearchResult,
  setBuffer,
  setFormDrawingSheetWasChanged
} = drawingsSlice.actions;
const drawingsReducers$1 = drawingsSlice.reducer;
const FormButtonSaveSetDrawings = ({
  values,
  form,
  responseSource,
  connectionId,
  mutation
}) => {
  const dispatch = useDispatch();
  const { validate } = useValidateInspectorForm(form);
  const [commitCreate, isInFlightCreating] = reactRelayExports.useMutation(mutation);
  const uploadToUrl = (url, presignedForm, file, onProgress) => {
    const formData = new FormData();
    Object.entries(presignedForm).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("file", file);
    return axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: (progressEvent) => {
        const percent = Math.round(progressEvent.loaded * 100 / (progressEvent.total || 1));
        if (onProgress) onProgress(percent);
      }
    });
  };
  const commit = (input) => {
    return {
      variables: {
        input,
        connections: connectionId ? [connectionId] : []
      },
      onCompleted: (response, errors) => {
        if (errors) {
          console.log(
            errors[0].extensions.debugMessage,
            errors
          );
        } else {
          console.log("Save drawings set successful", response, values, values.file.fileList[0]);
          const uploadData = JSON.parse(response[responseSource].uploadFields);
          uploadToUrl(
            response[responseSource].uploadUrl,
            uploadData,
            values.file.fileList[0].originFileObj,
            (percent) => {
              console.log(">>>", percent);
            }
          );
          dispatch(setIsUpdateAfterUploadDrawingSetVersion({ [values.drawingSetId]: true }));
          dispatch(setterInspector({ nameNewEntity: void 0 }));
          console.log(uploadData);
        }
      },
      onError: (error) => {
        console.error("Mutation error:", error);
      }
    };
  };
  const onClick = async () => {
    var _a;
    if (await validate()) {
      const data = {
        tags: (_a = values.tags) == null ? void 0 : _a.join(","),
        versionDate: values.versionDate.unix(),
        fileName: values.fileName,
        name: values.name,
        measureUnit: values.measureUnit,
        projectId: values.projectId,
        drawingSetId: values.drawingSetId
      };
      commitCreate(commit(data));
      console.log(data, mutation);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { icon: /* @__PURE__ */ jsxRuntimeExports.jsx(SaveOutlined, {}), onClick, loading: isInFlightCreating, children: "Save" });
};
const FormButtonSaveSetDrawings$1 = memo(FormButtonSaveSetDrawings);
const node$d = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cursor",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uploadFields",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uploadUrl",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "createDrawingSetMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "DrawingSetCreateOutput",
          "kind": "LinkedField",
          "name": "createDrawingSet",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetEdge",
              "kind": "LinkedField",
              "name": "edge",
              "plural": false,
              "selections": [
                v3,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DrawingSet",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "drawingSetFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v4,
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "createDrawingSetMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "DrawingSetCreateOutput",
          "kind": "LinkedField",
          "name": "createDrawingSet",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetEdge",
              "kind": "LinkedField",
              "name": "edge",
              "plural": false,
              "selections": [
                v3,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DrawingSet",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdById",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentJobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "previousJobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "measureUnit",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tags",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "versionDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "appendEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "edge",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            v4,
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e68e4be08cbff486296ac50e3b2e01e7",
      "id": null,
      "metadata": {},
      "name": "createDrawingSetMutation",
      "operationKind": "mutation",
      "text": "mutation createDrawingSetMutation(\n  $input: DrawingSetCreateInput!\n) {\n  createDrawingSet(input: $input) {\n    edge {\n      cursor\n      node {\n        ...drawingSetFragment\n        id\n      }\n    }\n    uploadFields\n    uploadUrl\n  }\n}\n\nfragment drawingSetFragment on DrawingSet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  currentJobId\n  fileName\n  previousJobId\n  status\n  name\n  measureUnit\n  tags\n  versionDate\n  projectId\n}\n"
    }
  };
}();
node$d.hash = "8bb8d96d1de2c5d2d0624d5485d0c091";
const createDrawingSetMutation = node$d;
const node$c = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    },
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "updateDrawingSetMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSet",
          "kind": "LinkedField",
          "name": "updateDrawingSet",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "updateDrawingSetMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSet",
          "kind": "LinkedField",
          "name": "updateDrawingSet",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentJobId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "previousJobId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measureUnit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tags",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "versionDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9cd7b14771f76aa2b38a62e2f8cf8d94",
      "id": null,
      "metadata": {},
      "name": "updateDrawingSetMutation",
      "operationKind": "mutation",
      "text": "mutation updateDrawingSetMutation(\n  $id: ID!\n  $input: DrawingSetUpdateInput!\n) {\n  updateDrawingSet(id: $id, input: $input) {\n    ...drawingSetFragment\n    id\n  }\n}\n\nfragment drawingSetFragment on DrawingSet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  currentJobId\n  fileName\n  previousJobId\n  status\n  name\n  measureUnit\n  tags\n  versionDate\n  projectId\n}\n"
    }
  };
}();
node$c.hash = "ce495dd3dba5f3ce9dc2f18f9faa471b";
const updateDrawingSetMutation = node$c;
const node$b = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "getDrawingSetListQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "drawingSetListFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "getDrawingSetListQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetConnection",
          "kind": "LinkedField",
          "name": "drawingSetList",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DrawingSet",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdById",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentJobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "previousJobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "measureUnit",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tags",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "versionDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [
            "input"
          ],
          "handle": "connection",
          "key": "drawingSetListFragment___drawingSetList",
          "kind": "LinkedHandle",
          "name": "drawingSetList"
        }
      ]
    },
    "params": {
      "cacheID": "a8ed9aafd8a0c00f9683466c63da8440",
      "id": null,
      "metadata": {},
      "name": "getDrawingSetListQuery",
      "operationKind": "query",
      "text": "query getDrawingSetListQuery(\n  $input: DrawingSetListInput!\n) {\n  ...drawingSetListFragment_2VV6jB\n}\n\nfragment drawingSetConnectionFragment on DrawingSetConnection {\n  edges {\n    cursor\n    node {\n      ...drawingSetFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageInfoFragment\n  }\n}\n\nfragment drawingSetFragment on DrawingSet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  currentJobId\n  fileName\n  previousJobId\n  status\n  name\n  measureUnit\n  tags\n  versionDate\n  projectId\n}\n\nfragment drawingSetListFragment_2VV6jB on Query {\n  drawingSetList(input: $input) {\n    edges {\n      cursor\n      node {\n        ...drawingSetFragment\n        id\n        __typename\n      }\n    }\n    ...drawingSetConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment pageInfoFragment on PageInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n}\n"
    }
  };
}();
node$b.hash = "6f5101626360e86c4301ed36471c4b22";
const getDrawingSetListQuery = node$b;
const node$a = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "getDrawingSetQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSet",
          "kind": "LinkedField",
          "name": "drawingSet",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "getDrawingSetQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSet",
          "kind": "LinkedField",
          "name": "drawingSet",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentJobId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "previousJobId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measureUnit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tags",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "versionDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4a4b086945f21f00b8771b6b173aacdb",
      "id": null,
      "metadata": {},
      "name": "getDrawingSetQuery",
      "operationKind": "query",
      "text": "query getDrawingSetQuery(\n  $id: ID!\n) {\n  drawingSet(id: $id) {\n    ...drawingSetFragment\n    id\n  }\n}\n\nfragment drawingSetFragment on DrawingSet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  currentJobId\n  fileName\n  previousJobId\n  status\n  name\n  measureUnit\n  tags\n  versionDate\n  projectId\n}\n"
    }
  };
}();
node$a.hash = "d55f0cbe3b6f9c7b6c9107f017f78aac";
const getDrawingSetQuery = node$a;
const node$9 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "getDrawingSetTableQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "drawingSetTableFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "getDrawingSetTableQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetTableConnection",
          "kind": "LinkedField",
          "name": "drawingSetTable",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DrawingSet",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdById",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentJobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "previousJobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "measureUnit",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tags",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "versionDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageTableInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "limit",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "page",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalPages",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [
            "input"
          ],
          "handle": "connection",
          "key": "drawingSetTableFragment___drawingSetTable",
          "kind": "LinkedHandle",
          "name": "drawingSetTable"
        }
      ]
    },
    "params": {
      "cacheID": "be0c06a8d87de1873d7d8d99251b350f",
      "id": null,
      "metadata": {},
      "name": "getDrawingSetTableQuery",
      "operationKind": "query",
      "text": "query getDrawingSetTableQuery(\n  $input: DrawingSetTableInput!\n) {\n  ...drawingSetTableFragment_2VV6jB\n}\n\nfragment drawingSetFragment on DrawingSet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  currentJobId\n  fileName\n  previousJobId\n  status\n  name\n  measureUnit\n  tags\n  versionDate\n  projectId\n}\n\nfragment drawingSetTableConnectionFragment on DrawingSetTableConnection {\n  edges {\n    cursor\n    node {\n      tags\n      ...drawingSetFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageTableInfoFragment\n  }\n}\n\nfragment drawingSetTableFragment_2VV6jB on Query {\n  drawingSetTable(input: $input) {\n    edges {\n      cursor\n      node {\n        ...drawingSetFragment\n        id\n        __typename\n      }\n    }\n    ...drawingSetTableConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment pageTableInfoFragment on PageTableInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n  totalCount\n  limit\n  page\n  totalPages\n}\n"
    }
  };
}();
node$9.hash = "66fc503664cfc8232263af55f2b4790f";
const getDrawingSetTableQuery = node$9;
const node$8 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "getDrawingProjectListQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "projectListFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "getDrawingProjectListQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "ProjectConnection",
          "kind": "LinkedField",
          "name": "projectList",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Project",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "number",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "created_at",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "created_by",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "deleted_at",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updated_at",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updated_by",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [
            "input"
          ],
          "handle": "connection",
          "key": "projectListFragment___projectList",
          "kind": "LinkedHandle",
          "name": "projectList"
        }
      ]
    },
    "params": {
      "cacheID": "2bc92ccd603c50da0d30faf9802276ff",
      "id": null,
      "metadata": {},
      "name": "getDrawingProjectListQuery",
      "operationKind": "query",
      "text": "query getDrawingProjectListQuery(\n  $input: ProjectListInput!\n) {\n  ...projectListFragment_2VV6jB\n}\n\nfragment pageInfoFragment on PageInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n}\n\nfragment projectConnectionFragment on ProjectConnection {\n  edges {\n    cursor\n    node {\n      ...projectFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageInfoFragment\n  }\n}\n\nfragment projectFragment on Project {\n  id\n  status\n  name\n  number\n  created_at\n  created_by\n  deleted_at\n  updated_at\n  updated_by\n}\n\nfragment projectListFragment_2VV6jB on Query {\n  projectList(input: $input) {\n    edges {\n      cursor\n      node {\n        ...projectFragment\n        id\n        __typename\n      }\n    }\n    ...projectConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
    }
  };
}();
node$8.hash = "b3100ffc30c3bb1366bda2ed67ce9d06";
const getDrawingProjectListQuery = node$8;
const projectModel = {
  label: "Project",
  name: "project",
  queryList: getDrawingProjectListQuery,
  schema: schema.Project
};
const drawingSetModel = {
  label: "Drawing Set",
  name: "drawingSet",
  query: getDrawingSetTableQuery,
  queryList: getDrawingSetListQuery,
  queryOne: getDrawingSetQuery,
  mutation: {
    update: updateDrawingSetMutation
    // delete: deleteDrawingSetMutation,
  },
  context: {
    inspectorInput: ["fileName", "tags", "name", "versionDate", "measureUnit", "projectId"],
    inspectorInputEdit: ["tags", "name", "measureUnit"],
    inspectorInputHide: ["projectId", "versionDate"]
  },
  schema: schema.DrawingSet,
  isCheckBoxColumn: true,
  defaultData: {
    versionDate: () => dayjs(DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss"))
  },
  loaderInspector: {
    tags: (fieldData) => fieldData.split(","),
    projectId: (fieldData) => fieldData
  },
  prepareDataForMutation: {
    tags: (value) => value.join(",")
  },
  renderData: {
    inspectorField: {
      fileName: () => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(FieldUploadFile, {});
      },
      versionDate: () => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Form.Item, { name: "versionDate", label: "Set version date", rules: [{ required: true }], children: /* @__PURE__ */ jsxRuntimeExports.jsx(DatePicker, { format: "YYYY-MM-DD hh:mm:ss" }) });
      },
      measureUnit: ({ schemaField }) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(FieldSimpleList, { schemaField, listName: "measureUnit" });
      },
      tags: ({ schemaField }) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          FieldDynamicListEntity,
          {
            listFieldName: ["id"],
            field: schemaField,
            listName: "tagsFilteredList",
            model: tagModel,
            mode: "tags"
          }
        );
      },
      projectId: ({ schemaField, filterProject }) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          FieldDynamicListEntity,
          {
            listFieldName: ["name", "number"],
            field: schemaField,
            listName: "projectList",
            model: projectModel,
            input: {
              filter: {
                id: {
                  operator: "IN",
                  value: (filterProject == null ? void 0 : filterProject.join(",")) || ""
                }
              }
            }
          }
        );
      }
    }
  },
  action: {
    table: [
      ({ entity, values, form, connectionId }) => {
        return !entity && /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormButtonSaveSetDrawings$1,
          {
            mutation: createDrawingSetMutation,
            responseSource: "createDrawingSet",
            values,
            form,
            connectionId
          }
        );
      }
    ],
    inspector: [
      ({ entity, values, form, connectionId }) => {
        return !entity && /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormButtonSaveSetDrawings$1,
          {
            mutation: createDrawingSetMutation,
            responseSource: "createDrawingSet",
            values,
            form,
            connectionId
          }
        );
      }
    ]
  }
};
const axiosInstance = axios.create();
const getAxios = () => {
  return window.soixa ?? axiosInstance;
};
const bufferUrlAndObject = {};
const useLoadingProtectUrl = (url, token) => {
  const [data, setData] = useState("");
  const [isInFlight, setIsInFlight] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        if (!bufferUrlAndObject[url]) {
          setIsInFlight(true);
          const signedUrlResponse = await getAxios().get(url, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          const signedUrl = signedUrlResponse.data.signedUrl;
          const response = await axios.get(signedUrl, {
            responseType: "blob",
            headers: {
              Accept: "*/*"
            }
          });
          bufferUrlAndObject[url] = URL.createObjectURL(response.data);
        }
        setIsInFlight(false);
        setData(bufferUrlAndObject[url]);
      } catch (error) {
        console.error("Download error:", error);
        setIsInFlight(false);
      }
    })();
  }, [url, token]);
  return { data, isInFlight };
};
const ViewerProtectPictWrapperAppryze = ({
  token = "",
  urlPdf,
  urlPictPreview,
  minHeight,
  onClick
}) => {
  const { data: dataPdf, isInFlight: isInFlight1 } = useLoadingProtectUrl(urlPdf, token);
  const { data: dataPictPreview, isInFlight: isInFlight2 } = useLoadingProtectUrl(urlPictPreview, token);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Spin, { spinning: isInFlight1 || isInFlight2, style: { minHeight }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      onClick: (e) => {
        e.stopPropagation();
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ViewerWrapperAppryze, { file: dataPdf, mode: "pict", urlPictPreview: dataPictPreview, onClick })
    }
  ) });
};
const DateTableCell = ({ value, format }) => {
  return DateTime.fromSeconds(value).toFormat(format);
};
const FORMAT_DATE_TIME = "yyyy-MM-dd hh:mm:ss";
const ButtonDeleteDrawingSetSheet = ({ dataEntity }) => {
  const dispatch = useDispatch();
  const checkboxRef = useRef(null);
  const [isRemoved, setIsRemoved] = useState(false);
  useEffect(() => {
    if (isRemoved) {
      dispatch(setFormDrawingSheetWasChanged({ [dataEntity.id]: true }));
    }
  }, [isRemoved]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { width: 70, textAlign: "center", margin: "auto" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Form.Item,
      {
        name: [dataEntity.id, "isRemoved"],
        style: { margin: 0 },
        valuePropName: "checked",
        hidden: true,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { ref: checkboxRef, checked: isRemoved })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        onClick: (e) => {
          var _a, _b;
          e.stopPropagation();
          setIsRemoved(!isRemoved);
          (_b = (_a = checkboxRef.current) == null ? void 0 : _a.input) == null ? void 0 : _b.click();
        },
        variant: !isRemoved ? "outlined" : "text",
        size: "small",
        icon: !isRemoved ? /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteOutlined, {}) : void 0,
        color: "danger",
        children: isRemoved ? "Deleted" : null
      }
    )
  ] });
};
const node$7 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "drawingSetSheetBatchSavingMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetSheetSavingOutput",
          "kind": "LinkedField",
          "name": "drawingSetSheetBatchSaving",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetSheet",
              "kind": "LinkedField",
              "name": "updatedSheets",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "drawingSetSheetFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "drawingSetSheetBatchSavingMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetSheetSavingOutput",
          "kind": "LinkedField",
          "name": "drawingSetSheetBatchSaving",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetSheet",
              "kind": "LinkedField",
              "name": "updatedSheets",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdById",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "versionDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "drawingSetId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "number",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isRemoved",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "order",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "revision",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c4938764a1c73d7b17ee277f4bd5c2aa",
      "id": null,
      "metadata": {},
      "name": "drawingSetSheetBatchSavingMutation",
      "operationKind": "mutation",
      "text": "mutation drawingSetSheetBatchSavingMutation(\n  $input: DrawingSetSheetBatchSavingInput!\n) {\n  drawingSetSheetBatchSaving(input: $input) {\n    updatedSheets {\n      ...drawingSetSheetFragment\n      id\n    }\n  }\n}\n\nfragment drawingSetSheetFragment on DrawingSetSheet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  versionDate\n  drawingSetId\n  number\n  name\n  isRemoved\n  order\n  revision\n}\n"
    }
  };
}();
node$7.hash = "bdd2989462508bb8acbdc8bb3cf48a96";
const drawingSetSheetBatchSavingMutation = node$7;
const node$6 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "getDrawingSetSheetQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetSheet",
          "kind": "LinkedField",
          "name": "drawingSetSheet",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetSheetFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "getDrawingSetSheetQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetSheet",
          "kind": "LinkedField",
          "name": "drawingSetSheet",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "versionDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "drawingSetId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "number",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRemoved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "order",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "revision",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6e61f9995720b3825ecb7802e460df01",
      "id": null,
      "metadata": {},
      "name": "getDrawingSetSheetQuery",
      "operationKind": "query",
      "text": "query getDrawingSetSheetQuery(\n  $id: ID!\n) {\n  drawingSetSheet(id: $id) {\n    ...drawingSetSheetFragment\n    id\n  }\n}\n\nfragment drawingSetSheetFragment on DrawingSetSheet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  versionDate\n  drawingSetId\n  number\n  name\n  isRemoved\n  order\n  revision\n}\n"
    }
  };
}();
node$6.hash = "e1c117cbcf89552cdc753edf788dd545";
const getDrawingSetSheetQuery = node$6;
const node$5 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "getDrawingSetSheetTableQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "drawingSetSheetTableFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "getDrawingSetSheetTableQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetSheetTableConnection",
          "kind": "LinkedField",
          "name": "drawingSetSheetTable",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetSheetEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DrawingSetSheet",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdById",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "versionDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "drawingSetId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "number",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isRemoved",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "order",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "revision",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageTableInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "limit",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "page",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalPages",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [
            "input"
          ],
          "handle": "connection",
          "key": "drawingSetSheetTableFragment___drawingSetSheetTable",
          "kind": "LinkedHandle",
          "name": "drawingSetSheetTable"
        }
      ]
    },
    "params": {
      "cacheID": "abe5210c0832b355ff306f977e1536e9",
      "id": null,
      "metadata": {},
      "name": "getDrawingSetSheetTableQuery",
      "operationKind": "query",
      "text": "query getDrawingSetSheetTableQuery(\n  $input: DrawingSetSheetTableInput!\n) {\n  ...drawingSetSheetTableFragment_2VV6jB\n}\n\nfragment drawingSetSheetConnectionFragment on DrawingSetSheetTableConnection {\n  edges {\n    cursor\n    node {\n      ...drawingSetSheetFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageTableInfoFragment\n  }\n}\n\nfragment drawingSetSheetFragment on DrawingSetSheet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  versionDate\n  drawingSetId\n  number\n  name\n  isRemoved\n  order\n  revision\n}\n\nfragment drawingSetSheetTableFragment_2VV6jB on Query {\n  drawingSetSheetTable(input: $input) {\n    edges {\n      cursor\n      node {\n        ...drawingSetSheetFragment\n        id\n        __typename\n      }\n    }\n    ...drawingSetSheetConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment pageTableInfoFragment on PageTableInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n  totalCount\n  limit\n  page\n  totalPages\n}\n"
    }
  };
}();
node$5.hash = "74d4d38b368ad5bfc48e3a1dfc2879fb";
const getDrawingSetSheetTableQuery = node$5;
const drawingSetSheetModel = {
  label: "Drawing Set Sheet",
  name: "drawingSetSheet",
  query: getDrawingSetSheetTableQuery,
  queryOne: getDrawingSetSheetQuery,
  mutation: {
    bulkUpdate: drawingSetSheetBatchSavingMutation
  },
  context: {
    table: ["id", "number", "name", "revision", "updatedAt", "isRemoved"],
    inspectorInput: ["drawingSetId", "name", "versionDate"],
    tableInput: ["number", "name", "isRemoved"]
  },
  aliasLabelColumn: {
    table: {
      id: "Drawing",
      number: "Page No.",
      name: "Page Title",
      revision: "Revision",
      updatedAt: "Set last update",
      isRemoved: "Action"
    }
  },
  schema: schema.DrawingSetSheet,
  isCheckBoxColumn: true,
  defaultData: {
    versionDate: () => dayjs(DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss"))
  },
  renderData: {
    inspectorField: {
      versionDate: () => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Form.Item, { name: "versionDate", label: "Set version date", rules: [{ required: true }], children: /* @__PURE__ */ jsxRuntimeExports.jsx(DatePicker, { format: "YYYY-MM-DD hh:mm:ss" }) });
      },
      drawingSetId: ({ schemaField, filterProject }) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          FieldDynamicListEntity,
          {
            listFieldName: ["name"],
            field: schemaField,
            listName: "drawingSetList",
            model: drawingSetModel,
            input: {
              filter: {
                id: {
                  operator: "IN",
                  value: (filterProject == null ? void 0 : filterProject.join(",")) || ""
                }
              }
            }
          }
        );
      }
    },
    tableCell: {
      id: (_, __, dataEntity) => {
        const urlPictPreview = `${API.DRAWINGS_S3_URL}/get-file/sheets/${dataEntity.drawingSetId}/${dataEntity.id}/artifacts/sheet@512.png`;
        const urlPdf = `${API.DRAWINGS_S3_URL}/get-file/sheets/${dataEntity.drawingSetId}/${dataEntity.id}/${dataEntity.id}.pdf`;
        return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { minHeight: HEIGHT_PICT_VIEW }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ViewerProtectPictWrapperAppryze,
          {
            urlPdf,
            urlPictPreview,
            token: API.GRAPHQL_TOKEN,
            minHeight: HEIGHT_PICT_VIEW
          }
        ) });
      },
      updatedAt: (_, fieldData) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(DateTableCell, { value: fieldData, format: FORMAT_DATE_TIME });
      },
      isRemoved: (_, __, dataEntity) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonDeleteDrawingSetSheet, { dataEntity });
      }
    }
  }
};
const node$4 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cursor",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uploadFields",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uploadUrl",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "createDrawingSetVersionMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "DrawingSetVersionCreateOutput",
          "kind": "LinkedField",
          "name": "createDrawingSetVersion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetEdge",
              "kind": "LinkedField",
              "name": "edge",
              "plural": false,
              "selections": [
                v3,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DrawingSet",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "drawingSetFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v4,
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "createDrawingSetVersionMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "DrawingSetVersionCreateOutput",
          "kind": "LinkedField",
          "name": "createDrawingSetVersion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetEdge",
              "kind": "LinkedField",
              "name": "edge",
              "plural": false,
              "selections": [
                v3,
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DrawingSet",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdById",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentJobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "previousJobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "measureUnit",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tags",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "versionDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projectId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "appendEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "edge",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            v4,
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "28c3bd1d929329859b561665fa65c1e8",
      "id": null,
      "metadata": {},
      "name": "createDrawingSetVersionMutation",
      "operationKind": "mutation",
      "text": "mutation createDrawingSetVersionMutation(\n  $input: DrawingSetVersionCreateInput!\n) {\n  createDrawingSetVersion(input: $input) {\n    edge {\n      cursor\n      node {\n        ...drawingSetFragment\n        id\n      }\n    }\n    uploadFields\n    uploadUrl\n  }\n}\n\nfragment drawingSetFragment on DrawingSet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  currentJobId\n  fileName\n  previousJobId\n  status\n  name\n  measureUnit\n  tags\n  versionDate\n  projectId\n}\n"
    }
  };
}();
node$4.hash = "8895e341f80f18e3ac1902aae90a79b2";
const createDrawingSetVersionMutation = node$4;
const node$3 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    },
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "getDrawingSetVersionListQuery",
      "selections": [
        {
          "args": v2,
          "kind": "FragmentSpread",
          "name": "drawingSetVersionListFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "getDrawingSetVersionListQuery",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "DrawingSetVersionConnection",
          "kind": "LinkedField",
          "name": "drawingSetVersionList",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetVersionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DrawingSetVersion",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdById",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "versionDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "drawingSetId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v2,
          "filters": [
            "input"
          ],
          "handle": "connection",
          "key": "drawingSetVersionListFragment___drawingSetVersionList",
          "kind": "LinkedHandle",
          "name": "drawingSetVersionList"
        }
      ]
    },
    "params": {
      "cacheID": "d45623e01fae308955ee0388cf444e09",
      "id": null,
      "metadata": {},
      "name": "getDrawingSetVersionListQuery",
      "operationKind": "query",
      "text": "query getDrawingSetVersionListQuery(\n  $input: DrawingSetVersionListInput!\n  $first: Int\n) {\n  ...drawingSetVersionListFragment_1oNFuy\n}\n\nfragment drawingSetVersionFragment on DrawingSetVersion {\n  id\n  createdAt\n  updatedAt\n  createdById\n  fileName\n  versionDate\n  status\n  drawingSetId\n  jobId\n}\n\nfragment drawingSetVersionListConnectionFragment on DrawingSetVersionConnection {\n  edges {\n    cursor\n    node {\n      ...drawingSetVersionFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageInfoFragment\n  }\n}\n\nfragment drawingSetVersionListFragment_1oNFuy on Query {\n  drawingSetVersionList(input: $input, first: $first) {\n    edges {\n      cursor\n      node {\n        ...drawingSetVersionFragment\n        id\n        __typename\n      }\n    }\n    ...drawingSetVersionListConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment pageInfoFragment on PageInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n}\n"
    }
  };
}();
node$3.hash = "0425830846f562f056c0e3a38105a35a";
const getDrawingSetVersionListQuery = node$3;
const node$2 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "getDrawingSetVersionQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetVersion",
          "kind": "LinkedField",
          "name": "drawingSetVersion",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetVersionFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "getDrawingSetVersionQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetVersion",
          "kind": "LinkedField",
          "name": "drawingSetVersion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "versionDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "drawingSetId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "c28d33681b66d49b3b25dc55bab0f083",
      "id": null,
      "metadata": {},
      "name": "getDrawingSetVersionQuery",
      "operationKind": "query",
      "text": "query getDrawingSetVersionQuery(\n  $id: ID!\n) {\n  drawingSetVersion(id: $id) {\n    ...drawingSetVersionFragment\n    id\n  }\n}\n\nfragment drawingSetVersionFragment on DrawingSetVersion {\n  id\n  createdAt\n  updatedAt\n  createdById\n  fileName\n  versionDate\n  status\n  drawingSetId\n  jobId\n}\n"
    }
  };
}();
node$2.hash = "a0af229c4912bfd9b60008e67631e66c";
const getDrawingSetVersionQuery = node$2;
const node$1 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "getDrawingSetVersionTableQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "drawingSetVersionTableFragment"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "getDrawingSetVersionTableQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetVersionTableConnection",
          "kind": "LinkedField",
          "name": "drawingSetVersionTable",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DrawingSetVersionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DrawingSetVersion",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdById",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fileName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "versionDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "drawingSetId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageTableInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "limit",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "page",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalPages",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [
            "input"
          ],
          "handle": "connection",
          "key": "drawingSetVersionTableFragment___drawingSetVersionTable",
          "kind": "LinkedHandle",
          "name": "drawingSetVersionTable"
        }
      ]
    },
    "params": {
      "cacheID": "cb11cf8b7e53a07d3254fe17f69ba253",
      "id": null,
      "metadata": {},
      "name": "getDrawingSetVersionTableQuery",
      "operationKind": "query",
      "text": "query getDrawingSetVersionTableQuery(\n  $input: DrawingSetVersionTableInput!\n) {\n  ...drawingSetVersionTableFragment_2VV6jB\n}\n\nfragment drawingSetVersionFragment on DrawingSetVersion {\n  id\n  createdAt\n  updatedAt\n  createdById\n  fileName\n  versionDate\n  status\n  drawingSetId\n  jobId\n}\n\nfragment drawingSetVersionTableConnectionFragment on DrawingSetVersionTableConnection {\n  edges {\n    cursor\n    node {\n      ...drawingSetVersionFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageTableInfoFragment\n  }\n}\n\nfragment drawingSetVersionTableFragment_2VV6jB on Query {\n  drawingSetVersionTable(input: $input) {\n    edges {\n      cursor\n      node {\n        ...drawingSetVersionFragment\n        id\n        __typename\n      }\n    }\n    ...drawingSetVersionTableConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment pageTableInfoFragment on PageTableInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n  totalCount\n  limit\n  page\n  totalPages\n}\n"
    }
  };
}();
node$1.hash = "4a990737010caded4ce755e182240a7b";
const getDrawingSetVersionTableQuery = node$1;
const drawingSetVersionModel = {
  label: "Drawing Set",
  name: "drawingSetVersion",
  query: getDrawingSetVersionTableQuery,
  queryList: getDrawingSetVersionListQuery,
  queryOne: getDrawingSetVersionQuery,
  context: {
    inspectorInput: ["fileName", "versionDate"]
  },
  schema: schema.DrawingSetVersion,
  isCheckBoxColumn: true,
  defaultData: {
    versionDate: () => dayjs(DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss"))
  },
  renderData: {
    inspectorField: {
      fileName: () => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(FieldUploadFile, {});
      },
      versionDate: () => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Form.Item, { name: "versionDate", label: "Set version date", rules: [{ required: true }], children: /* @__PURE__ */ jsxRuntimeExports.jsx(DatePicker, { format: "YYYY-MM-DD hh:mm:ss" }) });
      }
    }
  },
  action: {
    inspector: [
      ({ entity, values, form, connectionId }) => {
        return !entity && /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormButtonSaveSetDrawings$1,
          {
            mutation: createDrawingSetVersionMutation,
            responseSource: "createDrawingSetVersion",
            values,
            form,
            connectionId
          }
        );
      }
    ]
  }
};
const storeDrawingsModel = {
  drawingSet: drawingSetModel,
  drawingSetVersion: drawingSetVersionModel,
  tag: tagModel,
  drawingSetSheet: drawingSetSheetModel,
  drawingSetJob: drawingSetJobModel
};
const AlertEmptyProject = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { padding: 30 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Alert,
    {
      message: "Select project",
      description: "Please select a project from the project filter.",
      type: "warning",
      showIcon: true,
      closable: true
    }
  ) });
};
const parseUrlParam = (paramName) => {
  const urlParams = new URLSearchParams(window.location.search);
  const raw = urlParams.get(paramName);
  if (!raw) {
    return "";
  }
  return decodeURIComponent(raw.trim());
};
const setUrlParam = (paramName, value) => {
  const url = new URL(window.location.href);
  if (value != null && value.trim() !== "") {
    url.searchParams.set(paramName, encodeURIComponent(value.trim()));
  } else {
    url.searchParams.delete(paramName);
  }
  window.history.replaceState({}, "", url.toString());
};
const ButtonAdd = ({
  caption,
  modelName,
  size,
  parentNode,
  parentData,
  parentModelName,
  disabled = false,
  icon,
  minWidth
}) => {
  const dispatch = useDispatch();
  const onClick = useCallback((e) => {
    e.stopPropagation();
    dispatch(setterInspector({ nameNewEntity: modelName, parentNode, parentModelName, parentData }));
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Button,
    {
      type: "primary",
      disabled,
      style: { minWidth: minWidth || "80px" },
      onClick,
      size,
      children: [
        icon || /* @__PURE__ */ jsxRuntimeExports.jsx(PlusOutlined, {}),
        caption
      ]
    }
  );
};
const storeModel = {};
function registerModel(models) {
  Object.assign(storeModel, models);
  return storeModel;
}
const getModel = (modelName) => {
  return storeModel[modelName];
};
const SuspenseLoadingStatus = ({ onStart, onEnd }) => {
  useEffect(() => {
    onStart();
    return () => {
      onEnd();
    };
  }, []);
  return null;
};
const getNameOptionResponseFromFragmentName = (fragmentLink) => fragmentLink ? Object.keys(fragmentLink.__fragments)[0].replace("Fragment", "") : "";
const initialState$1 = {};
const storeModelSlice = createSlice({
  name: "storeModel",
  initialState: initialState$1,
  reducers: {
    setStoreConnectionId: (state, action) => {
      state.storeConnectionId = {
        ...state.storeConnectionId || {},
        ...action.payload
      };
    }
  },
  extraReducers: () => {
  }
});
const { setStoreConnectionId } = storeModelSlice.actions;
const modelReducer = storeModelSlice.reducer;
var murmurhash$3 = { exports: {} };
var hasRequiredMurmurhash$1;
function requireMurmurhash$1() {
  if (hasRequiredMurmurhash$1) return murmurhash$3.exports;
  hasRequiredMurmurhash$1 = 1;
  (function(module) {
    (function() {
      const createBuffer = (val) => new TextEncoder().encode(val);
      function MurmurHashV2(str, seed) {
        if (typeof str === "string") str = createBuffer(str);
        let l2 = str.length, h = seed ^ l2, i = 0, k;
        while (l2 >= 4) {
          k = str[i] & 255 | (str[++i] & 255) << 8 | (str[++i] & 255) << 16 | (str[++i] & 255) << 24;
          k = (k & 65535) * 1540483477 + (((k >>> 16) * 1540483477 & 65535) << 16);
          k ^= k >>> 24;
          k = (k & 65535) * 1540483477 + (((k >>> 16) * 1540483477 & 65535) << 16);
          h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16) ^ k;
          l2 -= 4;
          ++i;
        }
        switch (l2) {
          case 3:
            h ^= (str[i + 2] & 255) << 16;
          case 2:
            h ^= (str[i + 1] & 255) << 8;
          case 1:
            h ^= str[i] & 255;
            h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16);
        }
        h ^= h >>> 13;
        h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16);
        h ^= h >>> 15;
        return h >>> 0;
      }
      function MurmurHashV3(key, seed) {
        if (typeof key === "string") key = createBuffer(key);
        let remainder, bytes, h1, h1b, c1, c2, k1, i;
        remainder = key.length & 3;
        bytes = key.length - remainder;
        h1 = seed;
        c1 = 3432918353;
        c2 = 461845907;
        i = 0;
        while (i < bytes) {
          k1 = key[i] & 255 | (key[++i] & 255) << 8 | (key[++i] & 255) << 16 | (key[++i] & 255) << 24;
          ++i;
          k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
          k1 = k1 << 15 | k1 >>> 17;
          k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
          h1 ^= k1;
          h1 = h1 << 13 | h1 >>> 19;
          h1b = (h1 & 65535) * 5 + (((h1 >>> 16) * 5 & 65535) << 16) & 4294967295;
          h1 = (h1b & 65535) + 27492 + (((h1b >>> 16) + 58964 & 65535) << 16);
        }
        k1 = 0;
        switch (remainder) {
          case 3:
            k1 ^= (key[i + 2] & 255) << 16;
          case 2:
            k1 ^= (key[i + 1] & 255) << 8;
          case 1:
            k1 ^= key[i] & 255;
            k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
            h1 ^= k1;
        }
        h1 ^= key.length;
        h1 ^= h1 >>> 16;
        h1 = (h1 & 65535) * 2246822507 + (((h1 >>> 16) * 2246822507 & 65535) << 16) & 4294967295;
        h1 ^= h1 >>> 13;
        h1 = (h1 & 65535) * 3266489909 + (((h1 >>> 16) * 3266489909 & 65535) << 16) & 4294967295;
        h1 ^= h1 >>> 16;
        return h1 >>> 0;
      }
      const murmur = MurmurHashV3;
      murmur.v2 = MurmurHashV2;
      murmur.v3 = MurmurHashV3;
      {
        module.exports = murmur;
      }
    })();
  })(murmurhash$3);
  return murmurhash$3.exports;
}
var murmurhashExports$1 = requireMurmurhash$1();
const murmurhash$2 = /* @__PURE__ */ getDefaultExportFromCjs(murmurhashExports$1);
const bufferFetchKey = /* @__PURE__ */ new Set();
const WrapperTableLoaderQuery = ({
  model,
  variables,
  setDataSource,
  setDataPageInfo,
  fetchKey,
  upAdditionalField
}) => {
  const dispatch = useDispatch();
  const newHashFetchKey = murmurhash$2.v3(JSON.stringify(variables) + fetchKey);
  const queryResult = reactRelayExports.useLazyLoadQuery(model.query, variables, {
    fetchPolicy: bufferFetchKey.has(newHashFetchKey) ? "store-or-network" : "store-and-network",
    fetchKey
  });
  bufferFetchKey.add(newHashFetchKey);
  const dataConnectionFragment = useFragmentFromStore(queryResult);
  const nameOptionResponse = getNameOptionResponseFromFragmentName(queryResult);
  const dataConnectionList = dataConnectionFragment == null ? void 0 : dataConnectionFragment[nameOptionResponse];
  const connectionId = dataConnectionList == null ? void 0 : dataConnectionList.__id;
  const dataConnection = useFragmentFromStore(connectionId ? dataConnectionList : null);
  const dataPageInfo = useFragmentFromStore((dataConnection == null ? void 0 : dataConnection.pageInfo) || null);
  useEffect(() => {
    setDataPageInfo(dataPageInfo);
  }, [dataPageInfo]);
  useEffect(() => {
    dispatch(setStoreConnectionId({ [model.name]: connectionId }));
  }, [connectionId]);
  useEffect(() => {
    var _a;
    const dataSource = (_a = dataConnection || dataConnectionList) == null ? void 0 : _a.edges.map((edge) => {
      const result = {
        key: edge.cursor,
        userRef: edge.node
      };
      upAdditionalField == null ? void 0 : upAdditionalField.forEach((fieldName) => {
        result[fieldName] = edge.node.tags;
      });
      return result;
    });
    setDataSource(dataSource);
  }, [dataConnectionList]);
  return null;
};
var murmurhash$1 = { exports: {} };
var hasRequiredMurmurhash;
function requireMurmurhash() {
  if (hasRequiredMurmurhash) return murmurhash$1.exports;
  hasRequiredMurmurhash = 1;
  (function(module) {
    (function() {
      const createBuffer = (val) => new TextEncoder().encode(val);
      function MurmurHashV2(str, seed) {
        if (typeof str === "string") str = createBuffer(str);
        let l2 = str.length, h = seed ^ l2, i = 0, k;
        while (l2 >= 4) {
          k = str[i] & 255 | (str[++i] & 255) << 8 | (str[++i] & 255) << 16 | (str[++i] & 255) << 24;
          k = (k & 65535) * 1540483477 + (((k >>> 16) * 1540483477 & 65535) << 16);
          k ^= k >>> 24;
          k = (k & 65535) * 1540483477 + (((k >>> 16) * 1540483477 & 65535) << 16);
          h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16) ^ k;
          l2 -= 4;
          ++i;
        }
        switch (l2) {
          case 3:
            h ^= (str[i + 2] & 255) << 16;
          case 2:
            h ^= (str[i + 1] & 255) << 8;
          case 1:
            h ^= str[i] & 255;
            h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16);
        }
        h ^= h >>> 13;
        h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16);
        h ^= h >>> 15;
        return h >>> 0;
      }
      function MurmurHashV3(key, seed) {
        if (typeof key === "string") key = createBuffer(key);
        let remainder, bytes, h1, h1b, c1, c2, k1, i;
        remainder = key.length & 3;
        bytes = key.length - remainder;
        h1 = seed;
        c1 = 3432918353;
        c2 = 461845907;
        i = 0;
        while (i < bytes) {
          k1 = key[i] & 255 | (key[++i] & 255) << 8 | (key[++i] & 255) << 16 | (key[++i] & 255) << 24;
          ++i;
          k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
          k1 = k1 << 15 | k1 >>> 17;
          k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
          h1 ^= k1;
          h1 = h1 << 13 | h1 >>> 19;
          h1b = (h1 & 65535) * 5 + (((h1 >>> 16) * 5 & 65535) << 16) & 4294967295;
          h1 = (h1b & 65535) + 27492 + (((h1b >>> 16) + 58964 & 65535) << 16);
        }
        k1 = 0;
        switch (remainder) {
          case 3:
            k1 ^= (key[i + 2] & 255) << 16;
          case 2:
            k1 ^= (key[i + 1] & 255) << 8;
          case 1:
            k1 ^= key[i] & 255;
            k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
            h1 ^= k1;
        }
        h1 ^= key.length;
        h1 ^= h1 >>> 16;
        h1 = (h1 & 65535) * 2246822507 + (((h1 >>> 16) * 2246822507 & 65535) << 16) & 4294967295;
        h1 ^= h1 >>> 13;
        h1 = (h1 & 65535) * 3266489909 + (((h1 >>> 16) * 3266489909 & 65535) << 16) & 4294967295;
        h1 ^= h1 >>> 16;
        return h1 >>> 0;
      }
      const murmur = MurmurHashV3;
      murmur.v2 = MurmurHashV2;
      murmur.v3 = MurmurHashV3;
      {
        module.exports = murmur;
      }
    })();
  })(murmurhash$1);
  return murmurhash$1.exports;
}
var murmurhashExports = requireMurmurhash();
const murmurhash = /* @__PURE__ */ getDefaultExportFromCjs(murmurhashExports);
const CollapseListDrawingSetBody = ({
  storeLinkBody,
  itemBody,
  itemUseRef
}) => {
  const linkBodyRef = useRef(null);
  if (storeLinkBody) {
    storeLinkBody.current[itemUseRef.__id] = linkBodyRef;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: itemBody(itemUseRef, linkBodyRef) });
};
const EllipseContainer = ({ children, maxWidth }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth
      },
      children
    }
  );
};
const LinkToInspectorEntity = ({ node: node2, listFieldName, icon, component }) => {
  const dispatch = useDispatch();
  const data = useFragmentFromStore(node2);
  const onClick = (e) => {
    dispatch(setCurrentModel({ key: node2.__id, userRef: node2 }));
    e.stopPropagation();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    component && component(onClick),
    icon && !component && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        type: "link",
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(DatabaseOutlined, {}),
        onClick,
        size: "small",
        style: { marginTop: -1 }
      }
    ),
    !icon && !component && /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { to: `#`, onClick, children: (listFieldName == null ? void 0 : listFieldName.map((fieldName) => data[fieldName]).join(" ")) || node2.__id })
  ] });
};
const WrapperOneLoaderQuery = ({ model, variables, dataSourceRef, fetchKey }) => {
  const queryResult = reactRelayExports.useLazyLoadQuery(
    // environment,
    model.queryOne,
    variables,
    { fetchPolicy: "network-only", fetchKey }
  );
  const dataFragment = useFragmentFromStore(queryResult[model.name]);
  useEffect(() => {
    dataSourceRef.current = dataFragment;
  }, [dataFragment]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
const DrawingSetUploadProcess = ({
  jobId,
  setJobStatus,
  modeView = "big",
  timeout = 2e3
}) => {
  var _a, _b, _c, _d, _e, _f;
  const [render, setRender] = useState(0);
  const timerInterval = useRef();
  const currentStatusRef = useRef({
    UPLOADING: 0,
    EXTRACTING_ARTIFACTS: 0,
    EXTRACTING_SHEET_INFO: 0,
    RASTERIZING: 0,
    SHEET_SPLITTING: 0
  });
  const dataSourceRef = useRef();
  const model = getModel("drawingSetJob");
  useEffect(() => {
    setTimeout(() => {
      setRender((prevValue) => prevValue + 1);
    }, 300);
    timerInterval.current = setInterval(() => {
      setRender((prevValue) => prevValue + 1);
    }, timeout);
    return () => {
      clearInterval(timerInterval.current);
    };
  }, []);
  const jobStatus = (_a = dataSourceRef.current) == null ? void 0 : _a.jobStatus;
  useEffect(() => {
    if (dataSourceRef.current) {
      setJobStatus(jobStatus);
      if (jobStatus === "FAILED" || jobStatus === "SUCCESS") {
        clearInterval(timerInterval.current);
      }
    }
  }, [render]);
  switch ((_b = dataSourceRef.current) == null ? void 0 : _b.stage) {
    case "UPLOADING":
    case "SHEET_SPLITTING":
      currentStatusRef.current = {
        ...currentStatusRef.current,
        SHEET_SPLITTING: Math.round(dataSourceRef.current.stageProgress)
      };
      break;
    case "RASTERIZING":
      currentStatusRef.current = {
        ...currentStatusRef.current,
        SHEET_SPLITTING: 100,
        RASTERIZING: Math.round(dataSourceRef.current.stageProgress)
      };
      break;
    case "EXTRACTING_ARTIFACTS":
      currentStatusRef.current = {
        ...currentStatusRef.current,
        SHEET_SPLITTING: 100,
        RASTERIZING: 100,
        EXTRACTING_ARTIFACTS: Math.round(dataSourceRef.current.stageProgress)
      };
      break;
    case "EXTRACTING_SHEET_INFO":
      currentStatusRef.current = {
        ...currentStatusRef.current,
        SHEET_SPLITTING: 100,
        RASTERIZING: 100,
        EXTRACTING_ARTIFACTS: 100,
        EXTRACTING_SHEET_INFO: Math.round(dataSourceRef.current.stageProgress)
      };
      break;
  }
  const getCurrentStatus = (currentStatus) => {
    return currentStatus < 100 ? "active" : "success";
  };
  const getMessageAlert = (stage) => {
    switch (stage) {
      case "UPLOADING":
        return "Problem with uploading file";
    }
    return "Something went wrong";
  };
  const loader = /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    WrapperOneLoaderQuery,
    {
      fetchKey: render,
      model,
      variables: { id: jobId || "78acd971-2500-479b-bef0-a6a0971a7af6" },
      dataSourceRef
    }
  ) });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Spin, { spinning: !dataSourceRef.current, children: [
    modeView === "big" && /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { vertical: true, style: { padding: "0 15px" }, children: [
      loader,
      ((_c = dataSourceRef.current) == null ? void 0 : _c.jobStatus) === "FAILED" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        Alert,
        {
          message: "Failed",
          description: getMessageAlert((_d = dataSourceRef.current) == null ? void 0 : _d.stage),
          type: "error",
          showIcon: true
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justify: "space-between", align: "center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { children: "Loading process ..." }),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsxs("h4", { children: [
            Math.round(((_e = dataSourceRef.current) == null ? void 0 : _e.jobProgress) || 0),
            "%"
          ] })
        ] }),
        "Sheet splitting ...",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Progress,
          {
            percent: currentStatusRef.current.SHEET_SPLITTING,
            status: getCurrentStatus(currentStatusRef.current.SHEET_SPLITTING)
          }
        ),
        "Rasterizing ...",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Progress,
          {
            percent: currentStatusRef.current.RASTERIZING,
            status: getCurrentStatus(currentStatusRef.current.RASTERIZING)
          }
        ),
        "Extracting artifacts ...",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Progress,
          {
            percent: currentStatusRef.current.EXTRACTING_ARTIFACTS,
            status: getCurrentStatus(currentStatusRef.current.EXTRACTING_ARTIFACTS)
          }
        ),
        "Extracting sheet info ...",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Progress,
          {
            percent: currentStatusRef.current.EXTRACTING_SHEET_INFO,
            status: getCurrentStatus(currentStatusRef.current.EXTRACTING_SHEET_INFO)
          }
        )
      ] })
    ] }),
    modeView === "small" && /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { style: { width: 30 }, children: [
      loader,
      jobStatus === "RUNNING" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Progress,
        {
          style: { position: "absolute", top: -4 },
          type: "circle",
          percent: Math.round(((_f = dataSourceRef.current) == null ? void 0 : _f.jobProgress) || 0),
          size: 30
        }
      )
    ] })
  ] });
};
const SuspenseWrapper = ({ children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Suspense,
    {
      fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(Spin, { spinning: true, tip: "Loading ...", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Empty, {}) }),
      children
    }
  );
};
const IndicatorStatusDrawingSet = ({ node: node2, setJobIndicatorStatus }) => {
  const [jobStatus, setJobStatus] = useState();
  const dataNode = useFragmentFromStore(node2);
  useEffect(() => {
    setJobIndicatorStatus(jobStatus);
  }, [jobStatus]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SuspenseWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    DrawingSetUploadProcess,
    {
      jobId: dataNode.currentJobId || dataNode.previousJobId,
      setJobStatus,
      modeView: "small",
      timeout: 5e3
    }
  ) });
};
const CollapseListDrawingSetHeader = ({
  node: node2,
  listFieldName = [],
  storeLinkBody,
  openCollapseKey
}) => {
  var _a;
  const dispatch = useDispatch();
  const isUpdateAfterUploadDrawingSetVersion = useSelector(
    (state) => state.drawings.isUpdateAfterUploadDrawingSetVersion
  );
  const formDrawingSheetWasChanged = useSelector(
    (state) => state.drawings.formDrawingSheetWasChanged
  );
  const currentTags = useSelector((state) => state.drawings.currentTags);
  const [statusButton, setStatusButton] = useState(true);
  const [isInFlight, setIsInFlight] = useState();
  const [jobIndicatorStatus, setJobIndicatorStatus] = useState();
  const storeInterval = useRef();
  const dataNode = useFragmentFromStore(node2);
  const navigate = useNavigate();
  useEffect(() => {
    if (formDrawingSheetWasChanged[dataNode.id]) {
      setStatusButton(false);
    }
  }, [formDrawingSheetWasChanged]);
  useEffect(() => {
    if (isUpdateAfterUploadDrawingSetVersion[dataNode.id]) {
      setJobIndicatorStatus(void 0);
      dispatch(setIsUpdateAfterUploadDrawingSetVersion({ [dataNode.id]: false }));
    }
  }, [isUpdateAfterUploadDrawingSetVersion[dataNode.id]]);
  useEffect(() => {
    if (openCollapseKey.includes(node2.__id)) {
      if (storeInterval.current) {
        clearInterval(storeInterval.current);
      }
      storeInterval.current = setInterval(() => {
        var _a2, _b, _c, _d, _e, _f;
        setStatusButton(!Object.keys(((_c = (_b = (_a2 = storeLinkBody == null ? void 0 : storeLinkBody.current) == null ? void 0 : _a2[node2.__id]) == null ? void 0 : _b.current) == null ? void 0 : _c.changedValues) || {}).length);
        setIsInFlight((_f = (_e = (_d = storeLinkBody == null ? void 0 : storeLinkBody.current) == null ? void 0 : _d[node2.__id]) == null ? void 0 : _e.current) == null ? void 0 : _f.isInFlight);
      }, 1e3);
    } else {
      clearInterval(storeInterval.current);
    }
  }, [openCollapseKey]);
  const listTag = ((_a = dataNode == null ? void 0 : dataNode.tags) == null ? void 0 : _a.split(",")) || [];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justify: "space-between", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { width: 250, paddingRight: 10 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(EllipseContainer, { children: [
        jobIndicatorStatus === "FAILED" && /* @__PURE__ */ jsxRuntimeExports.jsx(Tag$1, { color: "error", children: "Failed" }),
        listFieldName.map((fieldName) => dataNode[fieldName]).join(" ")
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { justify: "start", children: [...listTag].sort((a, b) => {
        const aInCurrent = currentTags.includes(a);
        const bInCurrent = currentTags.includes(b);
        if (aInCurrent && !bInCurrent) return -1;
        if (!aInCurrent && bInCurrent) return 1;
        return 0;
      }).map((tag) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        Tag$1,
        {
          onClick: (e) => {
            e.stopPropagation();
            const newTags = currentTags.includes(tag) ? currentTags.filter((currentTag) => currentTag !== tag) : [...currentTags, tag];
            dispatch(setterDrawings({ currentTags: newTags }));
          },
          color: currentTags.includes(tag) ? "orange-inverse" : "default",
          children: tag
        },
        tag
      )) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { gap: 10, justify: "space-between", style: { minWidth: 10, minHeight: 24 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        LinkToInspectorEntity,
        {
          node: node2,
          icon: true,
          component: (onClick) => /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { size: "small", onClick, icon: /* @__PURE__ */ jsxRuntimeExports.jsx(EditOutlined, {}) })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          onClick: (e) => {
            e.stopPropagation();
            navigate(`/drawingSet/${node2.__id}/${dataNode.versionDate}`);
          },
          icon: /* @__PURE__ */ jsxRuntimeExports.jsx(LoginOutlined, {}),
          size: "small",
          style: { minWidth: "auto", width: "30px" },
          disabled: !dataNode.versionDate
        }
      ),
      jobIndicatorStatus === "SUCCESS" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            onClick: (e) => {
              var _a2, _b;
              e.stopPropagation();
              (_b = (_a2 = storeLinkBody == null ? void 0 : storeLinkBody.current) == null ? void 0 : _a2[node2.__id]) == null ? void 0 : _b.current.submitTableChanges();
            },
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(SaveOutlined, {}),
            loading: isInFlight,
            size: "small",
            disabled: statusButton,
            style: { minWidth: "auto", width: "30px" }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ButtonAdd,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CloudUploadOutlined, {}),
            size: "small",
            modelName: "drawingSetVersion",
            parentData: {
              drawingSetId: node2.__id
            },
            minWidth: "auto"
          }
        )
      ] }),
      jobIndicatorStatus === "FAILED" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          variant: "outlined",
          color: "red",
          onClick: (e) => {
            e.stopPropagation();
            console.log("remove");
          },
          icon: /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteOutlined, {}),
          size: "small",
          style: { minWidth: "auto", width: "30px" }
        }
      ),
      jobIndicatorStatus !== "FAILED" && jobIndicatorStatus !== "SUCCESS" && /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { style: { marginLeft: 10 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IndicatorStatusDrawingSet, { node: node2, setJobIndicatorStatus }) })
    ] })
  ] });
};
const CollapseListDrawingSet = ({
  model,
  listFieldName = [],
  limit,
  itemBody,
  storeLinkBody,
  filterProject
}) => {
  const dispatch = useDispatch();
  const currentTags = useSelector((state) => state.drawings.currentTags);
  const isAndFilterTag = useSelector((state) => state.drawings.isAndFilterTag);
  const [dataSource, setDataSource] = useState();
  const [_, setDataPageInfo] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openCollapseKey, setOpenCollapseKey] = useState([]);
  useEffect(() => {
    var _a;
    const projectId = (filterProject == null ? void 0 : filterProject[0]) || "none";
    dispatch(setSearchResult({ [projectId]: ((_a = dataSource == null ? void 0 : dataSource.filter(filterDataSource)) == null ? void 0 : _a.length) || 0 }));
    const buffer = {};
    dataSource == null ? void 0 : dataSource.forEach((item) => {
      var _a2;
      if (!(item == null ? void 0 : item.tags)) {
        return;
      }
      const hash = murmurhash.v3(item == null ? void 0 : item.tags);
      buffer[hash] = item.tags;
      (_a2 = item.tags) == null ? void 0 : _a2.split(",").forEach((tag) => {
        if (!buffer[tag]) {
          buffer[tag] = [];
        }
        buffer[tag].push(hash);
      });
    });
    dispatch(setBuffer(buffer));
  }, [dataSource, currentTags]);
  const variables = {
    input: {
      page: 1,
      limit: limit || 20,
      filter: { projectId: { operator: "IN", value: filterProject == null ? void 0 : filterProject.join(",") } }
    }
  };
  const filterDataSource = (item) => {
    var _a, _b;
    if (isAndFilterTag) {
      for (const currentTag of currentTags) {
        if (!((_a = item.tags) == null ? void 0 : _a.split(",").includes(currentTag))) {
          return false;
        }
      }
      return true;
    } else {
      return (_b = item.tags) == null ? void 0 : _b.split(",").some((tag) => !currentTags.length || currentTags.includes(tag));
    }
  };
  const items = dataSource == null ? void 0 : dataSource.filter(filterDataSource).map((item) => {
    return {
      key: item.key,
      label: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        CollapseListDrawingSetHeader,
        {
          node: item.userRef,
          listFieldName,
          storeLinkBody,
          openCollapseKey
        }
      ) }),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        CollapseListDrawingSetBody,
        {
          storeLinkBody,
          itemBody,
          itemUseRef: item.userRef
        }
      )
    };
  });
  const onChange = (key) => {
    setOpenCollapseKey(key);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Suspense,
      {
        fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SuspenseLoadingStatus,
          {
            onStart: () => {
              setIsLoading(true);
            },
            onEnd: () => {
              setIsLoading(false);
            }
          }
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          WrapperTableLoaderQuery,
          {
            model,
            variables,
            setDataSource,
            setDataPageInfo,
            upAdditionalField: ["tags"]
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Spin, { spinning: isLoading, children: !(items == null ? void 0 : items.length) ? /* @__PURE__ */ jsxRuntimeExports.jsx(Empty, { style: { marginTop: 135 }, description: "No drawings have been added to this project" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { items, defaultActiveKey: [], onChange }) })
  ] });
};
const setUrlArrayParam = (paramName, values) => {
  const url = new URL(window.location.href);
  if (values.length > 0) {
    const paramValue = values.map((value) => encodeURIComponent(value)).join(",");
    url.searchParams.set(paramName, paramValue);
  } else {
    url.searchParams.delete(paramName);
  }
  window.history.replaceState({}, "", url.toString());
};
const SearchPanelTagDrawingSet = ({ searchTags }) => {
  const dispatch = useDispatch();
  const currentTags = useSelector((state) => state.drawings.currentTags);
  const bufferTags = useSelector((state) => state.drawings.bufferTags);
  const isAndFilterTag = useSelector((state) => state.drawings.isAndFilterTag);
  const [tagList, setTagList] = useState();
  const getFullTagList = () => {
    const newTagList = Object.keys(bufferTags).map((tag) => Array.isArray(bufferTags[tag]) ? false : bufferTags[tag]).filter(Boolean).join(",").split(",");
    return Array.from(new Set(newTagList));
  };
  useEffect(() => {
    if (!currentTags.length && !searchTags) {
      setTagList(getFullTagList());
      return;
    }
    if (currentTags.length) {
      const intersectedTags = currentTags.reduce(
        (acc, tag) => {
          const numbers = bufferTags[tag];
          if (isAndFilterTag) {
            return acc ? acc.filter((n2) => numbers == null ? void 0 : numbers.includes(n2)) : numbers;
          }
          return acc ? [...acc, ...numbers] : numbers;
        },
        void 0
      ) || [];
      const newTagList = intersectedTags.map((tag) => bufferTags[tag]).join(",");
      const setTags = new Set(newTagList.split(",").filter((tag) => !currentTags.includes(tag)));
      setTagList(Array.from(setTags));
    }
    if (searchTags) {
      setTagList(
        getFullTagList().filter(
          (tag) => !currentTags.includes(tag) && tag.toLowerCase().includes(searchTags.toLowerCase())
        )
      );
    }
  }, [currentTags, bufferTags, isAndFilterTag, searchTags]);
  return tagList == null ? void 0 : tagList.map((tag) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tag$1,
    {
      onClick: () => {
        dispatch(setterDrawings({ currentTags: [...currentTags, tag] }));
      },
      children: tag
    },
    tag
  ));
};
const SearchPanelDrawingSet = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const currentTags = useSelector((state) => state.drawings.currentTags);
  const [searchTags, setSearchTags] = useState("");
  require$$0.useEffect(() => {
    form.setFieldsValue({ tags: currentTags });
    setUrlArrayParam("tags", currentTags ?? []);
    setSearchTags("");
  }, [currentTags, form]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { align: "center", justify: "space-between", gap: 10, style: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { style: { width: "calc(100% - 70px)" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Input,
        {
          size: "small",
          onChange: (e) => setSearchTags(e.target.value),
          prefix: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchOutlined, {}),
          style: { width: 130, marginRight: 10 },
          value: searchTags
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { style: { overflow: "hidden" }, children: [
        currentTags.map((tag) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Tag$1,
          {
            color: "blue",
            onClose: () => {
              dispatch(
                setterDrawings({
                  currentTags: currentTags.filter((currentTag) => currentTag !== tag)
                })
              );
            },
            closable: true,
            children: tag
          },
          tag
        )),
        /* @__PURE__ */ jsxRuntimeExports.jsx(SearchPanelTagDrawingSet, { searchTags })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Switch,
      {
        checkedChildren: "AND",
        unCheckedChildren: "OR",
        defaultChecked: true,
        onChange: (check) => {
          dispatch(setterDrawings({ isAndFilterTag: check }));
        },
        disabled: !currentTags.length
      }
    )
  ] });
};
const TabProjectLabel = ({ projectId }) => {
  var _a, _b, _c;
  const searchResult = useSelector((state) => state.drawings.searchResult);
  const data = reactRelayExports.useLazyLoadQuery(getDrawingProjectListQuery, {
    first: 1,
    input: {
      filter: {
        id: {
          operator: "IN",
          value: projectId
        }
      }
    }
  });
  const projectConnectionData = useFragmentFromStore(data);
  const projectData = useFragmentFromStore((_c = (_b = (_a = projectConnectionData == null ? void 0 : projectConnectionData.projectList) == null ? void 0 : _a.edges) == null ? void 0 : _b[0]) == null ? void 0 : _c.node);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Loading..." }), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { align: "center", gap: 5, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: projectData ? `${projectData.number} ${projectData.name}` : "none" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { count: searchResult[projectId] || 0, color: "blue", style: { opacity: 0.5 } })
  ] }) });
};
const EntityTableLoaderForm = memo(({ modelName, node: node2, contextName }) => {
  var _a;
  const form = Form.useFormInstance();
  const model = getModel(modelName);
  const dataEntity = useFragmentFromStore(node2);
  const values = Form.useWatch([], { form, preserve: true });
  const [render, setRender] = useState(0);
  const listColumnName = contextName ? ((_a = model.context) == null ? void 0 : _a[contextName]) || [] : model.schema.context.table;
  useEffect(() => {
    if (render > 0) {
      listColumnName.forEach((columnName) => {
        var _a2;
        const field = model.schema.field[columnName];
        form.setFieldsValue({
          [dataEntity.id]: {
            [field.name]: ((_a2 = values == null ? void 0 : values[dataEntity.id]) == null ? void 0 : _a2[field.name]) || dataEntity[field.name]
          }
        });
      });
    }
  }, [render]);
  useEffect(() => {
    if (!values) {
      setRender(render + 1);
    }
  }, []);
  return null;
});
const IdTableCell = ({ value }) => {
  const [copied, setCopied] = useState(false);
  const shortenUUID = (uuid, start = 3, end = 3) => {
    if (!uuid) {
      return "";
    }
    if (uuid.length <= start + end) {
      return uuid;
    }
    return `${uuid.slice(0, start)}...${uuid.slice(-end)}`;
  };
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Ошибка копирования UUID:", err);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: copied ? "Copied!" : value, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { onClick: handleCopy, style: { cursor: "pointer" }, children: shortenUUID(value) }) });
};
const EntityWrapperTableCell = ({ schemaData, dataEntity, model, fieldData }) => {
  const getValueByType = () => {
    var _a, _b, _c, _d;
    const renderFromModel = (_b = (_a = model.renderData) == null ? void 0 : _a.tableCell) == null ? void 0 : _b[schemaData.name];
    if (renderFromModel) {
      return renderFromModel(schemaData, fieldData, dataEntity);
    }
    if (schemaData.name === "id") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(IdTableCell, { value: fieldData });
    }
    switch (schemaData.type) {
      case "string":
      case "integer":
      case "[string]": {
        if ((_d = (_c = model.context) == null ? void 0 : _c.tableInput) == null ? void 0 : _d.includes(schemaData.name)) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(Form.Item, { name: [dataEntity.id, schemaData.name], style: { margin: 0 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, {}) });
        }
        return fieldData;
      }
      default:
        if (Array.isArray(fieldData)) {
          fieldData == null ? void 0 : fieldData.map((fragment) => {
            const [fragmentName] = Object.keys(fragment.__fragments);
            console.log("======", schemaData, fragmentName);
          });
        } else {
          console.log("##############");
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { message: `Error field type - ${schemaData.type}`, type: "error", showIcon: true });
    }
  };
  return getValueByType();
};
const EntityTableRowSetColumn = memo(({ modelName, node: node2, contextName }) => {
  var _a;
  const model = getModel(modelName);
  const dataEntity = useFragmentFromStore(node2);
  const listColumnName = contextName ? ((_a = model.context) == null ? void 0 : _a[contextName]) || [] : model.schema.context.table;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: listColumnName.map((columnName) => {
    const field = model.schema.field[columnName];
    return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { vertical: true, style: { maxHeight: 200, overflow: "auto" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      EntityWrapperTableCell,
      {
        schemaData: field,
        model,
        fieldData: dataEntity[columnName],
        dataEntity
      }
    ) }) }, columnName);
  }) });
});
const EntityTableRow = ({
  modelName,
  isCheckBoxColumn,
  setSelectedRows,
  selectedRows = [],
  node: node2,
  contextName,
  ...rest
}) => {
  const [isMouseOver, setMouseOver] = require$$0.useState(false);
  const dataEntity = useFragmentFromStore(node2);
  const getColor = () => {
    if (isMouseOver) {
      return selectedRows.includes(dataEntity.id) ? "#bae0ff" : "#fcfcfc";
    }
    return selectedRows.includes(dataEntity.id) ? "#e6f4ff" : "white";
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "tr",
    {
      ...rest,
      style: { cursor: "pointer", backgroundColor: getColor() },
      onMouseOver: () => {
        setMouseOver(true);
      },
      onMouseLeave: () => {
        setMouseOver(false);
      },
      children: [
        isCheckBoxColumn && /* @__PURE__ */ jsxRuntimeExports.jsx("td", { style: { textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Checkbox,
          {
            onClick: (e) => e.stopPropagation(),
            checked: selectedRows.includes(dataEntity.id),
            onChange: (value) => {
              if (value.target.checked) {
                setSelectedRows == null ? void 0 : setSelectedRows((previousValue) => {
                  return [...previousValue, dataEntity.id];
                });
              } else {
                setSelectedRows == null ? void 0 : setSelectedRows((previousValue) => {
                  return previousValue.filter((id) => id !== dataEntity.id);
                });
              }
            }
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(EntityTableRowSetColumn, { node: node2, contextName, modelName })
      ]
    }
  );
};
const useCommitFromMutation = (mutation) => {
  const [statusUpdate, setStatusUpdate] = useState("none");
  const [commitUpdate, isInFlightUpdate] = mutation ? reactRelayExports.useMutation(mutation) : [];
  const commit = (values) => {
    return {
      variables: {
        input: {
          sheets: Object.keys(values).map((key) => ({
            sheetId: key,
            ...values[key]
          }))
        }
      },
      onCompleted: (response, errors) => {
        if (errors) {
          console.log(
            errors[0].extensions.debugMessage,
            errors
          );
        } else {
          setStatusUpdate("success");
          setTimeout(() => {
            setStatusUpdate("none");
          }, 500);
          console.log("Update successful", response);
        }
      },
      onError: (error) => {
        setStatusUpdate("failed");
        console.error("Mutation error:", error);
      }
    };
  };
  const updateCommit = (values) => {
    commitUpdate == null ? void 0 : commitUpdate(commit(values));
  };
  return { updateCommit, isInFlightUpdate, statusUpdate };
};
const TableEntityBase = forwardRef(
  ({
    entityName,
    dataSource,
    isCheckBoxColumn,
    onSelectedRow,
    setCurrentModel: setCurrentModel2,
    pagination,
    setPagination,
    isLoading = false,
    contextName,
    setFetchKey
  }, ref) => {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const values = Form.useWatch([], { form, preserve: true });
    const model = getModel(entityName);
    const changedValuesRef = useRef({});
    const valuesBeforeChangedRef = useRef({});
    const [selectedRows, setSelectedRows] = useState([]);
    const selectedRowsRef = useRef([]);
    const bulkUpdating = useCommitFromMutation((_a = model.mutation) == null ? void 0 : _a.bulkUpdate);
    useEffect(() => {
      if (bulkUpdating.statusUpdate === "success") {
        changedValuesRef.current = {};
        setFetchKey == null ? void 0 : setFetchKey((prevValue) => prevValue + 1);
      }
    }, [bulkUpdating.statusUpdate]);
    const bulkSave = () => {
      form.submit();
    };
    useImperativeHandle(ref, () => ({
      submitTableChanges: bulkSave,
      changedValues: bulkUpdating.statusUpdate === "success" ? {} : changedValuesRef.current,
      isInFlight: bulkUpdating.isInFlightUpdate
    }));
    useEffect(() => {
      const listKey = Object.keys(values || {});
      if (listKey.length > 0 && listKey.length > Object.keys(valuesBeforeChangedRef.current || {}).length) {
        valuesBeforeChangedRef.current = {
          ...valuesBeforeChangedRef.current || {},
          ...values
        };
      }
    }, [values]);
    useEffect(() => {
      onSelectedRow == null ? void 0 : onSelectedRow(selectedRows);
    }, [selectedRows]);
    selectedRowsRef.current = selectedRows;
    const listColumnName = contextName ? ((_b = model.context) == null ? void 0 : _b[contextName]) || [] : model.schema.context.table;
    const columns = listColumnName.map((key) => {
      var _a2, _b2;
      const field = model.schema.field[key];
      return {
        title: contextName ? (_b2 = (_a2 = model.aliasLabelColumn) == null ? void 0 : _a2[contextName]) == null ? void 0 : _b2[field.name] : field.title,
        dataIndex: field.title,
        key
      };
    });
    const handlerOnRow = (record) => {
      const handleCLick = () => {
        console.log("click on row", record);
        if (setCurrentModel2) {
          dispatch(setCurrentModel2(record));
        }
      };
      return {
        onClick: handleCLick
      };
    };
    const rowSelection = isCheckBoxColumn ? {
      onChange: (selectedRowKeys, selectedRows2) => {
        console.log(`selectedRowKeys: ${selectedRowKeys}`, "selectedRows: ", selectedRows2);
        setSelectedRows(selectedRowKeys);
      },
      type: "checkbox",
      selectedRowKeys: selectedRows
    } : void 0;
    const handleTableChange = (pagination2) => {
      setPagination == null ? void 0 : setPagination(pagination2);
    };
    const tableComponents = useMemo(
      () => ({
        body: {
          row: ({ children, ...props }) => {
            const dataRowKey = props["data-row-key"];
            const record = dataRowKey ? dataSource == null ? void 0 : dataSource.find((item) => item.key === dataRowKey) : null;
            return record ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                EntityTableLoaderForm,
                {
                  node: record == null ? void 0 : record.userRef,
                  contextName,
                  modelName: entityName
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                EntityTableRow,
                {
                  ...props,
                  node: record == null ? void 0 : record.userRef,
                  modelName: entityName,
                  isCheckBoxColumn,
                  setSelectedRows,
                  selectedRows: selectedRowsRef.current,
                  contextName
                }
              )
            ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { style: { width: "200px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("td", { colSpan: 100, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Empty, {}) }) });
          }
        }
      }),
      [dataSource, entityName, isCheckBoxColumn, setSelectedRows, contextName]
    );
    const table = /* @__PURE__ */ jsxRuntimeExports.jsx(
      Table,
      {
        columns,
        dataSource,
        pagination,
        onChange: handleTableChange,
        scroll: { x: "max-content" },
        bordered: true,
        size: "small",
        loading: isLoading,
        components: tableComponents,
        rowSelection,
        onRow: handlerOnRow
      }
    );
    return ((_c = model.context) == null ? void 0 : _c.tableInput) ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Form,
      {
        form,
        onFinish: () => {
          bulkUpdating.updateCommit(changedValuesRef.current);
        },
        onValuesChange: (changedValues, allValues) => {
          var _a2;
          const [key] = Object.keys(changedValues);
          if (!changedValuesRef.current) {
            valuesBeforeChangedRef.current = {
              ...allValues
            };
          }
          changedValuesRef.current = {
            ...changedValuesRef.current || {},
            [key]: {
              ...((_a2 = changedValuesRef.current) == null ? void 0 : _a2[key]) || {},
              ...changedValues[key]
            }
          };
        },
        children: table
      }
    ) }) : table;
  }
);
const TableEntity = forwardRef(
  ({
    modelName,
    onSelectedRow,
    inputFilter,
    input,
    model,
    limit = 100,
    contextName,
    fetchKeyForUpdate = 0
  }, ref) => {
    const [dataSource, setDataSource] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [dataPageInfo, setDataPageInfo] = useState();
    const [fetchKey, setFetchKey] = useState(fetchKeyForUpdate);
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 10,
      total: 0
    });
    useEffect(() => {
      setFetchKey(fetchKeyForUpdate);
    }, [fetchKeyForUpdate]);
    const internalModel = modelName ? getModel(modelName) : model;
    const newInput = {
      ...input,
      filter: inputFilter || {},
      page: pagination.current,
      limit: pagination.pageSize || limit
    };
    const variables = {
      input: newInput
    };
    useEffect(() => {
      setPagination({
        ...pagination,
        pageSize: limit
      });
    }, [limit]);
    useEffect(() => {
      if (dataPageInfo) {
        setPagination({
          ...pagination,
          pageSize: dataPageInfo.limit,
          total: dataPageInfo.totalCount
        });
      }
    }, [dataPageInfo]);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Suspense,
        {
          fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(
            SuspenseLoadingStatus,
            {
              onStart: () => {
                setIsLoading(true);
              },
              onEnd: () => {
                setIsLoading(false);
              }
            }
          ),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            WrapperTableLoaderQuery,
            {
              model: internalModel,
              variables,
              setDataSource,
              setDataPageInfo,
              fetchKey
            }
          )
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TableEntityBase,
        {
          ref,
          entityName: internalModel.name,
          dataSource,
          isCheckBoxColumn: internalModel.isCheckBoxColumn,
          onSelectedRow,
          pagination,
          setFetchKey,
          setPagination,
          isLoading,
          contextName
        }
      )
    ] });
  }
);
const node = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "drawingSetVersionChangeStatusMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetVersion",
          "kind": "LinkedField",
          "name": "drawingSetVersionChangeStatus",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "drawingSetVersionFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "drawingSetVersionChangeStatusMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "DrawingSetVersion",
          "kind": "LinkedField",
          "name": "drawingSetVersionChangeStatus",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "versionDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "drawingSetId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "7c2cb834e862f861fe64ae43237bfb43",
      "id": null,
      "metadata": {},
      "name": "drawingSetVersionChangeStatusMutation",
      "operationKind": "mutation",
      "text": "mutation drawingSetVersionChangeStatusMutation(\n  $input: DrawingSetVersionChangeStatusInput!\n) {\n  drawingSetVersionChangeStatus(input: $input) {\n    ...drawingSetVersionFragment\n    id\n  }\n}\n\nfragment drawingSetVersionFragment on DrawingSetVersion {\n  id\n  createdAt\n  updatedAt\n  createdById\n  fileName\n  versionDate\n  status\n  drawingSetId\n  jobId\n}\n"
    }
  };
}();
node.hash = "5643e94ef8aa8ca878d80304ad11fa24";
const drawingSetVersionChangeStatusMutation = node;
const ButtonPublish = ({ drawingSetVersionId }) => {
  const resultEntity = reactRelayExports.useLazyLoadQuery(
    storeDrawingsModel.drawingSetVersion.queryOne,
    { id: drawingSetVersionId },
    { fetchPolicy: "store-or-network" }
  );
  const drawingSetVersion = useFragmentFromStore(
    resultEntity.drawingSetVersion
  );
  const [commitChangeStatus, isInFlightChangingStatus] = reactRelayExports.useMutation(drawingSetVersionChangeStatusMutation);
  const commit = (input) => {
    return {
      variables: {
        input
      },
      onCompleted: (response, errors) => {
        if (errors) {
          console.log(
            errors[0].extensions.debugMessage,
            errors
          );
        } else {
          console.log("Change status of drawings set version successful", response);
        }
      },
      onError: (error) => {
        console.error("Mutation error:", error);
      }
    };
  };
  const onClick = async () => {
    const data = {
      drawingSetVersionId,
      status: drawingSetVersion.status === "PUBLISHED" ? "DRAFT" : "PUBLISHED"
    };
    commitChangeStatus(commit(data));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      loading: isInFlightChangingStatus,
      onClick,
      variant: "outlined",
      color: drawingSetVersion.status !== "PUBLISHED" ? "green" : "default",
      children: drawingSetVersion.status === "PUBLISHED" ? "Unpublish" : "Publish"
    }
  );
};
const DrawingSetVersionSelectOption = ({ node: node2 }) => {
  const dataEntity = useFragmentFromStore(node2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DateTableCell, { value: dataEntity.versionDate, format: FORMAT_DATE_TIME }),
    dataEntity.status !== "PUBLISHED" ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { fontWeight: "bold", marginLeft: 5 }, children: "(draft)" }) : ""
  ] });
};
memo(DrawingSetVersionSelectOption);
const LoaderFormDrawingSetVersion = ({
  drawingSetId,
  versionDate
}) => {
  var _a, _b;
  const form = Form.useFormInstance();
  const resultEntityList = reactRelayExports.useLazyLoadQuery(
    getDrawingSetVersionListQuery,
    {
      input: {
        filter: {
          drawingSetId: {
            operator: "EQ",
            value: drawingSetId
          },
          versionDate: {
            operator: "EQ",
            value: versionDate.toString()
          }
        }
      },
      first: 1
    },
    { fetchPolicy: "store-or-network", fetchKey: "oneDrawingSetVersion" }
  );
  const data = useFragmentFromStore(resultEntityList);
  const dataResult = useFragmentFromStore((_b = (_a = data.drawingSetVersionList) == null ? void 0 : _a.edges[0]) == null ? void 0 : _b.node);
  useEffect(() => {
    form.setFieldsValue({ versionDate: dataResult.id });
  }, [data]);
  return null;
};
const TableDrawingSetSheetPanel = ({
  drawingSetId,
  versionDate,
  setCurrentVersionDate
}) => {
  const [form] = Form.useForm();
  const values = Form.useWatch([], { form, preserve: true });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justify: "space-between", flex: 1, style: { margin: "0 10px 0px" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { align: "center", gap: 5, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Form, { name: `drawingSetVersion-${drawingSetId}`, layout: "inline", form, autoComplete: "off", children: [
      versionDate && /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoaderFormDrawingSetVersion, { drawingSetId, versionDate }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FieldDynamicListEntity,
        {
          model: storeDrawingsModel.drawingSetVersion,
          listName: "drawingSetVersionList",
          listFieldName: ["versionDate"],
          field: storeDrawingsModel.drawingSetVersion.schema.field.versionDate,
          style: { width: 250 },
          input: { filter: { drawingSetId: { operator: "EQ", value: drawingSetId } } },
          renderLabel: (node2) => /* @__PURE__ */ jsxRuntimeExports.jsx(DrawingSetVersionSelectOption, { node: node2 }),
          onSelect: (value) => {
            console.log("////", value, +value.split(":")[1]);
            setCurrentVersionDate(+value.split(":")[1]);
          }
        }
      )
    ] }) }),
    (values == null ? void 0 : values.versionDate) && /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { loading: true, children: "Publish" }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonPublish, { drawingSetVersionId: values.versionDate }) })
  ] });
};
const TableDrawingSetSheet = forwardRef(({ nodeDrawingSet }, ref) => {
  const environment = reactRelayExports.useRelayEnvironment();
  const isUpdateAfterUploadDrawingSetVersion = useSelector(
    (state) => state.drawings.isUpdateAfterUploadDrawingSetVersion
  );
  const drawingSet = useFragmentFromStore(nodeDrawingSet);
  const [jobStatus, setJobStatus] = useState();
  const [currentStatusDrawingSetVersion, setCurrentStatusDrawingSetVersion] = useState("");
  const [fetchKey, setFetchKey] = useState(0);
  const [currentVersionDate, setCurrentVersionDate] = useState(drawingSet.versionDate);
  const intervalRef = useRef();
  useEffect(() => {
    const checkStore = () => {
      const drawingSetVersion = environment == null ? void 0 : environment.getStore().getSource().get(`${drawingSet.id}:${currentVersionDate}`);
      setCurrentStatusDrawingSetVersion(drawingSetVersion == null ? void 0 : drawingSetVersion.status);
      if (drawingSetVersion) {
        clearInterval(intervalRef.current);
        return;
      }
    };
    intervalRef.current = setInterval(checkStore, 200);
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [currentVersionDate]);
  useEffect(() => {
    if (isUpdateAfterUploadDrawingSetVersion[drawingSet.id]) {
      setJobStatus(void 0);
    }
  }, [isUpdateAfterUploadDrawingSetVersion[drawingSet.id]]);
  useEffect(() => {
    if (jobStatus === "SUCCESS") {
      setFetchKey((prevValue) => prevValue + 1);
    }
  }, [jobStatus]);
  const model = {
    ...getModel("drawingSetSheet")
  };
  if (currentStatusDrawingSetVersion === "PUBLISHED") {
    model.context.tableInput = ["id"];
    model.context.table = ["id", "number", "name", "revision", "updatedAt"];
  } else {
    model.context.tableInput = ["number", "name", "isRemoved"];
    model.context.table = ["id", "number", "name", "revision", "updatedAt", "isRemoved"];
  }
  const table = /* @__PURE__ */ jsxRuntimeExports.jsx(
    TableEntity,
    {
      ref,
      input: {
        viewMode: "ALL"
      },
      inputFilter: {
        drawingSetId: { operator: "EQ", value: drawingSet.id },
        versionDate: { operator: "LTE", value: currentVersionDate }
      },
      model,
      limit: 10,
      contextName: "table",
      fetchKeyForUpdate: fetchKey
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: jobStatus !== "SUCCESS" ? /* @__PURE__ */ jsxRuntimeExports.jsx(SuspenseWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    DrawingSetUploadProcess,
    {
      jobId: drawingSet.currentJobId || drawingSet.previousJobId,
      setJobStatus
    }
  ) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TableDrawingSetSheetPanel,
      {
        drawingSetId: drawingSet.id,
        versionDate: currentVersionDate,
        setCurrentVersionDate
      }
    ),
    currentStatusDrawingSetVersion === "PUBLISHED" && table,
    currentStatusDrawingSetVersion && currentStatusDrawingSetVersion !== "PUBLISHED" && table
  ] }) });
});
const PROJECT_PARAM = "drawings-project";
const DrawingSetListPage = ({ filterProject = [] }) => {
  const [currentFilterProject, setCurrentFilterProject] = useState(filterProject);
  const [isInitComponent, setIsInitComponent] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const storeTableLinkRef = useRef({});
  useEffect(() => {
    setTimeout(() => {
      setIsInitComponent(true);
    }, 500);
  }, []);
  useEffect(() => {
    if (filterProject.length) {
      setCurrentFilterProject(filterProject);
      const projectParam = parseUrlParam(PROJECT_PARAM);
      if (filterProject.includes(projectParam)) {
        setActiveTab(projectParam);
      } else {
        setActiveTab(filterProject[0] ?? "");
      }
    }
  }, [filterProject]);
  const handleTabChange = (activeKey) => {
    setActiveTab(activeKey);
    setUrlParam(PROJECT_PARAM, activeKey);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { vertical: true, flex: 1, style: { minWidth: 0, height: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justify: "space-between", gap: 10, style: { marginBottom: 20 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonAdd, { modelName: "drawingSet", caption: "Uploading Drawing" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { disabled: true, children: "Action" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { style: { marginBottom: 20 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchPanelDrawingSet, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ConfigProvider,
      {
        theme: {
          components: {
            Collapse: {
              contentPadding: "16px 0"
            },
            Table: {
              headerBorderRadius: 0
            }
          }
        },
        children: [
          !!currentFilterProject.length && isInitComponent && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Tabs,
            {
              type: "card",
              size: "small",
              activeKey: activeTab,
              onChange: handleTabChange,
              items: currentFilterProject.map((projectId) => {
                return {
                  label: /* @__PURE__ */ jsxRuntimeExports.jsx(TabProjectLabel, { projectId }),
                  key: projectId,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    CollapseListDrawingSet,
                    {
                      model: getModel("drawingSet"),
                      listFieldName: ["name"],
                      limit: 100,
                      itemBody: (node2, linkBody) => /* @__PURE__ */ jsxRuntimeExports.jsx(TableDrawingSetSheet, { ref: linkBody, nodeDrawingSet: node2 }),
                      storeLinkBody: storeTableLinkRef,
                      filterProject: [projectId]
                    }
                  ),
                  forceRender: true
                };
              })
            }
          ),
          !currentFilterProject.length && isInitComponent && /* @__PURE__ */ jsxRuntimeExports.jsx(AlertEmptyProject, {}),
          !isInitComponent && /* @__PURE__ */ jsxRuntimeExports.jsx(Spin, { spinning: !isInitComponent, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Empty, { style: { marginTop: 135 }, description: "No drawings have been added to this project" }) })
        ]
      }
    )
  ] });
};
const ButtonBackToDrawingSet = () => {
  const navigate = useNavigate$1();
  const handleBack = () => {
    navigate("/drawingSet");
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { icon: /* @__PURE__ */ jsxRuntimeExports.jsx(LeftOutlined, {}), onClick: handleBack, type: "primary" });
};
const NavigationUnitDrawingSetSheetVersion = ({
  node: node2,
  drawingSetId
}) => {
  const dispatch = useDispatch();
  const navigationCurrentSheet = useSelector(
    (state) => state.drawings.navigationCurrentSheet
  );
  const drawingSetSheet = useFragmentFromStore(node2);
  const urlPictPreview = `${API.DRAWINGS_S3_URL}/get-file/sheets/${drawingSetId}/${drawingSetSheet.id}/artifacts/sheet@512.png`;
  const urlPdf = `${API.DRAWINGS_S3_URL}/get-file/sheets/${drawingSetId}/${drawingSetSheet.id}/${drawingSetSheet.id}.pdf`;
  const isSelected = (navigationCurrentSheet == null ? void 0 : navigationCurrentSheet.id) === drawingSetSheet.id;
  console.log(drawingSetSheet, urlPictPreview, urlPdf);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { vertical: true, style: { padding: 5, backgroundColor: isSelected ? "#c8dcec" : "transparent" }, children: [
    drawingSetSheet.number,
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { height: 60 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      ViewerProtectPictWrapperAppryze,
      {
        urlPdf,
        urlPictPreview,
        token: API.GRAPHQL_TOKEN,
        minHeight: 60,
        onClick: () => dispatch(setterDrawings({ navigationCurrentSheet: drawingSetSheet }))
      }
    ) })
  ] });
};
const NavigationDrawingSetSheetVersion = ({
  drawingSetId,
  versionDate
}) => {
  const drawingSetSheetVersionRawList = reactRelayExports.useLazyLoadQuery(
    getDrawingSetSheetTableQuery,
    {
      input: {
        filter: {
          drawingSetId: {
            operator: "EQ",
            value: drawingSetId
          },
          versionDate: {
            operator: "LTE",
            value: versionDate.toString()
          }
        },
        limit: 100,
        page: 1,
        viewMode: "ALL"
      }
    },
    {
      fetchPolicy: "store-or-network"
      // fetchKey: 'oneDrawingSetVersion'
    }
  );
  const data = useFragmentFromStore(drawingSetSheetVersionRawList);
  const drawingSetSheetVersionFragmentList = useFragmentFromStore(
    data.drawingSetSheetTable
  );
  console.log(drawingSetSheetVersionFragmentList);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { vertical: true, style: { width: 100, height: "100%", backgroundColor: "#eee", overflow: "scroll" }, children: drawingSetSheetVersionFragmentList.edges.map((edge) => /* @__PURE__ */ jsxRuntimeExports.jsx(NavigationUnitDrawingSetSheetVersion, { node: edge.node, drawingSetId }, edge.cursor)) });
};
const NavigationViewDrawingSetSheetVersion = () => {
  const navigationCurrentSheet = useSelector(
    (state) => state.drawings.navigationCurrentSheet
  );
  const [update, setUpdate] = require$$0.useState(true);
  useEffect(() => {
    setUpdate(false);
  }, [navigationCurrentSheet]);
  useEffect(() => {
    if (!update) {
      setUpdate(true);
    }
  }, [update]);
  const urlPdf = `${API.DRAWINGS_S3_URL}/get-file/sheets/${navigationCurrentSheet == null ? void 0 : navigationCurrentSheet.drawingSetId}/${navigationCurrentSheet == null ? void 0 : navigationCurrentSheet.id}/${navigationCurrentSheet == null ? void 0 : navigationCurrentSheet.id}.pdf`;
  const { data: dataPdf } = useLoadingProtectUrl(urlPdf, API.GRAPHQL_TOKEN);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flex: 1, style: { height: "100%" }, children: update && /* @__PURE__ */ jsxRuntimeExports.jsx(ViewerAppryze, { file: dataPdf, height: "100%" }) });
};
const DrawingSetPage = () => {
  const environment = reactRelayExports.useRelayEnvironment();
  const { drawingSetId, versionDate } = useParams();
  const [currentVersionDate, setCurrentVersionDate] = useState(+versionDate);
  const dataFromStore = environment == null ? void 0 : environment.getStore().getSource().get(drawingSetId);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { vertical: true, flex: 1, style: { minWidth: 0, height: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justify: "space-between", gap: 10, align: "center", style: { marginBottom: 20 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonBackToDrawingSet, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { style: { marginTop: 14 }, children: dataFromStore == null ? void 0 : dataFromStore.name }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TableDrawingSetSheetPanel,
        {
          drawingSetId,
          versionDate: currentVersionDate,
          setCurrentVersionDate
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ConfigProvider,
      {
        theme: {
          components: {}
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { style: { height: "94%" }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(NavigationDrawingSetSheetVersion, { drawingSetId, versionDate: currentVersionDate }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(NavigationViewDrawingSetSheetVersion, {})
        ] })
      }
    )
  ] });
};
const isDrawingsRelayOperation = (args) => {
  const operationName = args.operation.name;
  return operationName === "getTagFilteredListQuery" || args.operation.name.toLowerCase().includes("drawing");
};
const initialState = {
  spinnerList: [],
  spinner: false
};
const spinnerSlice = createSlice({
  name: "spinner",
  initialState,
  reducers: {
    addSpinnerItem: (state, action) => {
      state.spinnerList = [...state.spinnerList, action.payload];
      state.spinner = true;
    },
    removeSpinnerItem: (state, action) => {
      state.spinnerList = state.spinnerList.filter((item) => item !== action.payload);
      if (!state.spinnerList.length) state.spinner = false;
    },
    clearSpinnerList: (state) => {
      state.spinnerList = [];
      state.spinner = false;
    }
  }
});
const { addSpinnerItem, removeSpinnerItem, clearSpinnerList } = spinnerSlice.actions;
const spinnerReducer = spinnerSlice.reducer;
const inspectorReducers = {
  spinner: spinnerReducer,
  inspector: inspectorReducer,
  model: modelReducer
};
const store = configureStore({
  reducer: {
    ...inspectorReducers,
    drawings: drawingsReducers$1
  }
});
const ButtonCloseAllInspector = ({ offsetRight }) => {
  const dispatch = useDispatch();
  const isCloseAll = useSelector((state) => state.inspector.isCloseAll);
  useEffect(() => {
    if (isCloseAll) {
      dispatch(setManyModel([]));
      dispatch(setterInspector({ isCloseAll: false, nameNewEntity: void 0 }));
    }
  }, [isCloseAll]);
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => {
    dispatch(setterInspector({ isCloseAll: true }));
  };
  useEffect(() => {
    setTimeout(() => {
      setIsOpen(true);
    }, 500);
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: offsetRight > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        padding: 10,
        position: "fixed",
        right: offsetRight,
        opacity: isOpen ? 1 : 0,
        top: 0,
        transform: isOpen ? `translateX(${0})` : `translateX(${50}px)`,
        transition: "transform .3s ease",
        // boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.2)',
        zIndex: 2e3 - offsetRight
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          style: {
            backgroundColor: "#fff",
            borderRadius: "50%"
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { title: "Close All", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button,
            {
              shape: "circle",
              onClick: onClose,
              icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseCircleOutlined, { style: { fontSize: 20 } }),
              type: "text",
              variant: "filled"
            }
          ) })
        }
      )
    }
  ) : null });
};
const WIDTH_INSPECTOR = 300;
const FieldNumber = ({ field }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Form.Item, { label: field.title, name: field.name, children: /* @__PURE__ */ jsxRuntimeExports.jsx(InputNumber, { disabled: field.isReadonly }) });
};
memo(FieldNumber);
const FieldString = ({ field, entity }) => {
  const rules = [];
  if (field.isRequired) {
    rules.push({
      required: true,
      message: "Please input data!"
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Form.Item, { label: field.title, name: field.name, rules, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { disabled: field.isReadonly && !!entity }) });
};
memo(FieldString);
const FormButtonDelete = ({ model, connectionId }) => {
  const { currentId } = useContext(SmxInspectorContext);
  const [commitDelete, isInFlightDelete] = reactRelayExports.useMutation(model.mutation.delete);
  const { setIsOpen, setIsLoading } = useContext(SmxInspectorContext);
  useEffect(() => {
    setIsLoading == null ? void 0 : setIsLoading(isInFlightDelete);
  }, [isInFlightDelete]);
  const commitModel = () => {
    return {
      variables: {
        id: currentId,
        connections: [connectionId]
      },
      onCompleted: (response, errors) => {
        if (errors) {
          console.log(
            errors[0].extensions.debugMessage,
            errors
          );
        } else {
          setIsOpen == null ? void 0 : setIsOpen(false);
          console.log("Item delete successful", response);
        }
      },
      onError: (error) => {
        console.error("Mutation error:", error);
      }
    };
  };
  const handleClick = async () => {
    if (currentId) {
      commitDelete(commitModel());
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: currentId && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popconfirm,
    {
      title: "Delete the unit",
      description: "Are you sure to delete this unit?",
      onConfirm: handleClick,
      okText: "Yes",
      cancelText: "No",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { icon: /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteOutlined, {}), danger: true, loading: isInFlightDelete, children: "Delete" })
    }
  ) });
};
const FormButtonDelete$1 = memo(FormButtonDelete);
const FormButtonSave = ({ model, data, connectionId, form }) => {
  const { currentId } = useContext(SmxInspectorContext);
  const [commitCreate, isInFlightCreate] = reactRelayExports.useMutation(model.mutation.create);
  const [commitUpdate, isInFlightUpdate] = reactRelayExports.useMutation(model.mutation.update);
  const [api, contextHolder] = notification.useNotification();
  const { setIsOpen, setIsLoading } = useContext(SmxInspectorContext);
  const { validate } = useValidateInspectorForm(form);
  useEffect(() => {
    setIsLoading == null ? void 0 : setIsLoading(isInFlightCreate || isInFlightUpdate);
  }, [isInFlightCreate, isInFlightUpdate]);
  const commitModel = (data2, id) => {
    const optimisticUpdater = (store2) => {
      var _a, _b, _c;
      if (id) {
        const oldModelStore = store2.get(id);
        const fields = Object.keys(data2);
        for (const keyField of fields) {
          let newDataField = data2[keyField];
          if ((_a = model.prepareDataForMutation) == null ? void 0 : _a[keyField]) {
            newDataField = (_c = (_b = model.prepareDataForMutation) == null ? void 0 : _b[keyField]) == null ? void 0 : _c.call(_b, data2[keyField]);
          }
          oldModelStore.setValue(newDataField, keyField);
        }
      }
    };
    const openNotificationWithIcon = () => {
      api["error"]({
        message: "Error",
        description: "Something went wrong"
      });
    };
    const newInput = {
      ...data2
    };
    if (model.prepareDataForMutation) {
      const listFieldName = Object.keys(data2);
      listFieldName.forEach((fieldName) => {
        var _a, _b, _c;
        if ((_a = model.prepareDataForMutation) == null ? void 0 : _a[fieldName]) {
          newInput[fieldName] = (_c = (_b = model.prepareDataForMutation) == null ? void 0 : _b[fieldName]) == null ? void 0 : _c.call(_b, data2[fieldName]);
        }
      });
    }
    return {
      variables: {
        id,
        input: newInput,
        connections: connectionId ? [connectionId] : []
      },
      // optimisticResponse: id ? optimisticUpdateTask : undefined,
      onCompleted: (response, errors) => {
        if (errors) {
          console.log(
            errors[0].extensions.debugMessage,
            errors
          );
        } else {
          setIsOpen == null ? void 0 : setIsOpen(false);
          console.log("Task save successful", response);
        }
      },
      optimisticUpdater: id ? optimisticUpdater : void 0,
      onError: (error) => {
        openNotificationWithIcon();
        console.error("Mutation error:", error);
      }
    };
  };
  const handleClick = async () => {
    if (await validate()) {
      if (currentId) {
        commitUpdate(commitModel({ ...data }, currentId));
      } else {
        commitCreate(commitModel({ ...data }, void 0));
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { onClick: handleClick, icon: /* @__PURE__ */ jsxRuntimeExports.jsx(SaveOutlined, {}), loading: isInFlightCreate, children: [
    contextHolder,
    "Save"
  ] });
};
const FormButtonSave$1 = memo(FormButtonSave);
const FormProcessor = ({ modelName, form, entity }) => {
  var _a, _b, _c, _d, _e;
  const values = Form.useWatch([], { form, preserve: true });
  const { connectionId } = useContext(SmxInspectorContext);
  const model = getModel(modelName);
  useEffect(() => {
    console.log("updates values >>>", values, model);
  }, [values]);
  const getDataToSave = () => {
    var _a2, _b2;
    if (!values) {
      return null;
    }
    const newData = {};
    (_b2 = (_a2 = model.context) == null ? void 0 : _a2.inspectorInput) == null ? void 0 : _b2.forEach((fieldName) => {
      newData[fieldName] = values[fieldName];
    });
    return newData;
  };
  const data = getDataToSave();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flex: 1, gap: 5, justify: "center", children: [
    (_b = (_a = model.action) == null ? void 0 : _a.inspector) == null ? void 0 : _b.map((action, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { children: action({ entity, values, form, connectionId }) }, index)),
    (((_c = model.mutation) == null ? void 0 : _c.create) && data && !entity || ((_d = model.mutation) == null ? void 0 : _d.update) && data && !!entity) && /* @__PURE__ */ jsxRuntimeExports.jsx(FormButtonSave$1, { model, data, connectionId, form }),
    ((_e = model.mutation) == null ? void 0 : _e.delete) && connectionId && /* @__PURE__ */ jsxRuntimeExports.jsx(FormButtonDelete$1, { model, connectionId })
  ] });
};
const FormProcessor$1 = memo(FormProcessor);
const LoaderDefaultDataFormInspector = ({ modelName }) => {
  const form = Form.useFormInstance();
  const model = getModel(modelName);
  useEffect(() => {
    if (!model.defaultData) {
      return;
    }
    const loadData = {};
    Object.keys(model.defaultData).forEach((fieldName) => {
      loadData[fieldName] = model.defaultData[fieldName]();
    });
    form.setFieldsValue({
      ...loadData
    });
  }, [modelName]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
const LoaderDefaultDataFormInspector$1 = memo(LoaderDefaultDataFormInspector);
const LoaderFormInspector = ({ entity, modelName }) => {
  const form = Form.useFormInstance();
  const model = getModel(modelName);
  const dataEntity = useFragmentFromStore(entity.userRef);
  useEffect(() => {
    var _a, _b, _c, _d, _e;
    const data = model.context ? {} : { ...dataEntity };
    if (model.context) {
      (_c = ((_a = model.context) == null ? void 0 : _a.inspectorInputEdit) || ((_b = model.context) == null ? void 0 : _b.inspectorInput)) == null ? void 0 : _c.map((fieldName) => {
        var _a2, _b2;
        data[fieldName] = ((_b2 = (_a2 = model.loaderInspector) == null ? void 0 : _a2[fieldName]) == null ? void 0 : _b2.call(_a2, dataEntity[fieldName])) || dataEntity[fieldName];
      });
      (_e = (_d = model.context) == null ? void 0 : _d.inspectorInputHide) == null ? void 0 : _e.map((fieldName) => {
        var _a2, _b2;
        data[fieldName] = ((_b2 = (_a2 = model.loaderInspector) == null ? void 0 : _a2[fieldName]) == null ? void 0 : _b2.call(_a2, dataEntity[fieldName])) || dataEntity[fieldName];
      });
    }
    form.setFieldsValue(data);
  }, [dataEntity]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
const LoaderFormInspector$1 = memo(LoaderFormInspector);
const LoaderParentDataFormInspector = ({ parentModelName }) => {
  const form = Form.useFormInstance();
  const { parentNode, parentData } = useContext(SmxInspectorContext);
  const dataParentEntity = useFragmentFromStore(parentNode) || parentData;
  const parentModel = parentModelName ? getModel(parentModelName) : null;
  useEffect(() => {
    console.log("_+_+_+_+_+_", parentData);
    const newData = !parentModel ? dataParentEntity : {};
    if (parentModel) {
      Object.keys(parentModel.fieldForChild).forEach((fieldName) => {
        const childFieldName = parentModel.fieldForChild[fieldName];
        newData[childFieldName] = dataParentEntity[fieldName];
      });
    }
    form.setFieldsValue({
      ...newData
    });
  }, [dataParentEntity]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
const LoaderParentDataFormInspector$1 = memo(LoaderParentDataFormInspector);
const FormInspector = ({ modelName, entity }) => {
  var _a, _b, _c;
  const [form] = Form.useForm();
  const { isLoading, currentId, parentNode, parentModelName, filterProject } = useContext(SmxInspectorContext);
  const model = getModel(modelName);
  const currentContext = entity ? ((_a = model.context) == null ? void 0 : _a.inspectorInputEdit) || ((_b = model.context) == null ? void 0 : _b.inspectorInput) : (_c = model.context) == null ? void 0 : _c.inspectorInput;
  const createField = (fieldName) => {
    var _a2, _b2;
    if (!currentId && !(currentContext == null ? void 0 : currentContext.some((subFieldName) => fieldName === subFieldName))) {
      return null;
    }
    const renderFromModel = (_b2 = (_a2 = model.renderData) == null ? void 0 : _a2.inspectorField) == null ? void 0 : _b2[fieldName];
    const field = model.schema.field[fieldName];
    if (renderFromModel) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: renderFromModel({ form, schemaField: field, dataField: entity, parentNode, filterProject }) }, fieldName);
    }
    switch (field.type) {
      case "string":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(FieldString, { field, entity }, fieldName);
      case "integer":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(FieldNumber, { field }, fieldName);
      default:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { message: `Error field type - ${field.type}`, type: "error", showIcon: true }, fieldName);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ConfigProvider,
    {
      theme: {
        components: {
          Form: {
            itemMarginBottom: 10,
            verticalLabelPadding: 0
          }
        }
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { vertical: true, flex: 1, style: { overflowY: "auto" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spin, { spinning: isLoading, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Form, { name: modelName + (entity == null ? void 0 : entity.key), layout: "vertical", form, autoComplete: "off", children: [
          !entity && /* @__PURE__ */ jsxRuntimeExports.jsx(LoaderParentDataFormInspector$1, { parentModelName }),
          !entity && /* @__PURE__ */ jsxRuntimeExports.jsx(LoaderDefaultDataFormInspector$1, { modelName }),
          entity && /* @__PURE__ */ jsxRuntimeExports.jsx(LoaderFormInspector$1, { entity, modelName }),
          currentContext == null ? void 0 : currentContext.map(createField)
        ] }) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { style: { margin: "5px 0" } }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { style: { marginTop: 5 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormProcessor$1, { modelName, form, entity }) })
      ]
    }
  );
};
const FormInspector$1 = memo(FormInspector);
const HeaderInspector = ({ entity, modelName }) => {
  var _a;
  const dispatch = useDispatch();
  const { isOpen, setIsOpen } = useContext(SmxInspectorContext);
  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        if (entity) {
          dispatch(deleteCurrentModel(entity.key));
        } else {
          dispatch(setterInspector({ nameNewEntity: void 0 }));
        }
      }, 500);
    }
  }, [isOpen]);
  const handleClose = () => {
    setIsOpen == null ? void 0 : setIsOpen(false);
  };
  console.log(modelName);
  const label = (!entity ? "New " : "") + ((_a = getModel(modelName)) == null ? void 0 : _a.label);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { align: "center", gap: 10, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleClose, type: "text", variant: "filled", icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseOutlined, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { style: { fontSize: 16, fontWeight: "bold" }, children: label })
  ] });
};
const HeaderInspector$1 = memo(HeaderInspector);
const SimpleDrawer = ({ open, width = 300, children, offsetRight }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inOffsetRight, setInOffsetRight] = useState(offsetRight);
  useEffect(() => {
    if (offsetRight < inOffsetRight) {
      setTimeout(() => {
        setInOffsetRight(inOffsetRight - 15);
      }, 5);
    }
  }, [offsetRight, inOffsetRight]);
  useEffect(() => {
    setIsOpen(open);
  }, [open]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      style: {
        padding: 10,
        position: "fixed",
        top: 0,
        right: inOffsetRight,
        width,
        height: "100vh",
        backgroundColor: "#fff",
        boxShadow: "-2px 0 8px rgba(0, 0, 0, 0.2)",
        transform: isOpen ? `translateX(${0})` : `translateX(${width}px)`,
        transition: "transform 0.3s ease",
        zIndex: 2e3 - inOffsetRight,
        overflowY: "auto"
      },
      vertical: true,
      justify: "space-between",
      children
    }
  );
};
const Inspector = ({ modelName, entity, offsetRight }) => {
  const { isOpen } = useContext(SmxInspectorContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SimpleDrawer, { open: !!isOpen, offsetRight, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { vertical: true, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderInspector$1, { entity, modelName }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { style: { margin: "5px 0" } })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { vertical: true, flex: 1, style: { minHeight: 0 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormInspector$1, { entity, modelName }) })
  ] });
};
const Inspector$1 = memo(Inspector);
const InspectorWrapper = ({ filterProject }) => {
  const environment = reactRelayExports.useRelayEnvironment();
  const currentEntityList = useSelector(
    (state) => state.inspector.currentEntityList
  );
  const storeConnectionId = useSelector(
    (state) => state.model.storeConnectionId
  );
  const nameNewEntity = useSelector(
    (state) => state.inspector.nameNewEntity
  );
  const parentNode = useSelector((state) => state.inspector.parentNode);
  const parentData = useSelector(
    (state) => state.inspector.parentData
  );
  const parentModelName = useSelector(
    (state) => state.inspector.parentModelName
  );
  const offset2 = WIDTH_INSPECTOR * (currentEntityList.length + (nameNewEntity ? 1 : 0));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    nameNewEntity && /* @__PURE__ */ jsxRuntimeExports.jsx(
      InspectorProvider,
      {
        connectionId: storeConnectionId == null ? void 0 : storeConnectionId[nameNewEntity],
        isOpen: true,
        parentNode,
        parentData,
        parentModelName,
        filterProject,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Inspector$1,
          {
            modelName: nameNewEntity,
            offsetRight: WIDTH_INSPECTOR * currentEntityList.length
          },
          nameNewEntity
        )
      }
    ),
    currentEntityList.map((entity, index) => {
      const dataFromStore = environment == null ? void 0 : environment.getStore().getSource().get(entity.key);
      const nameEntity = dataFromStore.__typename.charAt(0).toLowerCase() + dataFromStore.__typename.slice(1);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        InspectorProvider,
        {
          connectionId: storeConnectionId == null ? void 0 : storeConnectionId[nameEntity],
          currentId: entity.key,
          isOpen: true,
          filterProject,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Inspector$1,
            {
              modelName: nameEntity,
              entity,
              offsetRight: WIDTH_INSPECTOR * (index + (nameNewEntity ? 1 : 0))
            }
          )
        },
        entity == null ? void 0 : entity.key
      );
    }),
    offset2 > WIDTH_INSPECTOR && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonCloseAllInspector, { offsetRight: offset2 })
  ] });
};
export {
  DrawingSetListPage,
  DrawingSetPage,
  InspectorWrapper,
  Logo,
  getFragment,
  getModel,
  isDrawingsRelayOperation,
  registerModel,
  registerStoreFragments,
  store,
  storeDrawingsFragments,
  storeDrawingsModel
};
//# sourceMappingURL=index.js.map
